import pageText from './en-US/pageText';
import live from './live/en-US';
import timezone from './en-US/timezone';
import analysis from './en-US/analysis';
import activity from './en-US/activity';
import leaderboardActivity from './en-US/leaderboardActivity';
import vip from './en-US/vip';
import commonSelect from './en-US/commonSelect';
import game from './en-US/game';
import agent from './en-US/agent';
import luckySpin from './en-US/luckySpin';
import webConfig from './en-US/webConfig';
import adsAgent from './en-US/adsAgent';
import adsMccAccount from './en-US/adsMccAccount';
import adsAccount from './en-US/adsAccount';
import adsReport from './en-US/adsReport';
import adsUserPushRecord from './en-US/adsUserPushRecord';
import autoPushRecord from './en-US/autoPushRecord';
import autoPushConfig from './en-US/autoPushConfig';
import autoPushStats from './en-US/autoPushStats';
import manualPushRecord from './en-US/manualPushRecord';
import smsReport from './en-US/smsReport';
import smsChannels from './en-US/smsChannels';
import smsTemplates from './en-US/smsTemplates';
import smsLogs from './en-US/smsLogs';
import smsTasks from './en-US/smsTasks';
import inbox from './en-US/inbox';
import riskControl from './en-US/riskControl';
import news from './en-US/news';
import riskDimension from './en-US/riskDimension';
import manualTag from './en-US/manualTag';
import autoTag from './en-US/autoTag';
import auditReport from './en-US/auditReport';
import seoPlatform from './en-US/seoPlatform.js';
import aiModelConfig from './en-US/aiModelConfig.js';

export default {
  ...pageText,
  // Country configuration
  countries: {
    PH: 'PH - Philippines',
    VN: 'VN - Vietnam',
    TH: 'TH - Thailand',
    CN: 'CN - China'
  },

  smsChannels,
  smsTemplates,
  smsLogs,
  smsTasks,
  inbox,
  riskControl,
  news,
  ...riskDimension,
  ...manualTag,
  autoTag,
  ...auditReport,
  ...live,
  ...analysis,
  ...activity,
  ...leaderboardActivity,
  ...vip,
  ...commonSelect,
  ...agent,
  ...webConfig,
  ...adsAgent,
  ...adsMccAccount,
  ...adsAccount,
  ...adsReport,
  ...adsUserPushRecord,
  autoPushRecord,
  ...smsReport,
  autoPushConfig,
  autoPushStats,
  manualPushRecord,
  game,
  ...luckySpin,
  seoPlatform,
  aiModelConfig,
  timezone,
    'common.requestFailed': 'Request failed',
    'common.required': 'Required',

  // Login Page
  'login.language': 'Language',
  'login.account': 'Account',
  'login.accountRequired': 'Account cannot be empty',
  'login.accountPlaceholder': 'Please enter account',
  'login.password': 'Password',
  'login.passwordRequired': 'Password cannot be empty!',
  'login.passwordPlaceholder': 'Please enter password',
  'login.googleAuthCode': 'Google Auth Code',
  'login.googleAuthPlaceholder': 'Please enter Google verification code',
  'login.loginButton': 'Login',
  'login.bindGoogleAuth': 'Please bind Google authenticator and then click login again',
  'login.googleAuthMessage': 'Please bind Google authenticator before logging in',
  'login.close': 'Close',
  'login.loading': 'Loading...',

  // IP Whitelist Error
  'ipWhitelist.error.title': '404',
  'ipWhitelist.error.subTitle': 'Your IP address is not whitelisted, please contact the administrator',

  // Left Menu Management
  'indexLtMenu.tab.top': 'Top Menu',
  'indexLtMenu.tab.middle': 'Middle Menu',
  'indexLtMenu.tab.bottom': 'Bottom Menu',
  'indexLtMenu.tab.member': 'Member Menu',
  'indexLtMenu.tab.preferential': 'Discount menu',
  'indexLtMenu.menuName': 'Menu Name',
  'indexLtMenu.menuIcon': 'Icon',
  'indexLtMenu.ltMenuArea': 'Menu Type',
  'indexLtMenu.menuOrder': 'Order',
  'indexLtMenu.language': 'Language',
  'indexLtMenu.menuLink': 'Link/Code',
  'indexLtMenu.ltMenuStatus': 'Status',
  'indexLtMenu.menuNote': 'Note',
  'indexLtMenu.menuSection': 'Menu Section',
  'indexLtMenu.languageSettings': 'Language Settings',

  // Bottom Menu Management
  'indexBotMenu.menuName': 'Navigation name',
  'indexBotMenu.menuIcon': 'Menu Icon',
  'indexBotMenu.menuHighlightIcon': 'Highlight Menu Icon',
  'indexBotMenu.menuCode': 'Menu Code',
  'indexBotMenu.menuOrder': 'Order',
  'indexBotMenu.language': 'Language',
  'indexBotMenu.menuLink': 'Page link',
  'indexBotMenu.isEnable': 'Status',
  'indexBotMenu.h5Icon': 'H5 Icon',
  'indexBotMenu.pcIcon': 'PC Icon',
  'indexBotMenu.appIcon': 'APP Icon',

  'mlm.promote.userInviteInfoReport': 'Invitation achievement report.xls',
  'mlm.promote.rebate.level': 'Rebate level',
  'mlm.promote.gameType_1': 'Electronic rebate',
  'mlm.promote.gameType_2': 'Real-person rebate',
  'mlm.promote.gameType_3': 'Sports rebate',
  'mlm.promote.gameType_4': 'Lottery rebate',
  'mlm.promote.gameType_5': 'Fishing rebate',
  'mlm.promote.gameType_6': 'chess rebate',
  'mlm.promote.gameType_9': 'Better betting rebate',
  'mlm.promote.gameType_10': 'E-sports rebate',
  'mlm.promote.edit': 'Edit',
  'mlm.promote.edit_cancel': 'Cancel',
  'mlm.promote.save': 'Save',
  'mlm.promote.operation': 'Operation',
  'mlm.promote.inviteNotOpen': 'The invitation achievement is not opened',
  'mlm.promote.isRebateOpen': 'Whether to enable betting rebate',
  'mlm.promote.rebateRatioLimit': 'The rebate ratio cannot exceed {rebateRatioLimit}',
  'mlm.promote.digital': 'A number with up to two decimal places',
  'mlm.promote.start': 'From the start date',
  'mlm.promote.end': 'Start statistics',

  'mlm.promote.invited.isOpen': 'Whether to enable invitee rewards',
  'mlm.promote.invited.amount': 'The amount of bonus each invitee can receive',
  'mlm.promote.invited.betflow': 'betflow multiple',
  'mlm.promote.invited.domain': 'Invited domain name',
  'mlm.promote.invited.domainMsg': 'The format is comma separated domain names',
  'mlm.promote.bonus.invite': 'Invite rewards for everyone, {date}',
  'mlm.promote.bonus.rebate': 'Rebate rewards for everyone, {date}',
  'mlm.promote.bonus.domain': 'Invitation rewards for designated domain names for everyone, {date}',
  'mlm.promote.bonus.point': 'Reward points for everyones invitation,{0}',
  'mlm.promote.rebateReprot.title1': 'serial number',
  'mlm.promote.rebateReprot.title2': 'username',
  'mlm.promote.rebateReprot.title3': 'Agent Level',
  'mlm.promote.rebateReprot.title4': 'Issuance date',
  'mlm.promote.rebateReprot.title5': 'Total rebate',
  'mlm.promote.rebateReprot.view': 'View details',
  'mlm.promote.rebateReprot.inviteUserAccount': 'inviter username',
  'mlm.promote.rebateReprot.Excel': 'Friends rebate report.xls',
  'mlm.promote.rebateReprot.totalSum': 'Invitee rewards have been issued: {count} pen, {sum} yuan',

  'mlm.promote.rebateReprotDetail.title1': 'serial number',
  'mlm.promote.rebateReprotDetail.title2': 'Invitee username',
  'mlm.promote.rebateReprotDetail.title3': 'Agent Level',
  'mlm.promote.rebateReprotDetail.title4': 'Superior Agent',
  'mlm.promote.rebateReprotDetail.title5': 'Rebate level',
  'mlm.promote.rebateReprotDetail.title6': 'Statistical date',
  'mlm.promote.rebateReprotDetail.title7': 'Total rebate',
  'mlm.promote.rebateReprotDetail.suffix': 'Reflow/Reprot',

  'mlm.promote.inviteeReprot.title1': 'serial number',
  'mlm.promote.inviteeReprot.title2': 'Invitee username',
  'mlm.promote.inviteeReprot.title3': 'Invitee reward amount',
  'mlm.promote.inviteeReprot.title4': 'Turnover multiple',
  'mlm.promote.inviteeReprot.title5': 'Distribution status',
  'mlm.promote.inviteeReprot.title6': 'Invite domain name',
  'mlm.promote.inviteeReprot.title7': 'Inviter username',
  'mlm.promote.inviteeReprot.Excel': 'Invite Reward Report.xls',

  'mlm.promote.inviteeReprotDetail.title1': 'Invitee username',
  'mlm.promote.inviteeReprotDetail.title2': 'Registration time',
  'mlm.promote.inviteeReprotDetail.title3': 'Accumulated deposits',
  'mlm.promote.inviteeReprotDetail.title4': 'Status',
  'mlm.promote.inviteeReprotDetail.title5': 'Accumulated effective turnover',
  'mlm.promote.inviteeReprotDetail.title6': 'Whether to become a valid member',
  'mlm.promote.inviteeReprotDetail.title7': 'Is it the same as the device IP',
  'mlm.promote.inviteeReprotDetail.title8': 'Completion time',
  'mlm.report.finishDomainStatus51': 'In progress',
  'mlm.report.finishDomainStatus52': 'Completed',

  'mlm.report.title1': 'Discount distribution report',
  'mlm.report.title2': 'Invitation Achievement Report',
  'mlm.report.title3': 'Friends cheating report',
  'mlm.report.title4': 'Invitee reward report',

  'mlm.report.agent': 'MLM Agent',
  'mlm.report.agentLevel1': 'Level 1 agent',
  'mlm.report.agentLevel2': 'Second level agent',
  'mlm.report.agentLevel3': 'Level 3 agent',
  'mlm.report.agentLevel4': 'Level 4 agent',
  'mlm.report.agentLevel5': 'Level 5 agent',
  'mlm.report.agentLevel6': 'Level 6 agent',
  'mlm.report.finishDepositStatus21': 'In progress',
  'mlm.report.finishDepositStatus22': 'Completed',
  'mlm.promote.title1': 'Invitation achievement settings',
  'mlm.promote.title2': 'Betting rebate settings',
  'mlm.promote.title3': 'Other settings',

  'menu.live': 'Live Room Management',
  'menu.room': 'Live Room List',
  'menu.audit': 'Live Room Audit',
  'menu.gift': 'Gift Management',
  'menu.giftItem': 'Gift List',
  'menu.instruction': 'Live Room Announcement List',
  'menu.livePlatform': 'Live Platform Management',
  'menu.region': 'Live Region Management',
  'menu.filterWord': 'Filter Word Management',
  'menu.hotWeight': 'Hot Weight Management',

  'avatar.changePassword': 'Change Password',
  'avatar.oldPassword': 'Old Password',
  'avatar.oldPasswordPlaceholder': 'Old Password',
  'avatar.newPassword': 'New Password',
  'avatar.newPasswordPlaceholder': 'New Password',
  'avatar.confirmPassword': 'Confirm New Password',
  'avatar.confirmPasswordPlaceholder': 'Confirm Password Again',
  'avatar.passwordMismatch': 'New password and confirm password do not match',
  'avatar.changePasswordSuccess': 'Success! Please login again!',
  'avatar.oldPasswordRequired': 'Please enter old password',
  'avatar.newPasswordRequired': 'Please enter new password',
  'avatar.confirmPasswordRequired': 'Please enter confirm password',

  'sys.copySuccess': 'Copy success',
  'sys.game': 'Little game',
  'sys.eventName': 'Activity name',
  'sys.enterEventName': 'Please enter the activity name',
  'sys.date.type': 'Time type',
  'sys.permanent': 'Permanent validity',
  'sys.validit.period': 'Term of validity',
  'sys.added.prize': 'Prize added',
  'sys.noAdded.prize1': 'No prizes have been added yet',
  'sys.added.prize2': 'Add prizes',
  'sys.open': 'On',
  'sys.close': 'Off',
  'sys.cashReward': 'Cash award',
  'sys.pointReward': 'Point reward',
  'sys.physicalReward': 'Material reward',
  'sys.select.prize': 'Optional rewards',
  'sys.select.prizeType': 'Please select award type',
  'sys.noAdded.prize': 'No prize added yet',
  'sys.activities': 'Activity content',
  'sys.fillActivities': 'Activity content',
  'sys.copyImageLink': 'Copy picture link',
  'sys.imageLink': 'pictures linking',
  'sys.addOffer': 'Add offers',
  'sys.offer': 'Preferential content',
  'sys.enterOffer': 'Please fill in the offer',
  'sys.prizeName': 'Name of prize',
  'sys.enterPrizeName': 'Please enter the prize name',
  'sys.prizeType': 'Types of prizes',
  'sys.prizeType.desc': 'Prize type: cash chip | amount: {prizeAmount} | flow multiple: {betMultiple}',
  'sys.prizeType.desc1': 'Prize type: other',
  'sys.prizeType.desc2': '|Prize probability: {probability}%',
  'sys.prizeType.desc3': '|Prize order: {sort}',
  'sys.prizeType.desc4': '|Prize details: {prizeDetail}',
  'sys.prizeType.desc5': 'Prize Name: {prizeName}',
  'sys.ropeType.descInfo': 'Rope type：{configRopeType} |amount：{configPrizeAmount} |flow multiple：{betMultiple} |Cumulative betting：{accumulationBetAmount} |Synthetic rope type：{syntheticRopeType} |Number of synthetic rope：{syntheticQuantity} |Order of prizes：{sort} |Prize details：{configDetail}',
  'sys.prizeList': 'List of prizes',
  'sys.prizeAmount': 'Prize amount',
  'sys.probability': 'Probability',
  'sys.confirmCancel': 'Confirm cancel',
  'sys.content': 'Do you want to disqualify the member {userAccount} from this {activityGameType} lottery?',
  'sys.activity.type': 'Activity type',
  'sys.prize': 'Prize',
  'sys.unspecifiedPrize': 'No prize specified',
  'sys.notIssued': 'Unissued',
  'sys.obsolete': 'To void',
  'sys.upload': 'upload',
  'sys.upload.fail1': 'File upload failed, please delete and upload again',
  'sys.upload.picture1': 'Upload pictures',
  'sys.upload.imageMaterial': 'Picture material upload',
  'sys.upload.activityPicture': 'Upload activity picture',
  'sys.pc.activityPicture': 'PC activity picture',
  'sys.h5.activityPicture': 'Mobile activity picture',
  'sys.uploadPC.activityPicture': 'Please upload PC activity picture',
  'sys.uploadH5.activityPicture': 'Please upload the mobile activity picture',
  'sys.lengthLimit1': 'Enter up to 300 characters',
  'sys.lengthLimit2': 'Enter up to 250 characters',
  'sys.giftCash2': 'Free cash',
  'sys.giftCash1': 'Free cash (%)',
  'sys.maxBonusAmount': 'Maximum bonus',
  'sys.enterPrizeType': 'Please enter the prize type',
  'sys.discountCash': 'Preferential cash',
  'sys.giftCash': 'Free cash (yuan)',
  'sys.giftCashVN': 'Free cash (VND)',
  'sys.enterAmountPrize': 'Please enter the amount of the prize',
  'sys.flowMultiple': 'Flow multiple',
  'sys.flowMultiple2': 'Flow multiple',
  'sys.enterFlowMultiple': 'Please enter flow multiple',
  'sys.typeData': 'Please enter a number of 0-100',
  'sys.enterSort': 'Please enter sort',
  'sys.winningProbability': 'Winning probability',
  'sys.enterNumber': 'please enter a number',
  'sys.prizeDetails': 'Prize details',
  'sys.enterPrizeDetails': 'Please enter the prize details',
  'sys.rules.number': 'Enter up to 100 characters',
  'sys.prizePicture': 'Prize pictures',
  'sys.upload.prizePicture': 'Please upload the prize picture',
  'sys.pc.prizePicture': 'Prize picture of mobile terminal',
  'sys.editOffer': 'Modify offer content',
  'sys.addPrize.submit': 'Please add prizes before submitting!',
  'sys.add.success': 'Added successfully!',
  'common.requestfail': 'Request failed, please try again!',
  'sys.drawTime': 'Lucky draw time',
  'sys.setPrizes': 'Setting up prizes',
  'sys.disqualification': 'Disqualification',
  'sys.addLottery': 'Add lottery times',
  'sys.allType': 'All types',
  'sys.allState': 'All States',
  'sys.addNumberDrawsWrong': 'Error in adding lottery times, please try again later!',
  'sys.smallGameType': 'Small game type',
  'sys.selectSmallGameType': 'Please select a small game type',
  'sys.frequency': 'frequency',
  'sys.enterNumberDraws': 'Please enter the number of draw times',
  'sys.failedLoadPrizes': 'Failed to load prize, please try again later!',
  'sys.selectPrize': 'Please choose a prize',
  'sys.title.deleteBeforeDisable1': 'In order to prevent errors, please disable the games first and then delete them!',
  'sys.title.deleteGame': 'Games to be deleted: {activityName} after deletion, the number of times that no lottery has been conducted by all users about the game will also be deleted. Please confirm',
  'common.title.createAdmin1': 'Created by / at',
  'common.title.createAdmin2': 'Created by / at',
  'sys.expireDate': 'Expiration date',
  'sys.viewPrize': 'View prizes',
  'constants.activityType_11': '1. Lucky wheel',
  'constants.activityType_22': '2. shake.',
  'sys.addSmallGame': 'New games',
  'bet.select.gameType1': 'Choose game type',
  'sys.cancel': 'Cancel',
  'sys.submit': 'submit',
  'sys.totalNumberTime': 'Total number',
  'user.memberAccount': 'Membership account',
  'user.memberAccount1': 'Member account number:',
  'user.checkinTime': 'Check-in time',
  'sys.time': 'Payment time',
  'sys.receivePoints': 'Receive points',
  'sys.receiveState': 'Receiving status',
  'sys.receivePrize': 'Receive prizes',
  'sys.rewardType': 'Reward type',
  'sys.reward': 'reward',
  'sys.processing': 'Have in hand',
  'sys.whetherAdditionalRewards': 'Additional reward or not',
  'sys.confirmor': 'Confirming person',
  'sys.other': 'Other',
  'sys.integral': 'integral',
  'sys.no': 'no',
  'sys.yes': 'yes',
  'sys.chooseCheckInTime': 'Select check in time',
  'sys.confirmAward': 'Confirm award distribution',
  'sys.confirmWhetherRewardIssued': 'Please confirm whether the reward is issued',
  'finance.title.remark2': 'Remark',
  'sys.pickUpTime': 'Time to collect',
  'sys.choosePickUpTime': 'Select pick up time',
  'sys.receiveAward': 'Receive awards',
  'sys.usePoints': 'Using integral',
  'sys.grade': 'Grade',
  'sys.enterGrade': 'Please enter level',
  'sys.cumulativeBetAmount': 'Cumulative bets',
  'sys.cumulativeBetAmount1': 'Cumulative upgrade bonus',
  'sys.cumulativeBetAmount2': 'Accumulated weekly salary and bonus',
  'sys.cumulativeBetAmount3': 'Accumulated monthly salary and bonus',
  'sys.cumulativeBetAmount4': 'Accumulated salary and bonus',
  'sys.cumulativeBetAmount5': 'Weekly salary bonus',
  'sys.cumulativeBetAmount6': 'Monthly salary and bonus',
  'sys.cumulativeBetAmount7': 'Salary bonus',
  'sys.updateTime': 'Update time',
  'sys.upgradeUser.name': 'Upgrade member record list.xls',
  'sys.offerName': 'Preferential name',
  'sys.enterOfferName': 'Please enter the name of the offer',
  'sys.offerName1': 'Offer Name:',
  'sys.offerName2': 'Offer name, user name',
  'sys.offerName3': 'Offer name / user name',
  'sys.default.sort': 'Default sort',
  'sys.rank.ascending': 'Rank ascending order',
  'sys.rank.descending': 'Rank descending order',
  'sys.all.offers': 'Full discount',
  'sys.title.delete': 'About to delete: {bonusName}',
  'sys.mutuallyExclusiveOffer': 'Exclusive offers',
  'sys.addMutuallyExclusiveOffer': 'Add exclusive offer',
  'sys.addMutuallyExclusiveOfferGroup': 'Add exclusive offer group',
  'sys.alreadyCollectionRule': 'The claim rule already exists',
  'sys.rule.name': 'Rule name:',
  'sys.rule.name1': 'Rule name',
  'sys.enterRule.name': 'Please enter a rule name',
  'sys.collectionRule.description': 'Claim rule description',
  'sys.addCollectionRule': 'Add claim rule',
  'sys.deleteRule': 'About to delete the picking rule: {groupCode}',
  'sys.confirmDisabled': 'Confirm disabled',
  'sys.confirmDisabled1': 'About to disable: {groupName}',
  'sys.confirmEnable': 'Confirm enabled',
  'sys.confirmEnable1': 'About to enable: {groupName}',
  'sys.changeSetting': 'Modify configuration',
  'sys.management': 'Administration',
  'sys.next': 'Next step',
  'sys.addSpecialOffer': 'New offers',
  'sys.addSpecial': 'New offer',
  'sys.enterNameOfferArticle': 'Please enter the name of the offer article',
  'sys.nameOfferArticle': 'Article name',
  'sys.addOfferArticle': 'New articles',
  'sys.category': 'Classification',
  'sys.selectCategory': 'Please select the category',
  'sys.displayOrder': 'Display order',
  'sys.enterDisplayOrder': 'Please enter the display order',
  'sys.selectPlatformType': 'Select platform type',
  'sys.platformType': 'Platform type',
  'sys.enterPlatformType': 'Please enter platform type',
  'sys.selectPlatformType1': 'Please select the applicable platform',
  'sys.selectApplicationConditions': 'Please fill in the application conditions',
  'sys.computerSideAdvertisingImage': 'Computer advertising picture',
  'sys.uploadComputerImage': 'Please upload the computer pictures',
  'sys.mobileImage': 'Mobile advertising picture',
  'sys.uploadMobileImage': 'Please upload mobile pictures',
  'sys.associatedActivity': 'Related activities',
  'sys.selectOfferWantLink': 'Please select the offer you want to associate',
  'sys.addFail': 'Add failure',
  'sys.addError': 'Add error',
  'sys.newClassification': 'New classification',
  'sys.categoryName': 'Classification name',
  'sys.fillCategoryName': 'Please fill in the classification name',
  'sys.deleteOffer': 'Offers to be removed: {bonusName}',
  'sys.confirmCopy': 'Confirm replication',
  'sys.confirmCopy1': 'Are you sure to copy this offer?',
  'sys.promptMessage': 'Prompt information',
  'sys.disableDelete': 'Please disable before deleting.',
  'sys.confirmDelete': 'Are you sure to delete this offer?',
  'sys.confirm1': 'Are you sure you want to cancel this offer?',
  'sys.effectiveTime': 'Effective time',
  'sys.startTime': 'Start time:',
  'sys.startTime1': 'start time',
  'sys.endTime': 'End time:',
  'sys.endTime1': 'End time',
  'sys.associationSettings': 'Relational settings',
  'sys.cancelRecommend': 'Cancel recommendation',
  'sys.copy': 'copy',
  'sys.modifySort': 'Modify sort',
  'sys.editCopy': 'Editing copy',
  'sys.platform': 'platform',
  'sys.computer': 'Computer',
  'sys.mobile': 'move',
  'sys.editCategory': 'Editing classification',
  'sys.name': 'Name:',
  'pay.title.sort1': 'Sort:',
  'sys.recommendSignature': 'Recommended label:',
  'sys.recommendedDisplayImageUpload': 'Recommended display image upload',
  'sys.recommendedDisplayImage': 'Recommended display pictures',
  'sys.uploadImage': 'Please upload the picture',
  'sys.collectionMethod': 'Way of receiving',
  'sys.seletCollectionMethod': 'Please select the collection method',
  'sys.automaticDistribution': 'Automatic dispatching',
  'sys.manually': 'Manual collection',
  'sys.flowMultipleCalculationAmount': 'Daily multiple calculation amount',
  'sys.selectFlowMultipleCalculationAmount': 'Please select daily multiple to calculate amount',
  'sys.returnAmount': 'Amount of return water',
  'sys.withdrawalRestrictions': 'Withdrawal restriction',
  'sys.enterWithdrawalRestrictions': 'Please enter withdrawal limit',
  'sys.doubleWaterWithdrawDiscount': 'Double flow can withdraw the discount',
  'sys.platformPointSettings': 'Platform and points setting',
  'sys.chooseGamePlatform': 'Choose a game platform',
  'sys.returnPoint': 'Return water points',
  'sys.lowest': 'minimum',
  'sys.highest': 'minimum',
  'sys.yuan': 'element',
  'sys.yuanVN': 'VND',
  'sys.yuanPHP': 'PHP',
  'sys.yuan1': 'Yuan,',
  'sys.validBetReached': 'Valid bet reached',
  'sys.storageReach': 'Storage reach',
  'sys.howManyGetDraw': 'How many can get a chance to draw',
  'sys.onThatDay': 'On that day',
  'sys.twoDays': 'Two days',
  'sys.activityPeriod': 'Activity period',
  'sys.runningWaterAmount': 'Amount of running water',
  'sys.platformConditionSettings': 'Platform and condition setting',
  'sys.selectGamePlatform': 'Select game platform by type',
  'sys.addedOffers': 'Added offers',
  'sys.NoSpecialOffersYet': 'No offers have been added yet',
  'sys.selectGiftType': 'Please select a gift type',
  'sys.betAmount': 'Bet amount (including)',
  'sys.betAmount1': 'Maximum bet (excl.)',
  'sys.betAmount2': 'Please enter the maximum bet amount',
  'sys.betAmount3': 'Betting amount',
  'sys.enterMinimumAmount': 'Please enter the minimum amount',
  'sys.cashGiftForm': 'Form of cash gift',
  'sys.selectCashGiftForm': 'Please choose the form of cash gift',
  'sys.giveCashFixedAmount': 'Cash as a fixed amount',
  'sys.giveCashFixedAmount1': 'Cash in fixed proportion',
  'sys.numberGifts': 'Frequency of presentation',
  'sys.enterNumberGifts': 'Please enter the number of gifts',
  'sys.enterAmountCashGiven': 'Please enter the amount of cash presented',
  'sys.enterAmountCashGiven1': 'Please enter the maximum amount of free cash',
  'sys.enterProportionCashGiven': 'Please enter the proportion of free cash',
  'sys.enterProportionmaxBonusAmount': 'Please enter the proportion of max amount',
  'sys.noMoreThan': 'Up to (yuan)',
  'sys.noMoreThanVN': 'Up to (VND)',
  'sys.noMoreThan1': 'No more than (points)',
  'sys.basicInformationOffer': 'Basic information of the offer',
  'sys.relatedArticles': 'Related articles',
  'sys.selectOfferArticleWantLink': 'Please select the article you want to associate with',
  'sys.pc.sideOfferPicture': 'PC side discount picture',
  'sys.uploadPc.sideOfferPicture': 'Please upload PC picture',
  'sys.mobile.sideOfferPicture': 'Mobile benefits picture',
  'sys.mobile.accountAuthentication': 'Account authentication',
  'sys.mobile.phoneAuthentication': 'Mobile phone authentication',
  'sys.mobile.emailAuthentication': 'Mailbox authentication',
  'sys.bindingBankCard': 'Bind bank card',
  'sys.setPreferentialConditions': 'Set up preferential terms',
  'sys.selectLogType_platform': 'Please select a game platform',
  'sys.noteType': 'Note type',
  'sys.noteNumber': 'Note number',
  'sys.selectDuplicateRequestLimit': 'Please select a repeat request limit',
  'sys.duplicateRequestLimit': 'Restrictions on repeated applications',
  'sys.payoutAmount': 'Lottery amount',
  'sys.profitAmount': 'Amount of profit',
  'sys.onlyOnce': 'Only once',
  'sys.everyDay': 'Daily',
  'sys.weekly': 'weekly',
  'sys.perMonth': 'monthly',
  'sys.perYear': 'annually',
  'sys.maximumNumberApplications': 'Maximum number of applications',
  'sys.enterMaximumNumberOffers': 'Please enter the maximum number of times to apply for the discount',
  'sys.expirationTimeType': 'Expiration time type',
  'sys.enterExpirationTimeType': 'Please select expiration time type',
  'sys.day': 'day',
  'sys.noteExpirationTime': 'Note expiration time',
  'sys.enterBillingExpirationTime': 'Please enter the expiration time of the note',
  'sys.withdrawalConditions': 'Withdrawal conditions',
  'sys.selectWithdrawalCondition': 'Please select the withdrawal conditions',
  'sys.directWithdrawal': 'Direct withdrawals',
  'sys.flowRequirement': 'Flow requirements',
  'sys.enterFlowRequirement': 'Please input the current multiple of preferential withdrawal',
  'sys.setBetRequirements': 'Set note requirements',
  'sys.addWinningConditions': 'Add winning conditions',
  'sys.winningConditions': 'Winning conditions (including)',
  'sys.enterWinningCondition': 'Winning conditions (including)',
  'sys.offerMethod': 'Preferential way',
  'sys.noteBetAmountMultiple': 'Multiple of note amount',
  'sys.noteBetAmountMultiple1': 'Multiple of single lottery amount',
  'sys.noteBetAmountMultiple2': 'Note single profit amount multiple',
  'sys.giftPoints': 'Bonus points (points)',
  'sys.giftPoints1': 'Bonus points (%)',
  'sys.giftPoints2': 'Presentation points',
  'sys.giftPoints3': '|Bonus points: {giftPoint} points',
  'sys.giftPoints4': '|Bonus points: {pointPercent}% (no more than {maxPoint})',
  'sys.enterGiftPoints2': 'Please enter points',
  'sys.enterNumberBonusPoints': 'Please enter the number of bonus points',
  'sys.preferentialAmountBenchmarkRate': 'Benchmark rate of preferential amount',
  'sys.enterPreferentialAmountBenchmarkRate': 'Please enter the benchmark rate of preferential amount',
  'sys.enterPreferentialAmountBenchmarkRate1': 'Please enter the discount amount',
  'sys.maximumDiscountAmountLimit': 'Maximum preferential amount limit',
  'sys.enterMaximumDiscountAmountLimit': 'Please enter the maximum preferential amount limit',
  'sys.integralBenchmarkMagnification': 'Integral reference multiple',
  'sys.integralBenchmarkMagnification1': 'Integral reference multiple',
  'sys.maximumPointLimit': 'Maximum points limit',
  'sys.enterMaximumPointLimit': 'Please enter the maximum point limit',
  'sys.memberInformationBindingOffer': 'Member information binding offer',
  'sys.binding': 'Binding information',
  'sys.binding1': 'Binding type',
  'sys.binding2': 'Please select binding type',
  'sys.phoneNumber': 'Cell-phone number',
  'sys.pequiredDepositAmount': 'Required deposit amount',
  'sys.pequiredDepositAmount1': 'Please enter the required deposit amount',
  'sys.giftAmount': 'Donation amount',
  'sys.giftAmount1': 'Please enter the gift amount',
  'sys.maximumAmountAvailable': 'Maximum withdrawable amount',
  'sys.maximumAmountAvailable1': 'Please raise the maximum amount',
  'sys.continuousDeposit': 'Preferential settings for continuous deposit and bet (automatically issued from 4:00-4:30 am the next day)',
  'sys.newContinuousDeposit': 'Preferential settings for continuous deposit and bet',
  'sys.depositRequestAmount': 'Required amount of deposit',
  'sys.depositRequestAmount1': 'Running amount',
  'sys.consecutiveDays': 'Consecutive days',
  'sys.cumulativeDays': 'Cumulative days',
  'sys.selectType': 'Please select the type',
  'sys.continuous': 'continuity',
  'sys.cumulative': 'cumulative',
  'sys.enterNumberDays': 'Please enter the number of days',
  'sys.enterCumulativeDays': 'Please enter the accumulated days',
  'sys.enterAmount': 'Please enter the amount',
  'sys.userEffectiveFlowRequirements': 'User effective flow requirements',
  'sys.enterFlowRequirement1': 'Please input flow requirements',
  'sys.continuousDepositBonusSetting': 'Continuous deposit reward settings',
  'sys.cumulativeDepositBettingBonusSettings': 'Cumulative deposit betting bonus settings',
  'sys.di': 'The first',
  'sys.song': 'give',
  'sys.bei': 'times',
  'sys.wu': 'nothing',
  'sys.you': 'Yes',
  'sys.extraBonus': 'Is there any extra reward',
  'sys.extraDelivery': 'Extra delivery',
  'sys.addedOffer': 'Offer added',
  'sys.msg1': 'No need to apply for automatic dispatch at 04:00 am the next day',
  'sys.applicationConditions': 'Application conditions',
  'sys.selectCategory1': 'Please select the category',
  'sys.category1': 'Category of ownership',
  'sys.selectDepositChannel': 'Please select a deposit channel',
  'sys.depositChannel': 'Deposit channel',
  'sys.msg2': 'Maximum deposit amount must be greater than minimum deposit amount',
  'sys.msg3': 'Minimum deposit (including)',
  'sys.msg4': 'Please enter the minimum deposit amount',
  'sys.msg5': 'Maximum deposit (excluding)',
  'sys.msg6': 'Please enter the maximum deposit amount',
  'sys.msg7': 'Cash presented in fixed deposit range',
  'sys.pre-purchaseOffer': 'Pre offer - withdrawal conditions',
  'sys.pre-purchaseOffer1': 'Pre discount',
  'sys.postOffer': 'Post offer - claim conditions',
  'sys.postOffer1': 'Post concession',
  'sys.minusDiscount': 'Subtract concessions',
  'sys.accountType': 'Account type',
  'sys.accountType1': 'Please select account type',
  'sys.masterAccount': 'Main account',
  'sys.gameAccount': 'Game accounts',
  'sys.gameAccountType': 'Game account type',
  'sys.majorClass': 'Large class',
  'sys.account': 'account',
  'sys.enterAccount1': 'Please select a deposit account',
  'sys.depositOrder': 'Order of deposits',
  'sys.enterDepositOrder': 'Please select deposit order',
  'sys.nthDeposit': 'Nth deposit',
  'sys.nthDeposit1': 'Non first n deposits',
  'sys.nthDeposit2': 'All deposits',
  'sys.nthDeposit3': 'Fill in the value of n',
  'sys.nthDeposits': 'Nth deposit',
  'sys.greaterNthDeposit': 'Greater than the nth deposit',
  'sys.enterNumberDepositLimits': 'Please enter the number of deposit restrictions',
  'sys.flowType': 'Flow type',
  'sys.selectypeFlow': 'Flow type',
  'sys.msg8': 'Set pipeline multiple globally',
  'sys.msg9': 'Set flow multiple for single preferential content',
  'sys.msg10': 'The offer has been added (changing the flow type will cancel all offers. If it has been edited, it needs to be edited again. )',
  'sys.receivingValidityPeriod': 'Period of validity',
  'sys.enterExpirationDate': 'Please enter the period of validity',
  'sys.pointGiftForm': 'Bonus form',
  'sys.selectPointGiftForm': 'Please choose the form of bonus',
  'sys.givePointsFixedAmount': 'Bonus points in fixed quantity',
  'sys.givePointsFixedAmount1': 'Bonus points in fixed proportion',
  'sys.enterProportionBonusPoints': 'Please input the proportion of bonus points',
  'sys.enterMaximumCreditLimit': 'Please input the proportion of bonus points',
  'sys.msg11': 'Real time: deposit together with the payment',
  'sys.uploadH5Image': 'Please upload H5 picture',
  'sys.msg12': 'Mobile end size: 718 * 158px',
  'sys.check-inPointSetting': 'Sign in point settings',
  'sys.check-inDaysSetting': 'Check in days setting',
  'sys.check-in': 'Sign in',
  'sys.check-in1': 'Check-in',
  'sys.msg13': 'Fixed days extra bonus settings',
  'sys.doubleWater': 'Double water can be lifted',
  'sys.pointRedemptionSettings': 'Points exchange settings',
  'sys.exchange': 'exchange',
  'sys.msg14': 'Recommended person requirements',
  'sys.msg15': 'Within days',
  'sys.rewarderSelection': 'Selection of reward party',
  'sys.invitees': 'Invited person',
  'sys.invitees1': 'Inviter',
  'sys.inviterReward': 'Invitees reward',
  'sys.inviterReward1': 'Please enter the invitee reward',
  'sys.inviterReward2': 'Invitees reward',
  'sys.inviterReward3': 'Please enter the reward of the invitee',
  'sys.unlimited': 'Is it unlimited?',
  'sys.discountPoints': 'Preferential points',
  'sys.preferential': 'Preferential',
  'sys.doubleWater1': 'Double flow',
  'sys.maxWithdrawal': 'Maximum withdrawal',
  'sys.enterMaxWithdrawalAmount': 'Please enter the maximum withdrawal amount',
  'sys.msg16': 'Platform and condition setting (regular delivery at 04:00 every day)',
  'sys.msg17': 'The maximum payout multiple must be greater than the minimum payout amount',
  'sys.msg18': 'Payout is greater than the effective multiple (including)',
  'sys.msg19': 'Please enter the minimum payout greater than the effective multiple',
  'sys.msg20': 'The highest payout is greater than the effective multiple (excluding)',
  'sys.msg21': 'Please enter the maximum payout greater than the effective multiple',
  'sys.msg22': 'Multiple of free bet',
  'sys.msg23': 'Please enter the times of free bet',
  'sys.msg25': 'Withdrawal limit, n times of current withdrawable',
  'sys.msg300': 'Daily pickups',
  'sys.enterDailyPickupCount': 'Please enter the number of daily pickups',
  'sys.selectLeastOne': 'Please select at least one',
  'sys.addUpgradeConditions': 'Add upgrade condition',
  'sys.msg26': 'Required bet',
  'sys.msg27': 'Please enter the required amount',
  'sys.msg32': 'Upgrade conditions, (Weekly salary will be distributed on Wednesday and monthly salary on the 3rd of each month)',
  'sys.msg33': 'No upgrade conditions have been added yet',
  'sys.upgradeGift': 'Upgrade gifts',
  'sys.enterUpgradeGift': 'Please enter the upgrade gift',
  'sys.platformLevelSettings': 'Platform and level setting',
  'sys.msg34': 'Free cash: {giftMoney} yuan',
  'sys.msg34VN': 'Free cash: {giftMoney} VND',
  'sys.msg35': 'Free cash: {giftMoney}% (no more than {maxMoney})',
  'sys.msg35VN': 'Free cash: {giftMoney}% (no more than {maxMoney} VND)',
  'sys.msg36': '|Flow requirements: {betMultiple} times',
  'sys.msg37': 'Cumulative bet: {minBetAmount} ~ {maxBetAmount}',
  'sys.msg38': '|Times of gift: {giftCount} times',
  'sys.selectLeastOneGamePlatform': 'Please select at least one game platform!',
  'sys.setLeastOneObtainingMethod': 'Set at least one obtaining method',
  'sys.editLeastOneOffer': 'Please edit at least one offer',
  'sys.vip1': 'VIP {vipLevel} return water proportion must be greater than or equal to 0!',
  'sys.vip2': 'The maximum amount of VIP {vipLevel} should be about the minimum amount!',
  'sys.vip3': 'Please fill in VIP {vipLevel} return water proportion',
  'sys.vip4': 'Please fill in the minimum return water amount of VIP {vipLevel}',
  'sys.vip5': 'Please fill in VIP {vipLevel} maximum return water amount',
  'sys.addBetConditionBeforeSubmitting': 'Please add note conditions before submitting',
  'sys.noteTailNumber': 'Note single tail number: {conditionValue1}',
  'sys.noteTailNumber1': 'Note note bet amount: {conditionValue1}',
  'sys.noteTailNumber2': 'Note: amount of single lottery: {conditionValue1}',
  'sys.noteTailNumber3': 'Note single profit amount: {conditionValue1}',
  'sys.msg39': 'Fixed method: preferential amount: {giftMoney} yuan, points: {giftPoint}',
  'sys.msg39VN': 'Fixed method: preferential amount: {giftMoney} VND, points: {giftPoint}',
  'sys.msg40': 'Bet amount method: amount multiple rate: {moneyPercent}, maximum no more than: {maxMoney} yuan|',
  'sys.msg40VN': 'Bet amount method: amount multiple rate: {moneyPercent}, maximum no more than: {maxMoney} VND|',
  'sys.msg43': 'Payment method: integral multiple rate: {pointPercent}, maximum no more than: {maxPoint}',
  'sys.msg44': 'Profit amount method: amount multiple ratio: {moneyPercent}, the maximum is no more than: {maxMoney} yuan',
  'sys.msg44VN': 'Profit amount method: amount multiple ratio: {moneyPercent}, the maximum is no more than: {maxMoney} VND',
  'sys.msg45': 'Profit amount method: integral multiple rate: {pointPercent}, maximum no more than: {maxPoint}',
  'sys.msg46': 'Yuan to achieve',
  'sys.msg46VN': 'VND to achieve',
  'sys.msg47': 'The {money} element, the {betflowMulti} times flow can be extracted',
  'sys.msg47VN': 'The {money} VND, the {betflowMulti} times flow can be extracted',

  'sys.msg48': '{point} integral',
  'sys.msg49': 'The winning probability is {probability}%. There are {totalNumber} in total, and {dailyTotalNumber} every day',
  'sys.msg50': 'Please add the offer before submitting!',
  'sys.msg51': 'The cash of {giftMoney} yuan is put into the main account, and {betMultiple} times of the current account can be withdrawn.',
  'sys.msg52': '{giftPoint} points are added to the main account.',
  'sys.msg53': '{prizeName} custom rewards.',
  'sys.msg54': 'Keep going',
  'sys.msg55': 'Custom physical object',
  'sys.msg56': 'Make persistent efforts',
  'sys.msg57': 'Please add continuous rewards before submitting!',
  'sys.msg58': 'Continuous days must be greater than 0!',
  'sys.msg59': '"| flow requirements:',
  'sys.msg60': '+Preferential amount',
  'sys.msg62': '|{betMultiple} times flow',
  'sys.app': 'APP',
  'sys.mobileVersion': 'Mobile version',
  'sys.webVersion': 'Web version',
  'sys.continuousCheck-inForFixedRewards': 'Continuous sign in fixed reward',
  'sys.singleSign-inRaffleReward': 'Single sign in lottery reward',
  'sys.loginSide': 'Login terminal',
  'sys.selectLoginSide': 'Please select login',
  'sys.prizeSetting': 'Prize setting',
  'sys.selectPrizeSetting': 'Please select prize settings',
  'sys.continuousCheck-in': 'Continuous sign in',
  'sys.continuousCheck-in1': 'Please enter consecutive check-in days',
  'sys.amountObtained': 'Amount earned',
  'sys.earnPoints': 'Get integral',
  'sys.enterEarnPoints': 'Please enter the points you can get',
  'sys.addedSweepstakesBonus': 'Added raffle Awards',
  'sys.no1': 'No time',
  'sys.addReward': 'Add rewards',
  'sys.rewardAmount': 'Reward amount',
  'sys.enterRewardAmount': 'Please enter the reward amount',
  'sys.cashFlowRequirement': 'Withdrawal flow requirements',
  'sys.enterCashFlowRequirement': 'Please enter withdrawal flow requirements',
  'sys.rewardPoints': 'Bonus points',
  'sys.enterRewardPoints': 'Please enter bonus points',
  'sys.physicalName': 'Physical name',
  'sys.enterPhysicalName': 'Please enter the physical name',
  'sys.clickSelectImage': 'Click to select a picture',
  'sys.enterProbabilityWinning': 'Please enter the winning probability',
  'sys.totalNumberCopies': 'Total number',
  'sys.enterTotalNumberCopies': 'Please enter the total number of copies',
  'sys.distributeMostDaily': 'Maximum daily distribution',
  'sys.enterDistributeMostDaily': 'Please enter the maximum number of dispatches per day',
  'sys.lotteryConditions': 'Lucky draw conditions',
  'sys.daysDeposit': 'Days of deposit',
  'sys.enterDaysDeposit': 'Please enter continuous deposit days',
  'sys.dailyDepositAmount': 'Daily deposit amount',
  'sys.addLotteryPrizes': 'Add raffle prize',
  'sys.ruleSetting': 'Rule setting',
  'sys.balance': 'balance',
  'sys.msg63': 'Deposit amount: {minDeposit} ~ {maxDeposit}',
  'sys.msg64': 'Free cash: {giftPercent}%,max cash: {maxBonusAmount}',
  'sys.msg65': '|Pipeline multiple: {betMultiple}',
  'sys.successfulOperation': 'Operation succeeded!',
  'sys.discountInformation': 'Preferential information',
  'sys.displayInformation': 'Display information',
  'sys.previous': 'Previous step',
  'sys.offerEditedSuccessfully': 'Offer edited successfully.',
  'sys.returnListPage': 'Return to list page',
  'sys.msg68': 'Multiple of Free Bets: {giftMultiple}',
  'sys.msg69': '|Flow requirements: {betMultiple} times | the maximum amount of gift cannot exceed: {maxGiftMoney}',
  'sys.msg70': 'Payout is greater than the effective bet multiple: {minMultiple} ~ {maxMultiple}',
  'sys.msg71': 'Please select at least one offer!',
  'sys.msg72': 'Grade: {level}, cumulative {betflow} yuan effective bet',
  'sys.msg73': 'Enjoy: {upAmount} upgrade gift, {weekAmount} weekly salary gift, {monthAmount} monthly salary gift. All cash gift {betMultiple} times of current available for withdrawal',
  'sys.importTime': 'Import time',
  'sys.importCount': 'Number of import entries',
  'sys.importSuccessCount': 'Number of successful imports',
  'sys.importFailCount': 'Number of failures',
  'sys.seeDetails': 'View details',
  'sys.batchImport': 'Batch import',
  'sys.formatDescription': 'Format specification',
  'sys.formatDescription1': '1. Dividend name',
  'sys.formatDescription2': '2. User name',
  'sys.formatDescription3': '3. Preferential amount',
  'sys.formatDescription4': '4. Required amount of flow',
  'sys.busyServer': 'The server is busy. Please try again later.',
  'sys.batchImportSucceeded': 'Batch import succeeded',
  'sys.importSucceeded': 'Successful import',
  'sys.importFail': 'Import failed',
  'sys.msg74': 'Total imports of {importCount}, successful imports of {importSuccessCount}, failed imports of {importFailCount}.',
  'sys.msg75': 'Up to 6 items can be set for home page recommendation',
  'sys.uploadError': 'Upload error. Please try again later.',
  'sys.batchImportOffers': 'Bulk import offer',
  'sys.batchImportOffersDetails': 'Bulk import offer details',
  'sys.determine': 'OK',
  'sys.import': 'Import',
  'sys.whetherSucceed': 'Success',
  'sys.importStatus': 'Import state',
  'sys.content1': 'content',
  'sys.enterContent1': 'Please enter content',
  'sys.error.loadRoles': 'Failed to load roles data',
  'agent.title.confirmOffer2': 'Please confirm whether to issue?',
  'sys.confirmRejectionThisOffer': 'Are you sure you want to decline this offer?',
  'sys.confirmCancelThisOffer': 'Are you sure you want to cancel this offer?',
  'sys.winningNumber': 'Winning note No',
  'sys.preferentialVariety': 'Preferential variety',
  'sys.allVarieties': 'All varieties',
  'sys.preferentialPrincipal': 'Preferential principal',
  'sys.targetFlow': 'Target flow',
  'sys.effectiveFlow': 'Effective pipeline',
  'sys.flowCalculationState': 'Flow calculation status:',
  'sys.completionCalculation': 'Calculation completed',
  'sys.hasFailed': 'Failed',
  'sys.offerCurrentStatus': 'Offer current status:',
  'sys.offerCurrentStatus1': 'Current status of offer',
  'sys.offerArrivalTime': 'Preferential arrival time',
  'sys.runningWaterCalculationCompletionTime': 'Completion time of flow calculation',
  'sys.userWinsLoses': 'Users win or lose',
  'sys.platformProfitLoss': 'Platform profit and loss',
  'sys.examinationPassed': 'Audit pass',
  'sys.setEffectiveFlow': 'Set effective flow',
  'sys.winningNumber1': 'Winning number',
  'sys.totalDiscount': 'Total preferential amount',
  'sys.totalDiscount1': 'Total number of offers',
  'sys.totalDiscount2': 'Total rescue gold bars',
  'sys.totalDiscount3': 'Total number of upgrade Awards',
  'sys.totalDiscount4': 'Total number of awards for cicada',
  'sys.totalDiscount5': 'Total number of manually added offers',
  'sys.totalDiscount6': 'Total number of discount items',
  'sys.totalDiscount7': 'Total deposit preference',
  'sys.totalDiscount8': 'Total number of offers',
  'sys.totalDiscount9': 'Total number of other offers',
  'sys.totalDiscount10': 'Total number of new offers',
  'sys.xls': 'Preferential collection record report.xls',
  'sys.keyword': 'Keyword',
  'sys.releaseStartTime': 'Release start time',
  'sys.chooseStartTime': 'Select start time',
  'sys.chooseEndTime': 'Select end time',
  'sys.releaseEndTime': 'Release end time',
  'sys.enterValidWater': 'Please enter valid flow',
  'sys.recommendedOfferTips': 'Tips on recommended offers',
  'sys.setRecommendedBonusInformation': 'Set recommended bonus information',
  'sys.offerTitle': 'Preferential title',
  'sys.offerTitleName': 'Offer type name',
  'sys.offerTitle1': 'Offer subtitle',
  'sys.enterOfferTitle1': 'Please enter the offer subtitle',
  'sys.msg76': 'PC end size: 1000 * 150px',
  'sys.msg77': 'Picture of mobile terminal recommendation',
  'sys.msg78': 'Size of mobile end: 360 * 180px',
  'sys.msg79': 'It is recommended that you take off the article before closing this offer.',
  'sys.msg80': 'Are you sure to cancel the homepage offer?',
  'sys.offerType': 'Preferential type',
  'sys.scopeApplication': 'Scope of application',
  'sys.editor': 'Editor',
  'sys.editTime': 'Update time',
  'sys.self-serviceArea': 'self-service area ',
  'sys.image': 'picture',
  'sys.whetherDisplayListBySort': 'Display list by sort or not',
  'sys.selectOfferType': 'Choose offer type',
  'sys.msg81': 'Are you clear about the related preferential information',
  'sys.msg82': 'Please check carefully to confirm?',
  'sys.offerList': 'Discount list',
  'sys.unlink': 'Cancel Association',
  'sys.firstDepositOffer': 'First deposit offer',
  'sys.OtherOffers': 'Other preferences',
  'sys.clientType': 'Client type',
  'sys.offerMap': 'Preference map',
  'sys.sharingPhoto': 'Promotional pictures',
  'sys.amount': 'Payment amount',
  'sys.profitLoss': 'Preferential profit and loss',
  'sys.numberRecipients': 'Number of recipients',
  'sys.numberIssues': 'Frequency of issue',
  'sys.offerStatus': 'Preferential status',
  'sys.msg83': 'About to delete announcement with Title {name}',
  'sys.msg84': 'Are you sure you want to disable this announcement?',
  'sys.msg85': 'Are you sure to enable this announcement?',
  'sys.msg86': 'About to delete article with Title {title}',
  'sys.msg88': 'About to delete the game navigation icon named {pcName}',
  'sys.confirmationOperation': 'Confirm operation',
  'sys.pushTitle': 'Push heading',
  'sys.usableNot': 'Availability',
  'sys.usable': 'available',
  'sys.usable1': 'Unavailable',
  'sys.modifyAnnouncementMessage': 'Modify announcement message',
  'sys.addAnnouncement': 'Add announcement',
  'sys.addAnnouncementMessage': 'Add announcement message',
  'sys.announcementTitle': 'Notice title',
  'sys.loseAnnouncementTitle': 'Please enter announcement title',
  'sys.enterTitleAnnouncement': 'Please enter announcement title',
  'sys.announcementType': 'Announcement type',
  'sys.selectAnnouncementType': 'Please select announcement type',
  'sys.announcementContent': 'Announcement content',
  'sys.enterAnnouncementContent': 'Please enter announcement content',
  'sys.startEndTime': 'Start and stop time',
  'sys.selectStartEndTime': 'Please select Start and end time',
  'sys.articleTitle': 'Article title',
  'sys.enterArticleTitle': 'Please enter the title of the article',
  'sys.articleType': 'Article type',
  'sys.enterArticleType': 'Please enter article type',
  'sys.pcPlatform': 'PC platform',
  'sys.h5Platform': 'H5 platform',
  'sys.modifyArticles': 'Revise article',
  'sys.addArticle': 'Add article',
  'sys.articleContent': 'Article content',
  'sys.enterArticleContent': 'Please fill in the article',
  'sys.addArticleType': 'Add article type',
  'sys.enterArticleTypeTitle': 'Please enter article type title',
  'sys.smallIcon': 'small icons',
  'sys.bigIcon': 'Big Icon',
  'sys.addGameNavigation': 'Add game navigation',
  'sys.addGameName': 'Game navigation name',
  'sys.msg89': 'PC size icon must be passed to one',
  'sys.msg90': 'Mobile size icon must be passed to one',
  'sys.msg91': 'PC - upload game logo',
  'sys.msg92': 'PC - upload game logo',
  'sys.msg96': 'Image path event URI: if this field exists, when clicking on the image, it will be transferred to the page of click path. If this field has no value, no operation will be done to click on the image',
  'sys.msg97': 'Note: the format of image path event URI is; for example, www.baidu.com / # / game / all, if this page is the full path of the page to be transferred, then the URI of the required parameter here is # / game / all',
  'sys.msg98': 'This function is used for merchants to upload pictures to add / replace front-end pictures',
  'sys.msg99': 'Sequence: the sequence of pictures can be sorted by yourself',
  'sys.msg100': 'About to delete picture with name: {imgName}',
  'sys.msg101': 'Picture path event URI',
  'sys.gameNavigationName': 'Game navigation name',
  'sys.enterGameNavigationName': 'Please enter the game navigation name',
  'sys.page': 'page',
  'sys.fillRoleInformation': 'Fill in role information',
  'sys.enterName': 'Please enter a name',
  'sys.enterType': 'Please enter type',
  'sys.enterStatus': 'Please enter status',
  'sys.contentConfiguration': 'Content configuration',
  'sys.contentConfiguration1': 'Page configuration',
  'sys.keywordSearch': 'Keyword search',
  'sys.imageName': 'Picture name',
  'sys.enterImageName': 'Please enter a picture name',
  'sys.imageName1': 'Picture name / description',
  'sys.imageGroup': 'Picture group',
  'sys.addPictures': 'Add pictures',
  'sys.imageDescription': 'Picture description',
  'sys.msg102': 'Links when clicking pictures',
  'sys.msg103': 'Maximum number of pictures that can be transferred: it is to limit the maximum number of pictures that can be owned under this code group',
  'sys.msg104': 'Description: overview of the role of pictures / picture groups',
  'sys.msg106': 'About to enable picture group with name: {imgName}',
  'sys.numberUploadedImages': 'Number of uploaded pictures',
  'sys.sendPushMessage': 'Send push message',
  'sys.pushPlatform': 'Push platform',
  'sys.pushPlatform1': 'Please select a push platform',
  'sys.android': 'Android',
  'sys.ios': 'IOS',
  'sys.title': 'Title',
  'sys.fillPushTitle': 'Please fill in the push title',
  'sys.fillPushContent': 'Please fill in the push content',
  'sys.pushContent': 'Push content',
  'sys.msg107': 'Pusher / time',
  'sys.msg108': 'Select whether to set record as read',
  'sys.msg109': 'Select whether to set the record as unread',
  'sys.pushDate': 'Push date',
  'sys.messageType': 'Message type',
  'sys.theme': 'theme',
  'sys.enterTheme': 'Please enter a subject',
  'sys.time1': 'time',
  'sys.haveRead': 'Already read',
  'sys.unread': 'Unread',
  'sys.reply': 'Reply',
  'sys.hasBeenBack': 'Already returned',
  'sys.userNotSelected': 'No user selected',
  'sys.markRead': 'Mark as read',
  'sys.markRead1': 'Mark as unread',
  'sys.msg110': 'Delete selected record',
  'sys.recipient': 'Addressee',
  'sys.selectRecipient': 'Please select the recipient',
  'sys.sender': 'Sender',
  'sys.systemSend': 'System send',
  'sys.operationalTransmission': 'Operation dispatch',
  'sys.operator': 'Operator',
  'sys.sender1': 'Sender',
  'sys.send': 'Send out',
  'sys.sendHand': 'Manual transmission',
  'sys.sendSiteMsg': 'Send in station message',
  'sys.agentMustSelected': 'Agent must be selected',
  'sys.memberMustFilledOut': 'Member required',
  'sys.mustFillVipLevel': 'Must fill in vip level',
  'sys.mustFillTimePeriod': 'Time period must be filled in',
  'sys.parameterNotComplete': 'Parameters not filled in completely',
  'sys.msg111': 'Warm reminder: if the member account is bound to the email, you can receive the email you filled in',
  'sys.msg112': 'Please enter members separated by (,) commas',
  'common.agent1': 'Agent:',
  'sys.selectAgent': 'Please select an agent',
  'sys.allMembers': 'All members',
  'sys.actingMembers': 'Acting member',
  'sys.contentEmail': 'Mail content',
  'sys.fillLetter': 'Please fill in the station letter',
  'sys.stationLetterContent': 'Content of in station letter',
  'sys.operation.upgrade': 'Upgrade mode',
  'sys.msg113': 'Upgrade conditions, (Weekly salary will be distributed on Wednesday and monthly salary on the 3rd)',
  'sys.timeArrival': 'Payment date',
  'sys.totalNumberArticles': 'Total number',
  'sys.add': 'Newly added',
  'sys.smg114': 'Confirm will',
  'sys.smg115': 'Subordinate',
  'sys.smg116': 'Privilege settings',
  'sys.smg117': 'Privileges to be removed: {title}',
  'sys.smg118': 'Level {vipLevel}',
  'sys.smg119': 'Please enter a privilege Main Title less than 20 characters',
  'sys.smg120': 'Please enter the name of the promotion picture',
  'sys.smg121': 'Please enter a privilege subheading of less than 20 words',
  'sys.smg122': 'Please confirm that the information filled in is correct and the corresponding logic is correct.',
  'sys.confirmModificationStatus': 'Confirm modification status',
  'sys.vip7': 'VIP of privilege',
  'sys.vip8': 'Privilege main title',
  'sys.vip9': 'Privilege subtitle',
  'sys.vip10': 'Add privileges',
  'sys.ipAll': 'All IP',
  'sys.ipAddr': 'IP address',
  'sys.ipRemark': 'IP/ remarks',
  'sys.abnormalOperation': 'The operation is abnormal. Please try again later.',
  'sys.vip11': 'Add privilege information',
  'sys.vip12': 'Please enter the main title of the privilege',
  'sys.vip13': 'Please enter the privilege subtitle',
  'sys.vip14': 'VIP level setting',
  'sys.vip15': 'Vip name',
  'sys.vip16': 'Please enter VIP name',
  'sys.vip17': 'VIP level',
  'sys.vip18': 'View privileges',
  'sys.oldPromotionPicture': 'Old promotion pictures',
  'sys.uploadFile': 'Please upload the file',
  'sys.privilegeOrder': 'Order of privilege',
  'sys.enterPrivilegeOrder': 'Please enter the order of privileges',
  'sys.confirmSubmissionChanges': 'Confirm to submit modification',
  'sys.memberExpirationDate': 'Member validity',
  'sys.memberExpirationDate1': 'Please select the validity period',
  'sys.promotionRequirements': 'Promotion requirements',
  'sys.requiredPoints': 'Required integral',
  'sys.requiredDeposit': 'Required deposits',
  'sys.requiredFlow': 'Required flow',
  'sys.requiredPoints2': 'Relegation points',
  'sys.requiredDeposit2': 'Protection deposit',
  'sys.requiredFlow2': 'Relegation flow',
  'sys.relegationPeriod': 'Relegation period',
  'sys.coupletRequest': 'Reelection requirement',
  'sys.runningWater': 'Flow = =',
  'sys.runningWater1': 'Flowing water',
  'sys.msg123': '% negative earnings.',
  'sys.msg124': 'Baker',
  'sys.issueOnce': 'Release once',
  'sys.issueOnce1': 'Daily payment',
  'sys.issueOnce2': 'Weekly payment',
  'sys.issueOnce3': 'Monthly payment',
  'sys.issueOnce4': 'Annual payment',
  'sys.msg125': 'VIP {vipLevel} level ({vipName}) member level setting?',
  'sys.showName': 'Display name',
  'sys.view': 'See',
  'sys.msg126': 'Please confirm whether to unlock?',
  'sys.msg127': 'Please confirm whether it is approved?',
  'sys.lockedAmount': 'Lock amount',
  'sys.flowCompletionProgress': 'Flow completion progress',
  'sys.completedFlow': 'Completed flow:',
  'sys.offerTime': 'Preferential collection time',
  'sys.offerLockList': 'Offer lock-in list',
  'sys.monthlySettlementCommission': 'Monthly settlement Commission',
  'sys.confirmationReview': 'Confirmation audit',
  'sys.proxyName': 'Agent name',
  'sys.selectDate': 'Please select a date',
  'sys.completeSchedule': 'Completion schedule',
  'sys.rechargeTime': 'Recharge time',
  'sys.depositLockList': 'Deposit lock list',
  'sys.transferAmount': 'Transfer amount',
  'sys.transferStatus': 'Transfer status',
  'sys.transferType': 'Transfer type',
  'sys.gameOut': 'Game out',
  'sys.abnormal': 'abnormal',
  'sys.msg128': 'Set as successful?',
  'sys.msg129': 'Set to successful. If the transfer type is game transfer out, the amount will be added to the player\'s assets',
  'sys.msg130': 'Set as failed?',
  'sys.msg131': 'Set as failed. If the transfer type is transfer in game, the amount will be added to the player\'s assets',
  'sys.msg132': 'Order number, user name, game platform',
  'sys.setSuccess': 'Set it as a success',
  'sys.setFail': 'Set failure',
  'sys.totalWithdrawal': 'Total withdrawals',
  'sys.offerComposition': 'Preferential composition',
  'sys.gameWater': 'Game flow',
  'sys.bankRelated': 'Bank related',
  'sys.bankCode': 'bank code:',
  'sys.bankName': 'Bank Name:',
  'sys.branchName': 'Branch Name:',
  'sys.branchAddr': 'Branch address:',
  'sys.accountRelated': 'Account related',
  'sys.msg133': 'Account Name:',
  'sys.msg134': 'bank account:',
  'sys.msg135': 'Final amount',
  'sys.msg136': 'Running water records in the past seven days',
  'sys.msg137': 'IP location',
  'sys.msg138': 'View the users logged in by this IP',
  'sys.msg139': 'IP address statistics',
  'sys.normal': 'normal',
  'sys.bankInformation': 'Bank information',
  'sys.attributionType': 'Attribution type',
  'sys.offerRecord': 'Preferential record',
  'sys.userDeviceID': 'User device ID',
  'sys.deviceInformation': 'Device information',
  'sys.operatingSystemVersion': 'Operating system version',
  'sys.longitude': 'longitude',
  'sys.latitude': 'latitude',
  'sys.loginTimes': 'Login times',
  'sys.loginTimes1': 'Number of logins:',
  'sys.registrationTime': 'Registration time',
  'sys.cellphoneNumber': 'Phone number',
  'sys.cellphoneNumber2': 'phone number:',
  'sys.cellphoneNumber3': 'Is the mobile phone certified',
  'sys.msg140': 'Other users logged in by this IP',
  'sys.msg141': 'Last login time',
  'sys.msg142': 'Application submission time',
  'sys.windControlManagement': 'Wind control management',
  'sys.loginLog': 'Login log',
  'sys.deviceID': 'Device Id',
  'sys.browser': 'Browser',
  'sys.transactionRecord': 'Transaction record',
  'sys.transactionType': 'Transaction type',
  'sys.transferDetails': 'Transfer details',
  'sys.amountAfterSettlement': 'Amount after settlement',
  'sys.fundChange': 'Capital change',
  'sys.increase': 'increase',
  'sys.cutBack': 'reduce',
  'sys.winLossAmount': 'Winning or losing amount',
  'sys.chronologically': 'Chronological order:',
  'sys.agentWithdraw': 'Withdrawal request',
  'sys.selectRiskLevel': 'Select risk level',
  'sys.selectRiskLevel1': 'Please select risk control level',
  'sys.windControlLevel': 'Wind control level',
  'sys.confirmConsent': 'Confirm consent',
  'sys.confirmConsent1': 'Do you agree to this operation?',
  'sys.confirmConsent2': 'Do you want to reject this operation?',
  'sys.cardholder': 'Cardholder',
  'sys.viewUserDetails': 'View user details',
  'sys.by': 'adopt',
  'sys.notApproved': 'Not examined and approved',
  'sys.passed': 'Have passed',
  'sys.paid': 'Out of payment',
  'sys.successfulPayment': 'Successful payment',
  'sys.smg143': 'Users to be approved',
  'sys.smg144': 'Limited preferential users',
  'sys.smg145': 'Restricted withdrawal users',
  'sys.smg146': 'Restrict login users',
  'sys.smg147': 'Logged in IP address',
  'sys.smg148': 'Same device and same IP information',
  'sys.smg149': 'User win curve',
  'sys.smg150': 'Is the email certified',
  'sys.smg151': 'User risk control attribute list',
  'sys.flowRecord': 'Pipeline record',
  'sys.userInfo': 'User information',
  'sys.attribution': 'Place of ownership',
  'sys.registerationName': 'Registered domain name:',
  'sys.details': 'Details:',
  'sys.searchUser': 'User name:',
  'sys.numberDeposits': 'Number of deposits:',
  'sys.numberWithdrawals': 'Withdrawal times:',
  'sys.allGrades': 'All grades',
  'sys.riskValueScore': 'Var score',
  'sys.managementPlatformGame': 'Manage platform games',
  'sys.receivingTime': 'Receiving time:',
  'sys.completeTime': 'Completion time:',
  'sys.processResult': 'Processing result',
  'sys.addWorkOrder': 'Job sheet',
  'sys.smg155': 'Content / remarks / submitted by',
  'sys.fillWorkOrder': 'Fill in work order',
  'sys.enterTitle': 'Please enter a title',
  'sys.smg156': 'Please enter work order content, suggestion or opinion',
  'sys.enterProcessingResult': 'Please enter the processing result',
  'sys.realUnlockAmount': 'Real person unlocking amount',
  'sys.enterParameterAmount': 'Please enter parameter amount',
  'sys.realState': 'Human status',
  'sys.videoGameUnlockAmount': 'Amount of video game unlocking',
  'sys.videoGameStatus': 'Video game status',
  'sys.sportsUnlockAmount': 'Sports unlocking amount',
  'sys.sportsStatus': 'Sports state',
  'sys.chessCardUnlockingAmount': 'Unlock amount of chess and card',
  'sys.chessState': 'Chess status',
  'sys.fishingUnlockAmount': 'Fishing unlocking amount',
  'sys.fishingStatus': 'Fishing state',
  'sys.lotteryUnlockAmount': 'Lottery unlocking amount',
  'sys.lotteryStatus': 'Lottery status',
  'sys.universalUnlockAmount': 'General unlocking amount',
  'sys.defaultState': 'Default state',
  'sys.smg157': 'Note: the number of unlocking amount setting will affect the funds locked by members.',
  'sys.smg158': 'Discount locked amount minus discount lost amount is less than the unlocked amount.',
  'sys.smg159': 'The deposit locked amount minus the lost money is lower than the unlocked amount.',
  'sys.smg160': 'The system will automatically unlock the offer or deposit and set the status to failed.',
  'sys.smg161': 'The unlocking parameters of the corresponding game type will be used for the concessions of the specified game type, and the default unlocking parameters will be used for the concessions and deposit locking of the unspecified game type.',
  'sys.confirmUpload': 'Confirm upload',
  'sys.smg162': 'This upload will affect the download of the user app. Please be careful, upload or not?',
  'sys.smg163': 'Package and upload app version',
  'sys.AppType': 'APP type',
  'sys.selectAppTypr': 'Please select app type',
  'sys.version': 'Version number',
  'sys.enterVersion': 'Please enter version number',
  'sys.smg164': 'Enter up to 10 characters',
  'sys.pleaseUpload': 'Please upload',
  'sys.pleaseUploadApp': 'Please upload the app package',
  'sys.pleaseNote': 'Please note that',
  'sys.smg165': 'Select the app file to confirm, and then submit it for upload automatically!!!',
  'sys.AppUploadUpdateSucceeded': 'App upload and update succeeded',
  'sys.returnRefreshHome': 'Return to refresh home page',
  'sys.configurationItem': 'Configuration description item',
  'sys.enterConfigurationItem': 'Please enter the configuration description',
  'sys.withdrawalOrderSplit': 'Withdrawal order splitting',
  'sys.smg166': 'Do you want to {msg} withdraw order splitting?',
  'sys.addPaymentChannel': 'Add payment channel',
  'sys.orderSplitConfiguration': 'Order splitting configuration',
  'sys.maxAmount': 'Maximum sum',
  'sys.minAmount': 'Minimum amount',
  'sys.nameCode': 'Name /code',
  'sys.fillPaymentChannelInformation': 'Fill in payment channel information',
  'sys.paymentRate': 'Premium rate',
  'sys.enterPaymentRate': 'Please enter the payment rate',
  'sys.controllerPath': 'Controller path',
  'sys.fillPaymentSplitConfiguration': 'Fill in delegated payment splitting configuration',
  'sys.splitMinimumAmount': 'Split minimum amount',
  'sys.splitMaximumAmount': 'Split maximum amount',
  'sys.whetherOpen': 'Whether to open',
  'sys.isSubmit': 'Whether to submit',
  'sys.confirmSubmit': 'Please check whether the information is correct and submitted carefully',
  'sys.diffPass': 'Password is inconsistent, please confirm',
  'sys.formatError': 'Can only start with a lowercase letter, only contain lowercase letters and numbers',
  'sys.Pass': 'Password',
  'sys.cleanValidator': 'Are you sure you want to clear the verifier bound to this background account?',
  'sys.deleteAccount': 'Account to be deleted: {username}',
  'sys.forceOffline': 'Force offline',
  'sys.resetValidator': 'Reset verifier',
  'sys.fillDeviceInfo': 'Fill in equipment information',
  'sys.deviceNo': 'Equipment number',
  'sys.deviceNo1': 'Please enter the equipment number',
  'sys.deviceNo2': 'Please enter the equipment number remark',
  'sys.deviceNo3': 'Device number to be removed: {deviceNum}',
  'sys.confirmRefreshBlackList': 'Are you sure you want to refresh the device blacklist?',
  'sys.refreshBlackList': 'Refresh device blacklist',
  'sys.addDeviceNo': 'Add device number',
  'sys.fillIPInfo': 'Fill in IP information',
  'sys.startIP': 'Start IP',
  'sys.startIP1': 'Please enter start IP',
  'sys.endIP': 'End IP',
  'sys.endIP1': 'Please enter the end IP',
  'sys.endIP2': 'Please enter IP comment',
  'sys.deleteIP': 'IP to be deleted: {ipMinRange}',
  'sys.beginIP': 'IP address start',
  'sys.overIP': 'End of IP address',
  'sys.confirmRefreshIPBlackList': 'Are you sure you want to refresh the IP blacklist?',
  'sys.addIP': 'Add IP',
  'sys.refreshIpBlackList': 'Refresh IP blacklist',
  'sys.changeTime': 'Modification time',
  'sys.inputIPAddress': 'Please enter IP address',
  'sys.inputIPAddress1': 'Multi IP please use, number split',
  'sys.editPlayMethodDesc': 'Edit play instructions',
  'sys.playMethodDesc': 'Play instructions',
  'sys.playMethodDesc1': 'Please enter a description of how to play',
  'sys.winningExample': 'Examples of winning',
  'sys.winningExample1': 'Please enter the winning example',
  'sys.confirmEnablePlayMethod': 'Are you sure you want to enable this play?',
  'sys.confirmDisablePlayMethod': 'Are you sure you want to disable this play?',
  'sys.people': 'personnel',
  'sys.editDesc': 'Editor\'s note',
  'sys.attributeName': 'Attribute name',
  'sys.confirmChangeLiuHeOdds': 'Are you sure you want to modify the odds of [{firstName} - {secondName}]?',
  'sys.save': 'Preservation',
  'sys.odds': 'The odds are:',
  'sys.cleanWhiteListCache': 'Clear white list cache',
  'sys.inputIPAddress3': 'Please enter the IP address, and use the, number to divide multiple IP addresses',
  'sys.accountUnlockParam': 'Account unlocking parameters',
  'sys.lowOrderCount': 'Minimum orders',
  'sys.lowOrderCount1': 'Please enter the minimum number of orders',
  'sys.lowOrderCount2': 'Please enter the correct number',
  'sys.percentageWarning': 'Alert percentage',
  'sys.percentageWarning1': 'Please enter alert percentage',
  'sys.disablePercentage': 'Percent disabled',
  'sys.disablePercentage1': 'Please enter the disabled percentage',
  'sys.lowOrderCount3': 'Minimum order quantity: if the total order quantity of payment method is greater than this value, judge whether the payment method sends alert message and automatically disables it.',
  'sys.percentageWarning2': 'Alert percentage: if the success rate of the payment method is lower than this percentage, an alert message will be sent and displayed in the upper right corner of the page.',
  'sys.disablePercentage2': 'Disable percentage: if the success rate of the payment method is lower than this percentage, the payment method will be automatically disabled and a disable message will be sent, which will be displayed in the upper right corner of the page.',
  'sys.disablePercentage3': 'Payment methods that have been disabled will no longer send messages repeatedly.',
  'sys.gamePlatformInfo': 'Game platform information',
  'sys.chineseName': 'Chinese name',
  'sys.chineseName1': 'Please enter Chinese name',
  'sys.gameSort': 'Game sequencing',
  'sys.gameSort1': 'Please enter the game order, from small to large',
  'sys.pc': 'Support PC',
  'sys.pc1': 'Please select whether PC is supported',
  'sys.pc2': 'Support PC',
  'sys.notSupport': 'I won\'t support it',
  'sys.h52': 'Support H5',
  'sys.hotGame': 'Hot game',
  'sys.notHotGame': 'Non popular',
  'sys.newestGame': 'Latest game',
  'sys.notNewGame': 'Non up-to-date',
  'sys.gameNo': 'Game number',
  'sys.pcPicH5Pic': 'PC/H5 pictures',
  'sys.notSupportPc': 'PC side is not supported',
  'sys.notSupportH5': 'Mobile is not supported',
  'sys.newGame': 'New game',
  'sys.tryPlay': 'Support for trial play',
  'sys.hot': 'heat',
  'sys.new': 'new',
  'sys.try': 'try',
  'sys.addMaintenanceInfoSuccess': 'Maintenance information added successfully!',
  'sys.addMaintenanceInfoFail': 'Failed to add maintenance information',
  'sys.addMaintenanceInfoError': 'Error adding maintenance information',
  'sys.maintenanceInfo1': 'Please fill in the maintenance information',
  'sys.maintenanceInfo': 'Maintenance information',
  'sys.fillGamePlatFormInfo': 'Fill in game platform information',
  'sys.platFormNo': 'Please enter platform number',
  'sys.platFormGameNo': 'Platform game number',
  'sys.platFormGameNo1': 'Please enter the platform game number',
  'sys.platFormFullName': 'Full name of platform',
  'sys.gameNameAndGameType': 'Platform name + game type',
  'sys.platformRate': 'Platform rate',
  'sys.platformRate1': 'Please enter platform rate',
  'sys.platformDesc': 'Platform description',
  'sys.platformDesc1': 'Please enter platform description',
  'sys.platformDesc2': 'Enter up to 255 characters',
  'sys.platformSort1': 'Please enter platform sort',
  'sys.platformSort2': 'From large to small in natural order',
  'sys.platformSort': 'Platform sorting',
  'sys.allPlatform': 'All platforms',
  'sys.fullName': 'full name',
  'sys.gameRate': 'Game rate',
  'sys.confirmDeleteGamePlatForm': 'Game platform {fullName} to be deleted',
  'sys.isHot': 'Is it popular?',
  'sys.hotSort': 'Popular sorting',
  'sys.addPlatFomr': 'Add platform',
  'sys.isMaintenance': 'Maintenance',
  'sys.changeHotSort': 'Modify the popular sorting of {value}',
  'sys.hotSort1': 'Please enter a hot sort',
  'sys.mailInfo1': 'Fill in email information',
  'sys.mailInfo2': 'Please enter email user name',
  'sys.mailInfo3': 'Please enter a mailbox user name less than 80 characters',
  'sys.mailPass': 'Mailbox password',
  'sys.mailPass1': 'Please enter email password',
  'sys.mailPass2': 'Please enter a mailbox password less than 80 characters',
  'sys.mailSMTP1': 'Please enter the SMTP address',
  'sys.mailSMTP2': 'Please enter an SMTP address with less than 200 characters',
  'sys.encryptionType': 'Encryption type',
  'sys.encryptionType1': 'Please select encryption type',
  'sys.encryptionType2': 'No encryption (most ports are 25)',
  'sys.ssl': 'SSL (most ports are 465)',
  'sys.tls': 'TLS (most ports are 587)',
  'sys.port': 'Port number',
  'sys.port1': 'Please enter the port number',
  'sys.deleteMail': 'Mailbox to be deleted: {username}',
  'sys.addMail': 'Add Email',
  'sys.addMailTemplate': 'Fill in message template information',
  'sys.templateName': 'Template name',
  'sys.templateName1': 'Please enter a template name',
  'sys.mailTitle': 'Mail title',
  'sys.mailTitle1': 'Please enter a message title',
  'sys.mailContent1': 'Please enter the message content',
  'sys.mailRemark': 'Mail notes',
  'sys.mailRemark1': 'Please enter email notes',
  'sys.deleteMailTemplate': 'Message template to be deleted: {name}',
  'sys.addTemplate': 'add template',
  'sys.allTemplate': 'All templates',
  'sys.buttonPermissionMgt': 'Button authority management',
  'sys.noticeDataPermissionMgt': 'Notification data authority management',
  'sys.noticePermission': 'Notification authority',
  'sys.pageDataPermissionMgt': 'Page data permission management',
  'sys.console': 'Console',
  'sys.deleteRole': 'Role to be deleted: {roleName}',
  'sys.roleName': 'Role name',
  'sys.roleSort': 'Role sequence',
  'sys.dataPermission': 'Data permissions',
  'sys.disableRole': 'Do you want to disable this role?',
  'sys.enableRole': 'Do you want to enable this role?',
  'sys.addRole': 'Add roles',
  'sys.inputRoleName': 'Please enter the role name',
  'sys.inputRoleSort': 'Please enter role order',
  'sys.payLine': 'payline',
  'sys.cumulativePrizePool': 'Cumulative pool',
  'sys.classGame': 'Classic game',
  'sys.eliminateMusic': 'Xiao Xiao le',
  'sys.electricHorn': 'Electric horn',
  'sys.gameId': 'Game ID',
  'sys.intoGameParam': 'Enter the game parameters and fill in carefully',
  'sys.isTryGame': 'Please select whether to support trial',
  'sys.payLine1': 'Please enter compensation line',
  'sys.uploadPcPic': 'Upload PC picture',
  'sys.oldPcPic': 'Old PC pictures:',
  'sys.oldH5Pic': 'Old H5 pictures:',
  'sys.uploadH5Pic': 'Upload H5 pictures',
  'sys.platformName': 'Platform name',
  'common.productName': 'Game stone',
  'common.changeLang': 'switch language',
  'common.page.showtotal': 'current total is {total} records',
  'common.page.pageInfo': 'Page {currentPage} of {totalPages}',
  'common.page.showSelectTotal': 'There are currently {total} items, and {select} items have been selected',
  'common.404': 'Four hundred and four',
  'common.unkonwException': 'Unknown anomaly',
  'common.unkonwError': 'Unknown anomaly',
  'common.requestException': 'Request exception',
  'common.requestException1': 'The request is abnormal. Please try again later.',
  'common.requestError1': 'Request failed, please try again!',
  'common.requestError': '{err}, please try again later.',
  'common.operateFail': 'operation failed',
  'common.action': 'Action',
  'common.delete': 'Delete',
  'common.operateSuccess': 'Successful operation',
  'common.operateSuccess1': 'Add success',
  'common.operateFail1': 'Operation failed, please try again later',
  'common.operateFail2': 'Operation failed, {message}',
  'common.export.loading': 'Exporting calculation',
  'common.export.success': 'Export succeeded!',
  'common.export.error': 'Export failed, export data is too large, please export in batches',
  'common.export.excel': 'export report',
  'common.export.noneExport': 'The current user has no exported data',
  'common.export': 'Export',
  'common.tip': 'Notice',
  'common.pleaseSelectDateRange': 'Please select a date range',
  'common.exportFailed': 'Export failed',
  'common.export.type': 'Export type',
  'common.export.type0': 'Regular member export',
  'common.export.type3': 'Total agent export',
  'common.export.notice': 'Please select the EXECL table content to generate',
  'common.Button.details': 'details',
  'common.Button.expandDetails': 'Unfolding details',
  'common.Button.collapseDetails': 'Collect details',
  'common.button.update': 'modify',
  'common.button.update.role': 'modify role',
  'common.button.delete': 'delete',
  'common.button.add': 'add',
  'common.queryFrm.search': 'search',
  'common.queryFrm.reset': 'Reset',
  'common.refresh': 'Refresh',
  'common.queryFrm.searchMore': 'More search',
  'common.queryFrm.searchClean': 'Clear search criteria',
  'common.queryFrm.searchHide': 'More searches are hidden. If search criteria are not cleared, click the button to clear search criteria',
  'common.queryFrm.keyWord': 'Key word',
  'common.queryFrm.nickName': 'nick name',
  'common.queryFrm.cleanAndClose': 'Clear and close',
  'common.queryFrm.searchUserAccountPhoneMail': 'User name / mobile phone / email',
  'common.queryFrm.searchUserAccountBetflowNumber': 'User name / serial number',
  'common.queryFrm.searchUserAccountRemark': 'User name / comment',
  'common.radio.minute': 'Minute',
  'common.radio.hour': 'hour',
  'common.radio.day': 'day',
  'common.radio.week': 'week',
  'common.radio.month': 'month',
  'common.radio.permanent': 'permanent',
  'common.radio.today': 'Today',
  'common.radio.yesterday': 'Yesterday',
  'common.radio.beforeYesterday': 'The day before yesterday',
  'common.radio.last7Day': 'The first 7 days',
  'common.radio.last15Day': 'The first 15 days',
  'common.radio.last30Day': 'The first 30 days',
  'common.radio.thisWeek': 'This week',
  'common.radio.lastWeek': 'Last week',
  'common.radio.thisMonth': 'This month',
  'common.radio.lastMonth': 'Last month',
  'common.radio.disable': 'Prohibit',
  'common.radio.enable': 'Enable',
  'common.radio.enableDisable': 'Please select whether to enable',
  'common.radio.enableDisable1': 'Is it enabled?',
  'common.radio.block': 'hide',
  'common.radio.display': 'display',
  'common.radio.blockDisplay': 'Is it enabled?',
  'common.radio.recommend': 'Recommend',
  'common.radio.notRecommend': 'Not recommended',
  'common.radio.recommendAndNotRecommend': 'Recommendation',
  'common.radio.pc': 'Computer terminal',
  'common.radio.mobile': 'Mobile terminal',
  'common.radio.pcAndMobile': 'Display platform',
  'common.radio.level1': 'Class A',
  'common.radio.level2': 'second level',
  'common.title.dataSummary': 'Data aggregation',
  'common.title.operate': 'operation',
  'common.title.serialNumber': 'Serial number',
  'common.title.userName': 'User name',
  'common.title.completeUserName': 'Please enter your complete member account number',
  'common.title.createAdmin': 'Founder',
  'common.title.createTime': 'Creation time',
  'common.title.updateAdmin': 'Operator',
  'common.title.settlement': 'Settlement',
  'common.title.noData': 'No data',
  'common.records': 'records',
  'common.queryFailed': 'Query failed',
  'common.search': 'Search',
  'common.reset': 'Reset',
  'common.title.updateTime': 'Operation time',
  'common.select.selectPlatform': 'Please select a platform',
  'common.select.allPlatform': 'All platforms',
  'common.select.selectType1': 'Selection type',
  'common.select.selectType': 'Please select the type',
  'common.select.allType': 'All types',
  'common.select.allWay': 'All ways',
  'common.select.allStatus': 'All States',
  'common.select.allDevice': 'All equipment',
  'common.select.allLevel': 'All levels',
  'common.select.selectChannel': 'Please select a channel',
  'common.select.init': 'Please choose',
  'common.select.allChannel': 'All channels',
  'common.select.init1': 'whole',
  'common.select.init2': 'Full configuration',
  'common.select.selectStatus': 'Please select status',
  'common.checkBox.selectAll': 'All election',
  'common.checkBox.selectAll2': 'Select all',
  'login.install.verify': 'Please install the verifier first',
  'login.input.username': 'enter one user name',
  'login.input.password': 'Please input a password',
  'login.submit': 'Sign in',
  'login.success': 'Login successfully',
  'login.please': 'Please login',
  'menu.index': 'home page',
  'menu.export': 'Data export',
  'menu.console': 'Console',
  'menu.queryMember': 'Membership list',
  'menu.queryNewMember': 'New users',
  'menu.queryDepositMember': 'Deposit user',
  'menu.queryActiveUser': 'Active users',
  'menu.queryProfitAndLossAccount': 'Lost and returned users',
  'menu.querySilentUser': 'Silent user',
  'menu.retainedUser': 'Retention analysis',
  'menu.userAnalysis': 'User analysis',
  'menu.memberContact': 'Membership information',
  'menu.memberWithdrawalInformation': 'Member Withdrawal Information',
  'menu.member': 'Membership management',
  'menu.bonusSetting': 'Preferential settings',
  'menu.bonusUpperLimit': 'bonus upper limit',
  'menu.bonusActivities': 'Activities',
  'menu.operation.bonus.bonusArticle': 'Article management',
  'menu.bonusImport': 'Batch distribution',
  'menu.operation.bonus.bonusApplyRole': 'Mutex settings',
  'menu.bonusReport': 'Collection records',
  'menu.bonusWinOrLoseReport': 'Profit and loss statistics',
  'menu.bonus': 'Preferential system',
  'menu.setting': 'VIP level setting',
  'menu.vip': 'Membership level management',
  'menu.announcement': 'Announcement management',
  'menu.operation.frontContent.articleMgmt': 'Article management',
  'menu.operation.frontContent.articleTypeMgmt': 'Article type management',
  'menu.gamePlatformLogo': 'Game platform icon management',
  'menu.operation.frontContent.pageMgmt': 'Page management',
  'menu.frontContent': 'Front desk content management',
  'menu.activitySetting': 'Small game settings',
  'menu.activitySyntheticLog': 'Synthesis game pickup record',
  'menu.activityCashTurnLog': 'Cash Wheel Records',
  'menu.activityLog': 'Small game lottery record',
  'menu.activityUserCount': 'Small game quota record',
  'menu.operation.activity.checkin': 'Sign in reward record',
  'menu.operation.activity.integralExchange': 'Points exchange record',
  'menu.activity': 'Small game management',
  'menu.operation.upgrade.upgradeSetting': 'Level setting',
  'menu.operation.upgrade.upgradeUser': 'Player list',
  'menu.operation.upgrade.upgradeReport': 'Issue record',
  'menu.operation.upgrade': 'Upgrade mode',
  'menu.sendSiteMsg': 'Send in station message',
  'menu.inbox': 'Inbox',
  'menu.siteMsg': 'mail',
  'menu.sendMail': 'Mail delivery',
  'menu.operation.queryPushMessageList': 'Push management',
  'menu.operation': 'Operation center',
  'menu.information.sixLottery.queryGroupList': 'gallery',
  'menu.information.sixLottery.queryTopicList': 'Posting management',
  'menu.information.sixLottery.queryReplyList': 'Reply management',
  'menu.information.sixLottery.queryPushMessageList': 'Push management',
  'menu.information.sixLottery.queryComplaintList': 'Complaint management',
  'menu.information.sixLottery': 'Mark Six ',
  'menu.information.lotteryUserTrace.lotteryUserLevel': 'Membership level',
  'menu.information.lotteryUserTrace.lotteryUserAttention': 'Members concerns',
  'menu.information.lotteryUserTrace.lotteryUserApprove': 'Members praise',
  'menu.configPictureGroup': 'Picture group configuration',
  'menu.agentWithdraw': 'Withdrawal request',
  'menu.settingGamePlatform': 'Game platform settings',
  'menu.pixel': 'Pixel management',
  'menu.statistics': 'Push statistics',
  'menu.push': 'Push record',
  'menu.name': 'Name management',
  'menu.userPush': 'User push record',

  'menu.yyg': 'YYG management',
  'menu.yygOrder': 'Order management',
  'menu.yygConfig': 'System setting',
  'menu.yygCommodity': 'Commodity management',
  'menu.yygSummaryMain': 'Data statistic',
  'menu.yygData': 'Data management',
  'menu.yygSummaryDetail': 'Data detail',
  'menu.yygMutiple': 'Mutiple platform lang setting',
  'menu.yygPlatform': 'Mutiple platform',
  'menu.yygList': 'Commodity list',
  'menu.yygCategory': 'Commodity category',
  'menu.yygPlan': 'Commodity plan',

  'constants.riskLevelType_20': 'Increase deposit method',
  'constants.riskLevelType_10': 'Smooth deposits',
  'constants.riskLevelType_0': 'ordinary',
  'constants.riskLevelType_-9': 'Limit the return of water from time to time',
  'constants.riskLevelType_-20': 'Restricted withdrawals',
  'constants.riskLevelType_-30': 'Restricted login',
  'constants.gameType_1': 'video game',
  'constants.gameType_2': 'Live game',
  'constants.gameType_3': 'Sports',
  'constants.gameType_4': 'lottery',
  'constants.gameType_5': 'fishing',
  'constants.gameType_6': 'Chess',
  'constants.transferType_1': 'Background increase or decrease',
  'constants.transferType_2': 'deposit',
  'constants.transferType_3': 'Cash withdrawal',
  'constants.transferType_4': 'Switch to game',
  'constants.transferType_5': 'Out of the game',
  'constants.transferType_8': 'Preferential / rescue, etc',
  'constants.transferType_9': 'Manual deposit',
  'constants.transferType_10': 'Manual removal',
  'constants.transferType_14': 'Specified domain name invitation reward',
  'constants.transferType_15': 'Rewards for everyone',
  'constants.transferType_17': 'Invitation rewards for everyone',
  'constants.regSourceType_0': 'Self registration',
  'constants.regSourceType_1': 'agent',
  'constants.regSourceType_2': 'Advertisement',
  'constants.regSourceType_3': 'Tele-marketing',
  'constants.gameSlot_NEWBBIN': 'New bbin Slot',
  'constants.gameSlot_BBIN': 'BBIN',
  'constants.gameSlot_NEWPT': 'New Pt Slot',
  'constants.gameSlot_NEWSA': 'New SA Slot',
  'constants.gameSlot_PT': 'PT',
  'constants.gameSlot_MG': 'MG',
  'constants.gameSlot_HB': 'HB',
  'constants.gameSlot_JDB': 'JDB',
  'constants.gameSlot_DT': 'DT',
  'constants.gameSlot_VT': 'VT',
  'constants.gameSlot_PNG': 'PNG',
  'constants.gameSlot_AMEBA': 'AMEBA',
  'constants.gameSlot_SKYWIND': 'Skywind',
  'constants.gameSlot_CQ9': 'CQ9',
  'constants.gameSlot_GNS': 'GNS',
  'constants.gameSlot_GSS': 'GSS',
  'constants.gameSlot_AB': 'AB',
  'constants.gameSlot_REDTIGER': 'Red tiger',
  'constants.gameSlot_SA': 'SA',
  'constants.gameSlot_NETENT': 'NetEnt',
  'constants.gameSlot_BETSOFT': 'BetSoft',
  'constants.gameSlot_PLAYSTAR': 'PlayStar',
  'constants.gameSlot_SG': 'SG',
  'constants.gameSlot_RTG': 'RTG',
  'constants.gameSlot_QT': 'QT',
  'constants.gameSlot_PGSOFT': 'Pgsoft',
  'constants.gameSlot1_PG': 'Pgsoft',
  'constants.gameSlot_LG': 'LG',
  'constants.gameSlot_ISOFTBET': 'Isoftbet',
  'constants.gameSlot_KingMaker': 'KM Slot',
  'constants.gameSlot_CG': 'CG Slot',
  'constants.gameSlot_CRG': 'CRG Slot',
  'constants.gameSlot_PP': 'PP Slot',
  'constants.gameSlot_SEA': 'SEA Slot',
  'constants.gameSlot_FC': 'FC',
  'constants.gameSlot_YESBINGO': 'YESBINGO',
  'constants.gameSlot_SPRIBE': 'SPRIBE',
  'constants.gameSlot_BNG': 'BNG',
  'constants.gameSlot_MW': 'MW',
  'constants.gameSlot_WG': 'WG',
  'constants.gameSlot_PCLASSICG': 'PCLASSICG',
  'constants.gameSlot1_MW': 'MW',
  'constants.gameSlot_FUNKY': 'FUNKY Slot',
  'constants.gameSlot1_JILISLOT': 'JILI',
  'constants.gameSlot1_JILI': 'JILI',
  'constants.gameSlot1_PHJILISLOT': 'PHJILI',
  'constants.gameSlot1_TTG': 'TTG Slot',
  'constants.gameSlot1_PGO': 'Play\'n GO Slot',
  'constants.gameSlot1_RT': 'Red Tiger Slot',
  'constants.gameSlot1_PRAP': 'PRAGMATIC PLAY Slot',
  'constants.gameSlot1_PST': 'PLAYSTAR Slot',
  'constants.gameSlot1_RICH': 'Rich88 Slot',
  'constants.gameSlot1_FUNKY': 'FUNKY Slot',
  'constants.gameSlot1_YESBINGO': 'YESBINGO',
  'constants.gameSlot1_SPRIBE': 'SPRIBE',
  'constants.gameSlot1_BNG': 'BNG',
  'constants.gameSlot1_NEWAG': 'NEWAG',
  'constants.gameSlot1_AG': 'AG',
  'constants.gameSlot1_WG': 'WG',

  'constants.gameSlot1_SPB': 'Spribe Arcade',
  'constants.gameSlot1_OBDZ': 'OBDZ Slot',
  'constants.gameSlot1_PHPREDTIGER': 'RedTiger Slot',
  'constants.gameSlot1_FC': 'FC',
  'constants.gameSlot1_PHPSG': 'SG',
  'constants.gameSlot1_RICH88': 'RICH 88',
  'constants.gameSlot1_FCSLOT': 'FC Slot',
  'constants.gameSlot1_SEA': 'SEA',

  'constants.vipValidType_0': 'permanent',
  'constants.vipValidType_1': 'Effective immediately, 30 days',
  'constants.vipValidType_3': 'Effective Immediate, 365 days',
  'constants.vipValidType_5': 'Effective immediately, 60 days',
  'constants.vipValidType_6': 'Effective immediately, 90 days',
  'constants.status_0': 'Disabled',
  'constants.status_1': 'Enabled',
  'constants.bonusType_17': 'Bet upgrade offer',
  'constants.newBonusType_1': 'Preferential water treatment',
  'constants.newBonusType_2': 'Deposit discount',
  'constants.newBonusType_3': 'Invitation to discount',
  'constants.newBonusType_5': 'Manual review offer',
  'constants.newBonusType_7': 'Registration preferences',
  'constants.newBonusType_8': 'Preferential deposit channels',
  'constants.newBonusType_9': 'Note preference',
  'constants.newBonusType_10': 'Betting preference',
  'constants.newBonusType_11': 'Water return discount',
  'constants.newBonusType_12': 'Real time deposit offer',
  'constants.newBonusType_13': 'Information binding offer',
  'constants.newBonusType_14': 'Lottery discount',
  'constants.newBonusType_15': 'Sign in bonus',
  'constants.newBonusType_16': 'Continuous deposit and investment preference',
  'constants.newBonusType_19': 'Daily task discount',
  'constants.newBonusType_24': 'Invitation to discount(New)',// 新邀请优惠
  'constants.newBonusType_26': 'Coded red envelope',
  'constants.newBonusType_30': 'Big Spin Offer',
  'constants.newBonusType_31': 'Accumulative deposit and investment concessions',
  'constants.newBonusType_32': 'Game pen save',
  'constants.newBonusType_33': 'Preferential withdrawal channels',
  'constants.newBonusType_34': 'Seven-day deposit offer',
  'constants.newBonusType_38': 'Recharge page discount',
  'constants.bonusMainType_A': 'Rescue fund',
  'constants.bonusMainType_B': 'Upgrade bonus',
  'constants.bonusMainType_C': 'Continue bonus',
  'constants.bonusMainType_D': 'Deposit requirement',
  'constants.bonusMainType_0': 'Add offers in the background',
  'constants.bonusMainType_1': 'Preferential water treatment',
  'constants.bonusMainType_2': 'Deposit discount',
  'constants.bonusMainType_3': 'Invitation to discount',
  'constants.bonusMainType_4': 'Sign in preference',
  'constants.bonusMainType_5': 'Manual review offer',
  'constants.bonusMainType_6': 'Continuous deposit preference',
  'constants.bonusMainType_7': 'Registration preferences',
  'constants.bonusMainType_8': 'Preferential deposit channels',
  'constants.bonusMainType_9': 'Note preference',
  'constants.bonusMainType_10': 'Betting preference',
  'constants.bonusMainType_11': 'Water return discount',
  'constants.bonusMainType_12': 'Real time deposit offer',
  'constants.bonusMainType_13': 'Information binding offer',
  'constants.bonusMainType_14': 'Lottery discount',
  'constants.bonusMainType_15': 'Sign in bonus',
  'constants.bonusMainType_16': 'Continuous deposit and investment preference',
  'constants.bonusMainType_18': 'Small game lottery',
  'constants.bonusMainType_19': 'Daily task discount',
  'constants.bonusMainType_24': 'Invitation to discount', // 新邀请优惠
  'constants.bonusMainType_26': 'Coded red envelope',
  'constants.bonusMainType_30': 'Big Spin Offer',
  'constants.bonusMainType_31': 'Accumulative deposit and investment concessions',
  'constants.bonusMainType_32': 'Game pen save',
  'constants.bonusMainType_33': 'Preferential withdrawal channels',
  'constants.bonusMainType_34': 'Seven-day deposit offer',
  'constants.bonusMainType_38': 'Recharge page discount',
  'constants.newBonusMainType_A': 'Rescue fund',
  'constants.newBonusMainType_B': 'Upgrade bonus',
  'constants.newBonusMainType_C': 'Continue bonus',
  'constants.newBonusMainType_0': 'Add bonus manually',
  'constants.newBonusMainType_1': 'Preferential water treatment',
  'constants.newBonusMainType_2': 'Deposit discount',
  'constants.newBonusMainType_3': 'Invitation to discount',
  'constants.newBonusMainType_5': 'Manual review offer',
  'constants.newBonusMainType_7': 'Registration preferences',
  'constants.newBonusMainType_8': 'Preferential deposit channels',
  'constants.newBonusMainType_9': 'Note preference',
  'constants.newBonusMainType_10': 'Betting preference',
  'constants.newBonusMainType_11': 'Water return discount',
  'constants.newBonusMainType_12': 'Real time deposit offer',
  'constants.newBonusMainType_13': 'Information binding offer',
  'constants.newBonusMainType_14': 'Lottery discount',
  'constants.newBonusMainType_15': 'Sign in bonus',
  'constants.newBonusMainType_16': 'Continuous deposit and investment preference',
  'constants.newBonusMainType_17': 'Bet upgrade offer',
  'constants.newBonusMainType_18': 'Small game lottery',
  'constants.newBonusMainType_19': 'Daily task discount',
  'constants.newBonusMainType_24': 'New Invitation to discount',
  'constants.newBonusMainType_26': 'Coded red envelope',
  'constants.newBonusMainType_21': 'New sign-in points offer',
  'constants.newBonusMainType_28': 'First withdrawal offer',
  'constants.newBonusMainType_29': 'Resurrection offer',
  'constants.newBonusMainType_30': 'Big Spin Offer',
  'constants.newBonusMainType_31': 'Accumulative deposit and investment concessions',
  'constants.newBonusMainType_32': 'Game pen save',
  'constants.newBonusMainType_33': 'Preferential withdrawal channels',
  'constants.newBonusMainType_34': 'Seven-day deposit offer',
  'constants.newBonusMainType_38': 'Recharge page discount',

  'constants.bonusStatus_0': 'Application',
  'constants.bonusStatus_1': 'In calculation',
  'constants.bonusStatus_2': 'Completed',
  'constants.bonusStatus_3': 'refuse',
  'constants.bonusStatus_4': 'fail',
  'constants.bonusStatus_5': 'Uncollected',
  'constants.bonusStatus_6': 'Not pumped out',
  'constants.ticketStatus_0': 'Submitted',
  'constants.ticketStatus_1': 'In processing',
  'constants.ticketStatus_2': 'Processing completed',
  'constants.bonusConfigStatus_0': 'Editor',
  'constants.gameMaintain_0': 'Unmaintained',
  'constants.gameMaintain_1': 'Maintenance',
  'constants.payLevel_0': 'Available for first level members only',
  'constants.payLevel_1': 'All members',
  'constants.payLevel_2': 'Secondary and above members',
  'constants.payLevel_3': 'Level 3 and above members',
  'constants.payLevel_4': 'Level 4 and above members',
  'constants.payLevel_5': 'Level 5 and above members',
  'constants.payLevel_6': 'Level 6 and above members',
  'constants.payLevel_7': 'Level 7 and above members',
  'constants.payLevel_8': 'Level 8 and above members',
  'constants.payLevel_9': 'Level 9 and above',
  'constants.payLevel_10': 'Class ten member',
  'constants.logType_ad': 'Advertisement',
  'constants.logType_admin': 'Background account',
  'constants.logType_agent': 'agent',
  'constants.logType_bonus': 'Discount',
  'constants.logType_button': 'Button',
  'constants.logType_config': 'System configuration parameters',
  'constants.logType_custom': 'Worksheet information',
  'constants.logType_domain': 'domain name',
  'constants.logType_platform': 'Game platform',
  'constants.logType_ip': 'IP',
  'constants.logType_market': 'Tele-marketing',
  'constants.logType_menu': 'menu',
  'constants.logType_notify': 'notice',
  'constants.logType_pay': 'payment',
  'constants.logType_risk': 'Risk management',
  'constants.logType_role': 'role',
  'constants.logType_withdraw': 'Cash withdrawal',
  'constants.logType_user': 'user',
  'constants.logType_picture': 'Picture configuration',
  'constants.logType_announcement': 'Notice',
  'constants.logType_login': 'Backstage login',
  'constants.logType_logout': 'Background exit',
  'constants.agentOtherType_0': 'refund',
  'constants.agentOtherType_1': 'Market cost',
  'constants.sysAdminType_-1': 'Super administrator',
  'constants.sysAdminType_-2': 'Administrators',
  'constants.activityType_1': 'wheel of fortune ',
  'constants.activityType_2': 'Shake',
  'constants.activityType_3': 'Synthesis games',
  'constants.activityType_4': 'Blind box draw',
  'constants.activityType_5': 'Cash Turntable games',
  'constants.activityChannelType_0': 'System increase',
  'constants.activityChannelType_1': 'Manual increase',
  'constants.activityChannelType_2': 'Draw decline',
  'constants.activityChannelType_3': 'Manual deletion',
  'constants.prizeType_0': 'cash',
  'constants.prizeType_1': 'Other',
  'constants.prizeType_2': 'No prize',
  'constants.prizeType_3': 'Points',
  'constants.announcementType_6': 'Notice',
  'constants.announcementType_7': 'Recommend',
  'constants.frontType_0': 'PC terminal',
  'constants.frontType_1': 'Mobile terminal',
  'constants.frontType_3': 'Full platform',
  'constants.siteMsgType_0': 'Deposit and withdrawal problems',
  'constants.siteMsgType_1': 'Preferential activities',
  'constants.siteMsgType_2': 'Game problem',
  'constants.siteMsgType_3': 'Other questions',
  'constants.siteMsgType_4': 'proposal',
  'constants.siteMsgType_5': 'Complaint',
  'constants.manualType_1': 'Manual adjustment of accounts',
  'constants.manualType_9': 'Manual deposit',
  'constants.manualType_10': 'Manual removal',
  'constants.gameSlot1_BBIN': 'BBIN',
  'constants.gameSlot1_NEWBBIN': 'New bbin Slot',
  'constants.gameSlot1_PT': 'PT',
  'constants.gameSlot1_NEWPT': 'New Pt Slot',
  'constants.gameSlot1_MG': 'MG',
  'constants.gameSlot1_HB': 'HB',
  'constants.gameSlot1_JDB': 'JDB',
  'constants.gameSlot1_JDB2': 'JDB2',
  'constants.gameSlot1_DT': 'DT',
  'constants.gameSlot1_VT': 'VT',
  'constants.gameSlot1_PNG': 'PNG',
  'constants.gameSlot1_AMEBA': 'AMEBA',
  'constants.gameSlot1_TP': 'TP',
  'constants.gameSlot1_FKJILI': 'FKJILI',
  'constants.gameSlot1_FKJILI1': 'FKJILI1',
  'constants.gameSlot1_FKPG': 'FKPG',
  'constants.gameSlot1_FKPG1': 'FKPG1',
  'constants.gameSlot1_OMGPG': 'OMGPG',
  'constants.gameSlot1_OMGJILI': 'OMGJILI',
  'constants.gameSlot1_OMGPP': 'OMGPP',
  'constants.gameSlot1_JS2PG': 'JS2PG',
  'constants.gameSlot1_GB': 'GB',
  'constants.gameSlot1_YL': 'YL',
  'constants.gameSlot1_PCLASSICG': 'PCLASSICG',
  'constants.gameSlot1_WMDZ': 'WMDZ',
  'constants.gameSlot1_NS': 'NEXTSPIN',
  'constants.gameSlot1_WM': 'WM',
  'constants.gameSlot1_KA': 'KA',
  'constants.gameSlot1_CRG': 'CRG',
  'constants.gameSlot1_FTG': 'FTG',
  'constants.gameSlot1_VA': 'VA',
  'constants.gameSlot1_ASKME': 'ASKME',
  'constants.gameSlot1_OMG': 'OMG',
  'constants.gameSlot1_VNRICH88': 'VNRICH88',
  'constants.gameSlot1_VNRTG': 'VNRTG',
  'constants.gameSlot1_JL': 'JL',
  'constants.gameSlot1_PP': 'PP',
  'constants.gameSlot1_SKYWIND': 'Skywind',
  'constants.gameSlot1_CQ9': 'CQ9',
  'constants.gameSlot1_GNS': 'GNS',
  'constants.gameSlot1_GSS': 'GSS',
  'constants.gameSlot1_AB': 'AB',
  'constants.gameSlot1_REDTIGER': 'Red tiger',
  'constants.gameSlot1_SA': 'SA',
  'constants.gameSlot1_SA2': 'New SA',
  'constants.gameSlot1_MG2': 'MG2',
  'constants.gameSlot1_MG3': 'MG3',
  'constants.gameSlot1_NETENT': 'NetEnt',
  'constants.gameSlot1_BETSOFT': 'BetSoft',
  'constants.gameSlot1_PLAYSTAR': 'Playstar',
  'constants.gameSlot1_SG': 'SG',
  'constants.gameSlot1_RTG': 'RTG',
  'constants.gameSlot1_QT': 'QT',
  'constants.gameSlot1_PGSOFT': 'Pgsoft',
  'constants.gameSlot1_LG': 'LG',
  'constants.gameSlot1_ISOFTBET': 'Isoftbet',
  'constants.gameSlot1_TOTALEGAME': 'Totalegame',
  'constants.gameLive2_AG': 'AG',
  'constants.gameLive2_NEWAG': 'New AG',
  'constants.gameLive2_EBET': 'EBET',
  'constants.gameLive2_OG': 'OG',
  'constants.gameLive2_OG1': 'OG1',
  'constants.gameLive2_BG': 'BG',
  'constants.gameLive2_BG2': 'New BG',
  'constants.gameLive2_GD': 'GD',
  'constants.gameLive2_EG': 'EG real person',
  'constants.gameLive2_SB': 'SB Live',
  'constants.gameLive2_TS': 'TS Live',
  'constants.gameLive2_DG': 'DreamGame',
  'constants.gameLive2_SEXY': 'Sexy Live',
  'constants.gameLive2_VENUS': 'Venus Live',
  'constants.gameLive2_MAYE': 'Maya Live',
  'constants.gameLive2_AB': 'AB',
  'constants.gameLive2_BBIN': 'BBIN',
  'constants.gameLive2_NEWBBIN': 'NEWBBIN',
  'constants.gameLive2_SA': 'SA',
  'constants.gameLive2_TP': 'TP',
  'constants.gameLive2_GPI': 'GPI',
  'constants.gameLive2_NEWSA': 'New SA',

  'constants.gameSport3_XSPORT': 'HAHA Sport',
  'constants.gameSport3_AVIA': 'AVIA E-sports',
  'constants.gameSport3_IBC': 'IBC Sports',
  'constants.gameSport3_UG': 'UG Sports',
  'constants.gameSport3_UG2': 'UG Sports',
  'constants.gameSport3_PINGBO': 'PINGBO Sports',
  'constants.gameSport3_BETLINK': 'BetLink Sports',
  'constants.gameSport3_IM': 'IM Sports',
  'constants.gameSport3_IMDJ': 'IM Sports',
  'constants.gameSport3_XINBAO': 'XINBAO Sports',
  'constants.gameSport3_IBC2': 'IBC2 ESports',
  'constants.gameSport3_ESPORTS': 'ESports',
  'constants.gameSport3_THREESING': '3 liters of sports',
  'constants.gameSport3_UWIN': 'UWIN E-sports',
  'constants.gameSport3_DSDJ': 'Dongsen E-sports',
  'constants.gameSport3_SPB': 'SPB Arcade',
  'constants.gameSport3_PHSBO': 'SBO Sport',
  'constants.gameSport3_NEWIM': 'NEW IM',
  'constants.gameLottery4_CQ': 'ST lottery',
  'constants.gameLottery4_VR': 'VR lottery',
  'constants.gameLottery4_VL': 'VL lottery',
  'constants.gameLottery4_KG': 'KG lottery',
  'constants.gameLottery4_DSEN': 'DSEN lottery',
  'constants.gameLottery4_TCG': 'TCG lottery',
  'constants.gameLottery4_TCG_VN': 'TCG lottery',
  'constants.gameLottery4_IG_GFC': 'IG official colors',
  'constants.gameLottery4_GS': 'Local lottery',
  'constants.gameLottery4_DBCP': 'DB lottery',
  'constants.gameLottery4_NEWDB': 'DB lottery',
  'constants.gameLottery4_TP': 'TP',
  'constants.gameLottery4_BBIN': 'BBIN',
  'constants.gameLottery4_DB': 'DB lottery',
  'constants.gameLottery4_SPRIBE': 'SPRIBE lottery',
  'constants.gameLottery4_CG': 'CG lottery',
  'constants.gameLottery4_QQK': 'QQKeno lottery',
  'constants.gameLottery4_FG': 'Funky Games lottery',
  'constants.gameLottery4_SEA': 'Sealotto lottery',
  'constants.gameLottery4_YESB': 'YES BINGO lottery',
  'constants.gameLottery4_YESBINGO': 'YES BINGO lottery',
  'constants.gameLottery4_AE': 'AE',

  'constants.gameFish5_GG': 'GG fishing',
  'constants.gameFish5_BBIN': 'BBIN',
  'constants.gameFish5_NEWBBIN': 'NEWBBIN',
  'constants.gameFish5_SA': 'SA',
  'constants.gameFish5_SA2': 'New SA',
  'constants.gameFish5_AG': 'AG',
  'constants.gameFish5_NEWAG': 'New AG',
  'constants.gameFish5_OBBY': 'OBBY',
  'constants.gameChess6_OBQP': 'DB Chess',
  'constants.gameFish5_JILI': 'JILI',
  'constants.gameFish5_TP': 'TP',
  'constants.gameFish5_YL': 'YL',
  'constants.gameFish5_KA': 'KA',
  'constants.gameFish5_VA': 'VA',
  'constants.gameFish5_FTG': 'FTG',
  'constants.gameFish5_PLAYSTAR': 'PLAYSTAR',
  'constants.gameFish5_ASKME': 'ASKME',
  'constants.gameFish5_VNRTG': 'VNRTG',
  'constants.gameFish5_FC': 'FC',
  'constants.gameFish5_YESBINGO': 'YESBINGO',
  'constants.gameFish5_LUCKY': 'Lucky',
  'constants.gameFish5_PHPSG': 'SG',
  'constants.gameFish5_WG': 'WG',

  'constants.gameFish5_ACE': 'ACE Fish',
  'constants.gameFish5_SGFISH': 'SG Fish',
  'constants.gameFish5_JDB': 'JDB',
  'constants.gameFish5_PHJILI': 'PHJILI',
  'constants.gameChess6_KY': 'KY Chess',
  'constants.gameChess6_LUCKY': 'LUCKY Chess',
  'constants.gameChess6_V8': 'V8 Chess',
  'constants.gameChess6_LY': 'LY Chess',
  'constants.gameChess6_YL': 'YL Chess',
  'constants.gameChess6_KM': 'KM Chess',
  'constants.gameChess6_TP': 'TP',
  'constants.gameChess6_VNRICH88': 'VNRICH88',
  'constants.gameChess6_FTG': 'FTG',
  'constants.gameChess6_PHJILI': 'PHJILI',
  'constants.gameChess6_WG': 'WG',
  'constants.gameChess6_KINGMAKER_CHESS': 'KINGMAKER Chess',
  'constants.gameChess6_VG': 'VG Chess',
  'constants.gameChess6_SSO761': '761 Chess',
  'constants.gameChess6_LEG': 'LEG Chess',
  'constants.gameChess6_CS': 'Fortune Chess',
  'constants.gameChess6_GAMMA': 'Gama Chess',
  'constants.gameChess6_HT': 'Spade Chess',
  'constants.gameChess6_JILI': 'JILI',
  'constants.gameChess6_PHKM': 'KM Chess',

  'constants.platforms_BBIN': 'BBIN',
  'constants.platforms_NEWBBIN': 'NEWBBIN',
  'constants.platforms_SA': 'SA',
  'constants.platforms_SA2': 'New SA',
  'constants.platforms_NEWSA': 'New SA',
  'constants.platforms_AG': 'AG',
  'constants.platforms_NEWAG': 'New AG',
  'user.searchUser': 'User found, user name: {userAccount}',
  'user.searchUserFail': 'User not found',
  'user.logout': 'Logout',
  'user.changePass': 'Change Password',
  'user.title.message': 'news',
  'user.title.memberGroup': 'Member Group',
  'user.empty.message': 'You have read all the messages',
  'user.icon.online': 'On-line',
  'user.button.confirm': 'confirm',
  'user.form.oldPass': 'Please enter the old password',
  'user.form.newPass': 'Please enter a new password',
  'user.form.newPassAgain': 'Please enter the new password again',
  'msg.clear': 'clear',
  'msg.allRead': 'All read',
  'msg.closeBeep': 'Turn off the tone',
  'msg.openBeep': 'Prompt tone on',
  'bet.title.platformCode': 'Platform number',
  'bet.title.betAmount': 'Amount of bet',
  'bet.title.betflow': 'Effective sum',
  'common.title.resultAmount': 'Platform profitability',
  'bet.title.betTime': 'Bet time',
  'bet.title.createTime': 'Settling time',
  'pay.label.pageAmount': 'Amount of this page',
  'pay.label.pageUnTotal': 'Number of cash orders in the application on this page',
  'pay.label.pageRiskSuccess': 'Number of over drawn orders reviewed by risk control on this page',
  'pay.label.pageSuccess': 'Number of orders successfully withdrawn for payment on this page',
  'pay.label.pageRefuse': 'Number of orders refused to withdraw on this page',
  'pay.label.amount': 'Total sum',
  'pay.label.unTotal': 'Number of cash orders in total application',
  'pay.label.riskSuccessTotal': 'Number of over drawn orders reviewed by general risk control',
  'pay.label.successTotal': 'Total number of orders successfully withdrawn',
  'pay.label.refuseTotal': 'Total rejected cash orders',
  'bet.label.pageBet': 'Bet amount on this page (yuan)',
  'bet.label.pageBetVN': 'Bet amount on this page (VND)',
  'bet.label.pageFlow': 'Effective bet on this page (yuan)',
  'bet.label.pageFlowVN': 'Effective bet on this page (VND)',
  'bet.label.pageProfit': 'Platform profit on this page (yuan)',
  'bet.label.pageProfitVN': 'Platform profit on this page (VND)',
  'bet.label.totalBet': 'Total bet (yuan)',
  'bet.label.totalBetVN': 'Total bet (VND)',
  'bet.label.totalFlow': 'Total effective bet (yuan)',
  'bet.label.totalFlowVN': 'Total effective bet (VND)',
  'bet.label.totalProfit': 'Total platform profit (yuan)',
  'bet.label.totalProfitVN': 'Total platform profit (VND)',
  'bet.strAttr1.game': 'Game',
  'bet.strAttr1.platType': 'take laws and regulations lightly',
  'bet.strAttr1.period': 'Bureau number',
  'bet.strAttr1.titleNumber': 'Table number',
  'bet.strAttr1.result': 'Result',
  'game.platform.order': 'Platform No.: {gsId}',
  'game.game.order': 'Game No.: {bizNo}',
  'bet.export.exportName': 'Export of betting record',
  'bet.export.title': 'Export hint',
  'bet.export.content': 'The export task has entered the export queue. Click OK to view the export progress. You can also view the download later through the console - > Data Export',
  'bet.queryFrm.betDate': 'Bet time',
  'bet.queryFrm.createDate': 'Settling time',
  'bet.queryFrm.platformCode': 'Game platform',
  'bet.queryFrm.gameType': 'Game type',
  'bet.select.gameType': 'Please select game type',
  'user.chart.memberCount': 'Number of members',
  'user.chart.memberCount1': 'Number of users (person)',
  'user.title.activeUser': 'Active users',
  'user.title.peopleNumber': 'Number',
  'user.title.register': 'register',
  'common.chart.orderCount': 'Single volume (1000 strokes)',
  'common.chart.orderCount1': 'Single volume',
  'common.chart.betOrderCount': 'Volume of betting',
  'common.chart.date': 'date',
  'common.chart.date1': 'Please select a date',
  'common.chart.percentage': 'Percentage',
  'common.chart.user': 'user',
  'common.chart.count': 'Number',
  'common.chart.amount': 'Amount (10000 yuan)',
  'common.chart.amount1': 'Amount of money',
  'common.chart.amount3': 'Amount (yuan)',
  'common.chart.amount3VN': 'Amount (VND)',
  'common.chart.validBet': 'Effective bet',
  'common.chart.amount2': 'Amount (thousand yuan)',
  'bet.chart.bettingSettlement': 'Betting settlement',
  'finance.title.prompt': 'Tips',
  'finance.content.prompt': 'Do you want to include it in the deposit?',
  'finance.content.prompt2': 'Do you want to not include it in the deposit?',
  'bet.title.userAccount': 'Member name',
  'bet.title.ticketNumber': 'Ticket Number',
  'finance.title.transNoAndTransName': 'Order No. / name',
  'finance.title.transName': 'Name: {transDetail}',
  'finance.title.transType': 'Account adjustment type',
  'finance.title.amount': 'Amount of account adjustment',
  'finance.title.transType1': 'mode',
  'finance.title.transType1_1': 'Unaccounted for',
  'finance.title.transType1_9': 'Credited to deposit',
  'finance.title.transType1_10': 'Accounting for withdrawals',
  'finance.title.afterAmount': 'After balance',
  'finance.title.remark': 'Remarks',
  'finance.title.remark1': 'Please enter comments',
  'finance.title.createTimeAndCreateAdmin': 'createTimeAndCreateAdmin',
  'finance.title.updateTimeAndUpdateAdmin': 'updateTimeAndUpdateAdmin',
  'finance.title.totalAmount': 'Total sum',
  'finance.title.totalOrderCount': 'Total stroke number',
  'finance.button.call': 'Call up',
  'finance.export.name': 'Reconciliation report.xls',
  'finance.queryFrm.ManualTransferDate': 'Adjusting account time',
  'finance.queryFrm.ManualTransferType': 'Account adjustment type',
  'finance.queryFrm.urmoo': 'User name, remark, account adjuster, order number, order name',
  'finance.queryFrm.urmoo2': 'Please enter remarks/account adjuster keywords',
  'user.title.name': 'Full name',
  'user.title.mobilePhone': 'Full name',
  'user.title.idNo': 'Contact number',
  'user.title.regType': 'source',
  'user.title.domain': 'Last login URL',
  'user.title.registerTime': 'Registration date',
  'user.title.createTime': 'Online time',
  'user.title.level': 'Level | risk control level',
  'user.title.totalDeposit': 'Total deposit',
  'user.title.totalWithdraw': 'Total withdrawals',
  'user.title.totalBonus': 'Total discount',
  'user.title.balance': 'Master account total balance',
  'user.description.totalUserNum': 'Online number',
  'user.description.totalDeposit': 'Total deposits of current online members',
  'user.description.totalWithdraw': 'Total withdrawal of current online members',
  'user.description.totalBonus': 'Total offers for current online members',
  'user.description.totalBetFlow': 'Current total online membership flow',
  'user.radio.onlineUserType_-1': 'No Selected',
  'user.radio.onlineUserType_1': 'Total deposit',
  'user.radio.onlineUserType_2': 'Total withdrawals',
  'user.radio.onlineUserType_3': 'Total discount',
  'user.radio.onlineUserType_4': 'Current balance',
  'user.select.channelType_1': 'Not Selected',
  'user.select.channelType_0': 'Total deposit',
  'user.select.channelType_4': 'Total withdrawals',
  'user.select.channelType_2': 'Total discount',
  'user.select.channelType_3': 'Current balance',
  'sys.title.createTime': 'Operation time',
  'sys.title.createAdmin': 'Operator',
  'sys.title.beingAdmin': 'Operator',
  'sys.title.operatingMsg': 'Operation instructions',
  'sys.title.resultMsg': 'The result shows',
  'sys.title.logType': 'Log type',
  'sys.title.operatingStatus': 'Operation state',
  'sys.title.operatingStatusFail': 'fail',
  'sys.title.operatingStatusSuccess': 'Success',
  'bonus.title.newNumber': 'new user',
  'bonus.title.oldNumber': 'Old users',
  'bonus.title.oldUserRatio': 'Proportion of old users',
  'analyze.card.cumulativeUser': 'Cumulative user',
  'analyze.card.last7dayActiveUser': 'Active users in the past 7 days',
  'analyze.card.last30dayActiveUser': 'Active users in the past 30 days',
  'analyze.card.moreWaitting': 'Coming soon',
  'analyze.card.cumulativePayingUser': 'Cumulative paid users',
  'analyze.card.cumulativePaymentAmount': 'Accumulated payment amount',
  'analyze.card.paymentRate': 'Rate',
  'analyze.card.userComposition': 'User composition',
  'analyze.card.activeUserComposition': 'Active user composition',
  'analyze.card.newUsers': 'New users',
  'analyze.card.firstDepositUsers': 'First save user',
  'analyze.card.withdrawalUsers': 'Withdrawals user',
  'analyze.card.depositUsers': 'Deposit user',
  'analyze.card.activeUser': 'Active users',
  'analyze.card.depositBet': 'Total deposit And Bet users',
  'analyze.card.depositUsersDistinct': 'Deposit user (distinct)',
  'analyze.card.activeUserDistinct': 'Active users (distinct)',
  'analyze.card.userRecharge': 'User recharge',
  'analyze.card.top-upUser': 'Recharge users',
  'analyze.card.depositAmount': 'Recharge amount',
  'analyze.card.firstDepositAmount': 'First charge amount',
  'analyze.card.totalDeposit': 'Total deposits',
  'analyze.card.totalWithdrawal': 'Total withdrawals',
  'analyze.card.offerDiscount': 'Preferential treatment',
  'analyze.card.platformFlow': 'Platform pipelining',
  'analyze.card.platformFlow1': 'Platform flow (yuan)',
  'analyze.card.platformFlow1VN': 'Platform flow (VND)',
  'analyze.card.betUserCount': 'Number of people betting (by platform)',
  'analyze.card.betUserCount1': 'Number of betting',
  'analyze.card.orderCount': 'Quantity of note',
  'finance.title.firstDeposit': 'First survival',
  'finance.title.totalDeposit': 'Total storage',
  'finance.title.totalWithdraw': 'Total take',
  'finance.title.totalBetflow': 'Total flow',
  'finance.title.totalWin': 'Reserve difference',
  'finance.title.profitLoss': 'Profit and loss',
  'pay.platformName': 'payment platform',
  'pay.orderAmount': 'Order amount',
  'pay.orderCount': 'Order amount',
  'pay.platformNameOrderAmount': 'Payment platform * order amount',
  'pay.platformNameOrderCount': 'Payment platform * order amount',
  'pay.title.amountStatistics': 'Payment platform transaction amount statistics',
  'pay.title.countStatistics': 'Transaction statistics of payment platform',
  'pay.title.successChannelRate': 'Payment success rate of each channel',
  'pay.title.usageRatio': 'Proportion of payment platforms used',
  'pay.title.successRatio': 'Payment platform success percentage',
  'pay.title.payName': 'Three party name',
  'pay.title.successCount': 'Successful stroke number',
  'pay.title.successAmount': 'Amount of success',
  'pay.title.orderCount': 'Total stroke number',
  'pay.title.amountSummary': 'Total sum',
  'pay.title.successRate': 'Success rate',
  'pay.export.payExcel': 'Payment success rate report.xls',
  'pay.label.settlementDate': 'Settlement date',
  'pay.label.allChannel': 'All channels',
  'pay.label.allPayType': 'All payment types',
  'pay.label.payChannel': 'Payment channel',
  'pay.label.payChannel1': 'Please select payment channel',
  'pay.label.payType': 'Payment type',
  'pay.label.payType1': 'Please select payment type',
  'pay.label.useLevel': 'Usage level',
  'pay.label.useLevel1': 'Please select the use level',
  'pay.label.useLevelAbove': 'What level does it need to reach',
  'pay.label.depositMin': 'Minimum sum',
  'pay.label.depositMin1': 'Please enter the minimum amount',
  'pay.label.depositMax': 'Maximum amount',
  'pay.label.depositMax1': 'Please enter the maximum amount',
  'pay.label.depositAmountNotice': 'Please enter a legal amount number',
  'pay.label.depositRequest': 'Recharge requirement',
  'pay.label.depositRequest1': 'Please enter recharge request',
  'pay.label.param': 'parameter',
  'pay.label.orderSort': 'Order of arrangement',
  'pay.label.orderSort1': 'Please enter legal order',
  'pay.label.amountType': 'Amount type',
  'pay.label.amountType1': 'Please select amount type',
  'pay.label.exchangeType': 'Please select exchange rate type',
  'pay.label.amountType_1': 'User input amount',
  'pay.label.amountType_2': 'Fixed amount list',
  'pay.label.amountType_3': 'Both supported',
  'pay.label.fixedAmountList': 'Fixed amount',
  'pay.label.fixedAmountList1': 'Please enter a fixed amount',
  'pay.label.fixedAmountList2': 'Enter a fixed amount of up to 200 characters',
  'pay.label.fixedAmountList3': 'Please enter a fixed amount. For more than one amount, please use, to divide',
  'pay.label.cardNumber': 'Bank account',
  'pay.label.cardOwner': 'Cardholder\'s Name',
  'pay.label.withdrawalAmount': 'Withdrawal Amount',
  'pay.label.withdrawalAmount1': 'Withdrawal Amount',
  'pay.label.withdrawType': 'Withdrawal method',
  'pay.label.withdrawInfo': 'Payment Information',
  'pay.withdraw.apName': 'Alipay name',
  'pay.withdraw.apName_jk4': 'GCash name',
  'pay.withdraw.apAccount': 'Alipay account number',
  'pay.withdraw.apAccount_jk4': 'GCash account number',
  'pay.withdraw.usdtPayCount': 'Payment count',
  'pay.withdraw.cardOwner': 'Account Name',
  'pay.withdraw.bankName': 'Belonging to bank',
  'pay.withdraw.bankNumber': 'Card Number',
  'pay.label.bankName': 'Bank Name',
  'pay.label.bankName1': 'Please enter bank name',
  'pay.label.bankName2': 'Enter up to 25 characters',
  'pay.label.bankAccount': 'Payee',
  'pay.label.bankAccount1': 'Please enter payee',
  'pay.label.bankAccount2': 'Enter up to 50 characters',
  'pay.label.bankAccount3': 'Enter up to 100 characters',
  'pay.label.bankAccount4': 'Enter up to 20 characters',
  'pay.label.bankAddr': 'Account opening',
  'pay.label.bankAddr1': 'Please enter the account opening outlet',
  'pay.label.bankNumber': 'Bank card number',
  'pay.label.bankNumber1': 'Please enter the bank card number',
  'pay.label.qrCode': 'QR code',
  'pay.label.qrCode1': 'Please upload QR code',
  'pay.label.payDesc': 'Recommended description',
  'pay.label.payDesc1': 'Please enter a recommendation description',
  'pay.label.payDesc3': 'Enter up to 200 character recommended description',
  'pay.label.payViewName': 'Channel custom name',
  'pay.label.payViewName1': 'Please enter a custom name',
  'pay.loadConfigInfoFail': 'Failed to load payment configuration information',
  'pay.loadConfigInfoError': 'Failed to load payment configuration information error',
  'pay.title.channelName': 'Channel name',
  'pay.title.channelName1': 'Please enter channel name',
  'pay.title.channelName2': 'Please enter your own channel name',
  'analyze.title.cumulativeUsers': 'Cumulative users (total channel users / total platform users)',
  'pay.title.payCode': 'Channel number',
  'pay.title.viewName': 'Channel type',
  'pay.title.remark': 'Self determined channel name',
  'pay.title.depositMin': 'Amount limitation',
  'common.agent': 'agent',
  'common.channel': 'agent',
  'common.title.agentAccount': 'Proxy account',
  'common.title.agentCode': 'Agent Code',
  'agent.h3.channelDistribution': 'Channel distribution',
  'finance.title.depositTime': 'Deposit time',
  'finance.title.depositAmount': 'Deposit amount',
  'finance.title.depositType': 'Way of deposit',
  'finance.title.totalDepositUsers': 'Total number of members',
  'finance.title.totalDepositAmount': 'Total deposit amount (yuan)',
  'finance.title.totalDepositAmountVN': 'Total deposit amount (VND)',
  'finance.export.excel': 'Deposit report.xls',
  'bonus.export.excel': 'Offer report.xls',
  'bonus.title.offerTime': 'Preferential payment time',
  'finance.title.bonusAmount': 'Preferential amount',
  'finance.title.bonusName': 'Preferential name',
  'finance.title.approveAdmin': 'Add operator manually',
  'finance.title.totalUserCount': 'Total User Count',
  'finance.title.totalBonusAmount': 'Total Bonus Amount',
  'game.title.betUsers': 'Bet users',
  'game.title.betOrderCount': 'Bet quantity',
  'game.title.betAmount': 'Bet amount (yuan)',
  'game.title.betAmountVN': 'Bet amount (VND)',
  'game.title.playerProfit': 'Player profit (yuan)',
  'game.title.playerProfitVN': 'Player profit (VND)',
  'game.title.platformProfit': 'Platform profit (yuan)',
  'game.title.platformProfitVN': 'Platform profit (VND)',
  'game.title.platformProfitLose': 'Platform profit and loss',
  'user.title.pageBetOrderCount': 'Total number of bets on this page',
  'user.title.pageBetAmount': 'Total bet on this page',
  'user.title.pagePlayerResultAmount': 'Total players win or lose on this page',
  'user.title.pageBetflow': 'Total flow on this page',
  'user.title.totalOrderCount': 'Total number of bets',
  'user.title.totalResultAmount': 'Total player wins',
  'pay.title.pageOrderAmount': 'Order amount on this page',
  'pay.title.pagePaidOrders': 'Number of paid orders on this page',
  'pay.title.pageUnpaidOrders': 'Number of unpaid orders on this page',
  'pay.title.pageExpiredOrders': 'Number of expired orders on this page',
  'pay.title.totalOrderAmount': 'Total order amount',
  'pay.title.totalPaidOrders': 'Total orders paid',
  'pay.title.totalUnpaidOrders': 'Total outstanding orders',
  'pay.title.totalExpiredOrders': 'Total expired orders',
  'game.title.pageBetUserCount': 'Number of users on this page',
  'game.title.pageBetOrderCount': 'Note quantity on this page',
  'game.title.pageBetAmount': 'Bet amount on this page (yuan)',
  'game.title.pageBetAmountVN': 'Bet amount on this page (VND)',
  'game.title.pagePlatformProfit': 'Platform profit on this page (yuan)',
  'game.title.pagePlatformProfitVN': 'Platform profit on this page (VND)',
  'game.title.totalUserCount': 'Total bet users',
  'game.title.totalOrderCount': 'Total bet volume',
  'game.title.totalBetAmount': 'Total bet (yuan)',
  'game.title.totalBetAmountVN': 'Total bet (VND)',
  'game.title.totalBetAmount1': 'Total bet',
  'game.title.totalPlatformProfit': 'Total platform profit (yuan)',
  'game.title.killRate': 'Kill Rate(%)',
  'game.title.killRateFormulas': 'Kill Rate=Total platform profit/Total bet',
  'game.title.totalPlatformProfitVN': 'Total platform profit (VND)',
  'game.title.totalPlayerResultAmount': 'Player wins or loses',
  'game.title.totalPlayerResultAmount1': 'Player wins or loses',
  'finance.title.pageDepositCount': 'Total recharge times of this page',
  'finance.title.pageDepositAmount': 'Total deposit on this page',
  'finance.title.pageFirstAmount': 'Top of this page',
  'finance.title.totalDepositProfit': 'Total recharge times',
  'finance.title.totalDepositAmount2': 'Total deposit (yuan)',
  'finance.title.totalDepositAmount2VN': 'Total deposit (VND)',
  'finance.title.totalFirstDepositAmount': 'Total initial charge (yuan)',
  'finance.title.totalFirstDepositAmountVN': 'Total initial charge (VND)',
  'game.export.platformExcel': 'Game platform report.xlsx',
  'game.title.platformName': 'Platform name',
  'game.title.platformName1': 'Please enter platform name',
  'common.title.dataDetail': 'Data details',
  'finance.title.withdrawalTime': 'Withdrawal time',
  'finance.title.withdrawalAmount': 'Withdrawal amount',
  'finance.title.withdrawalType': 'Withdrawal method',
  'finance.title.withdrawalType2': 'Withdrawal method',
  'finance.title.totalWithdrawUsers': 'Total Withdrawal Users Count',
  'finance.title.totalWithdrawAmount': 'Total Withdrawal Amount',
  'finance.export.withdrawalExcel': 'Withdrawal report.xls',
  'finance.export.userDepositExcel': 'User recharge report.xls',
  'user.export.userGameExcel': 'User game report.xlsx',
  'activity.export.excel': 'Mini game lottery record.xls',
  'common.title.type': 'type',
  'common.title.type1': 'Real name authentication',
  'common.title.type2': 'SMS',
  'common.title.type3': 'Is there a real name',


  'msg.title.certificationTime': 'Authentication time',
  'msg.title.period': 'Time slot',
  'game.title.gameName': 'Game name',
  'bet.title.betFlowId': 'Serial number',
  'bet.title.rawData': 'Raw data (game platform time)',
  'finance.title.depositCount': 'Recharge times',
  'finance.title.totalDepositAmount1': 'Total recharge amount',
  'finance.title.firstDepositTime': 'First charge time',
  'finance.title.lastDepositTime': 'Last recharge time',
  'finance.text.addBlacklist': 'Add blacklist',
  'finance.title.disablePaymentChannels': 'Disable payment channels',
  'finance.label.selectDisablePaymentChannels': 'Select disable payment channels',
  'user.title.lastLoginTime': 'Last login time',
  'user.title.userLevel': 'User level',
  'user.title.riskLevel': 'Risk level',
  'user.title.registerIP': 'Registered IP',
  'user.title.registerAddress': 'Registered address',
  'user.title.registerType': 'Registration type',
  'analyze.title.statisticalDate': 'Statistical date',
  'user.title.betOrderCount': 'Number of betting pen',
  'user.title.betAmount': 'Betting amount',
  'user.title.dataOverview': 'Data overview',
  'user.title.displayNumber': 'Display number',
  'sys.title.exportName': 'Name',
  'sys.title.exportName1': 'Please enter the correct name',
  'sys.title.nodeNumber': 'Node number',
  'sys.title.exportStatus': 'Derived state',
  'sys.title.exportStatus0': 'Waiting for export',
  'sys.title.exportStatus1': 'complete',
  'sys.title.exportStatus2': 'fail',
  'sys.title.exportStatus3': 'Exporting',
  'sys.title.exportStatus4': 'Download expired',
  'sys.title.finishTime': 'Completion time',
  'sys.title.nameAndNumber': 'Name / number',
  'sys.title.confirmDelete': 'confirm deletion',
  'sys.title.deletePicGroup': 'About to delete picture group configuration: {imgCode}',
  'sys.title.deleteButton': 'Button to be deleted: {btnName}',
  'sys.title.deleteConfig': 'Configuration to be removed: {configKey}',
  'sys.title.deleteMenuName': 'Menu to be deleted: {menuName}',
  'sys.title.deleteNotifyName': 'Notification type to be deleted: {notifyName}',
  'sys.title.deleteBeforeDisable': 'To prevent errors, please disable before deleting!',
  'sys.title.addGroupConfig': 'Add group configuration',
  'sys.title.repeatGroup': 'Add group configuration',
  'sys.title.imgCode': 'Picture group code',
  'sys.title.imgCode1': 'Picture group code:',
  'sys.title.imgCode2': 'Please enter picture group code',
  'sys.title.imgName': 'Picture group name',
  'sys.title.imgName1': 'Picture group name:',
  'sys.title.imgName2': 'Please enter a picture group name',
  'sys.title.remark': 'describe',
  'sys.title.remark1': 'Description:',
  'sys.title.remark2': 'Picture group description',
  'sys.title.maxAmount': 'Maximum number of pictures that can be transferred',
  'sys.title.maxAmount1': 'Maximum number of pictures that can be transferred:',
  'sys.title.maxAmount2': 'Maximum number of pictures that can be transferred',
  'user.title.submit': 'Whether to submit',
  'user.title.confirmSubmit': 'Please check whether the information is correct and submitted carefully',
  'user.title.notSamePass': 'Password is inconsistent, please confirm',
  'user.title.wrongPassNotice': 'Can only start with a lowercase letter, only contain lowercase letters and numbers',
  'user.title.existUser': 'User already exists',
  'user.title.addBackAccount': 'Add background account',
  'user.title.minUserNameLength': 'Please enter a user name with less than 6 characters',
  'user.title.maxUserNameLength': 'Please enter a user name of up to 25 characters',
  'user.title.userNameLengthLimit': 'Please enter login user name, 6-25 characters',
  'user.title.name1': 'Please enter a name',
  'user.title.name2': 'Please enter the correct name',
  'user.title.pass': 'Password',
  'user.title.pass1': 'Please enter the login password and leave it blank',
  'user.title.pass2': 'Please input a password',
  'user.title.pass3': 'Please enter the password for login',
  'user.title.pass4': 'Confirm password',
  'user.title.pass5': 'Please enter the login password again',
  'user.title.pass6': 'Please confirm the password',
  'user.title.mail': 'mailbox',
  'user.title.mail1': 'Please enter the correct email',
  'user.title.mail2': 'Please enter email',
  'user.title.phone': 'Mobile phone',
  'user.title.phone1': 'Please enter the correct mobile number',
  'user.title.phone2': 'Please enter your mobile number',
  'user.title.role': 'role',
  'user.title.role1': 'Please select a role',
  'user.title.status': 'state',
  'user.title.status1': 'Please select status',
  'user.title.goBack': 'Return',
  'user.title.submit1': 'Submission',
  'user.title.name3': 'Name',
  'user.title.isOnline': 'Is online?',
  'user.title.online': 'On-line',
  'user.title.offline': 'Off-line',
  'user.title.forceOffline': 'Off-line',
  'sys.button.cleanCache': 'Clear native cache',
  'user.button.addAccount': 'Add account',
  'user.button.addButton': 'add button',
  'user.button.addConfig': 'Add configuration',
  'sys.button.addLeafMenu': 'Add submenu',
  'sys.button.addParam': 'Add parameter',
  'sys.button.addTopMenu': 'Add top menu',
  'sys.button.addNotifyType': 'Add notification type',
  'sys.button.addExternalChain': 'Add external payment',
  'user.disableNotice': 'Are you sure you want to disable this background account?',
  'user.enableNotice': 'Are you sure you want to enable the background account?',
  'user.title.confirmNotice': 'Confirmation prompt',
  'user.offlineUserAccountNotice': 'Are you sure you want to force the background account offline?',
  'sys.title.fillButtonInfo': 'Fill in button information',
  'sys.title.fillRejectReason': 'Fill in rejection reason',
  'sys.title.fillMenuInfo': 'Fill in menu information',
  'sys.title.fillInfo': 'Fill in information',
  'sys.title.fillPayChannelInfo': 'Fill in payment channel parameters',
  'sys.title.fillNoticeTypeInfo': 'Fill in notification type information',
  'sys.title.fillOnlinePayInfo': 'Fill in online payment information',
  'sys.title.fillOffLinePayChannelInfo': 'Fill in offline payment channel information',
  'sys.title.groupName': 'Group name',
  'sys.title.groupName1': 'Please enter group name',
  'sys.title.groupName2': 'Please enter a group name with less than 20 characters',
  'sys.title.buttonName': 'Button name',
  'sys.title.buttonName1': 'Please enter the button name',
  'sys.title.buttonName2': 'Please enter a button name less than 20 characters',
  'sys.title.buttonNumber': 'Button number',
  'sys.title.buttonNumber1': 'Please enter the button number',
  'sys.title.buttonNumber2': 'Please enter a button number less than 100 characters',
  'sys.title.buttonDes': 'Button description',
  'sys.title.buttonDes1': 'Please enter the button description',
  'sys.title.buttonDes2': 'Please enter a button description with less than 1000 characters',
  'sys.title.groupNameAndNumber': 'Group name / number',
  'sys.title.buttonAndLink': 'Button name / link',
  'sys.title.configNameValueGroup': 'Configuration name / value / group',
  'sys.title.belongUserGroup': 'User group',
  'sys.title.userGroup': 'User group',
  'sys.title.adminGroup': 'Management Group',
  'sys.title.userGroup1': 'Please select a user group',
  'sys.title.configGroup': 'Configuration group',
  'sys.title.configGroup1': 'Please enter configuration group',
  'sys.title.group': 'group',
  'sys.title.group1': 'Please input group',
  'sys.title.limitLength20': 'Please enter less than 20 characters',
  'sys.title.limitLength50': 'Please enter less than 50 characters',
  'sys.title.limitLength100': 'Please enter less than 100 characters',
  'sys.title.limitLength1000': 'Please enter less than 1000 characters',
  'sys.title.keyNotice': 'Please input key',
  'sys.title.value': 'value',
  'sys.title.valueNotice': 'Please input value.',
  'sys.title.sort': 'order',
  'sys.title.sortNotice': 'Please output the order',
  'sys.title.fillMenuInfoNotice': 'Menu number must be the last / last link',
  'sys.title.hierarchical': 'Menu hierarchy',
  'sys.title.hierarchical1': 'Menu level {menuLevel}',
  'sys.title.topMenu': 'Top menu',
  'sys.title.leafMenu': 'Leaf menu',
  'sys.title.leafMenu1': 'Leaf menu',
  'sys.title.menuName': 'Menu name',
  'sys.title.menuName1': 'Please enter menu name',
  'sys.title.menuName2': 'Please enter a menu name with less than 20 characters',
  'sys.title.menuLevel': 'Menu level',
  'sys.title.menuLevel1': 'Please select menu level',
  'sys.title.menuLevel_1': 'First class menu',
  'sys.title.menuLevel_2': 'Two level menu',
  'sys.title.menuLevel_3': 'Three level menu',
  'sys.title.menuType': 'Menu type',
  'sys.title.menuType1': 'Is it a leaf menu',
  'sys.title.menuOrder': 'Menu order',
  'sys.title.menuOrder1': 'Please enter menu order',
  'sys.title.menuLink': 'Menu link',
  'sys.title.menuLink1': 'Please enter the menu number for splicing links',
  'sys.title.menuLink2': 'Please enter a menu number less than 100 characters',
  'sys.title.menuLink3': '"/" start + superior link + "/" + menu number',
  'sys.title.menuCode': 'Menu number',
  'sys.title.menuCode1': 'Please enter the menu number, letter, number and decimal point',
  'sys.title.menuCode2': 'Please enter a menu number less than 100 characters',
  'sys.title.menuCode3': 'Link composition: parent menu number / menu number',
  'sys.title.menuIcon': 'Menu icon',
  'sys.title.menuIcon1': 'Please enter a menu icon with less than 20 characters',
  'sys.title.menuIcon2': 'Please enter the menu icon. The first level menu does not need to be',
  'sys.title.reviewIcon': 'Icon Preview',
  'sys.title.menuGroup': 'Menu group',
  'sys.title.menuNameAndLink': 'Menu name / link',
  'msg.title.notifyName': 'Notification name',
  'msg.title.notifyName1': 'Please enter a notification type name',
  'msg.title.notifyName2': 'Please enter a notification type name less than 20 characters',
  'msg.title.notifyCode': 'Notification number',
  'msg.title.notifyCode1': 'Please enter the notification type number for splicing links',
  'msg.title.notifyCode2': 'Please enter a notification type number less than 100 characters',
  'msg.title.notifyCode3': 'Link composition: superior notification type No. / notification type No',
  'msg.title.notifyDesc': 'Notification description',
  'msg.title.notifyDesc1': 'Please enter a description of the notification type less than 20 characters',
  'msg.title.notifyDesc2': 'Please enter a description of the notification type',
  'msg.title.notifyNameAndLink': 'Notification type name / link',
  'msg.title.notifyNameR': 'Notification name',
  'msg.title.notifyCodeR': 'Notification number',
  'sys.title.updateDesc': 'Release Notes:',
  'sys.title.updateDesc1': 'It is recommended not to exceed 5 lines, with 15 characters (including characters) per line',
  'agent.title.confirmOffer': 'Confirmation of payment',
  'agent.title.confirmOffer1': 'Please confirm whether to issue commission?',
  'agent.title.confirmReject': 'Confirm rejection',
  'agent.title.confirmReject1': 'Please confirm whether to refuse to issue?',
  'agent.title.confirmCumulative': 'Confirm cumulative accounting',
  'agent.title.confirmCumulative1': 'Please confirm whether the Commission settlement is accumulated to the next month?',
  'agent.title.settlementDate': 'Settlement day',
  'agent.title.monthlyProfitLoss': 'phase',
  'agent.title.bonusAmount': 'Bonus amount',
  'agent.title.depositWithdrawalFee': 'Service charge for deposit and withdrawal',
  'agent.title.depositWithdrawAndFee': 'Deposits, withdrawals and fees',
  'agent.title.deposit': 'Deposits',
  'agent.title.withdraw': 'withdrawals',
  'agent.title.transFee': 'fees',
  'agent.title.netProfit': 'Net profit',
  'agent.title.earningCommission': 'Income Commission',
  'agent.title.commissionStatus1': 'To be reviewed I (risk control)',
  'agent.title.commissionStatus2': 'To be reviewed II (Finance)',
  'agent.title.commissionStatus3': 'Commission distributed',
  'agent.title.commissionStatus4': 'Refuse to grant',
  'agent.title.commissionStatus5': 'Accumulative month',
  'agent.title.offerCommission': 'Commission',
  'agent.title.reject': 'refuse',
  'agent.title.marketCost': 'Market cost',
  'agent.title.refundFee': 'Refund fee',
  'agent.title.taxDeduction': 'tax deduction',
  'agent.title.lowerLevel': 'Lower level pumping',
  'agent.title.alreadyOffer': 'Have been issued',
  'sys.upload.success': 'File uploaded successfully',
  'sys.upload.fail': 'File upload failed. Please delete and upload the file again.',
  'sys.upload.deleteSuccess': 'Deleted successfully.',
  'sys.upload.picture': 'Upload pictures.',
  'sys.lengthLimit': 'Enter up to 300 characters',
  'sys.input': 'Please input',
  'pay.offline': 'Offline payment',
  'pay.online': 'Online channel',
  'pay.title.payTypeInfo': 'Payment type information',
  'sys.title.parentCode': 'Attribution grouping',
  'sys.title.parentCode1': 'Please select the belonging group',
  'sys.title.forwardUrl': 'Jump link',
  'sys.title.forwardUrl1': 'Please enter a jump link',
  'sys.title.forwardUrl2': 'Please enter a valid jump link',
  'sys.title.background': 'Background color',
  'sys.title.background1': 'Please enter background color',
  'sys.title.background2': 'Please enter the order background color',
  'sys.title.background3': 'Recommendation: blue #0ae / green #22ac38 / dark blue #4a79d6 / yellow #d55a26 / red #dd524d / light yellow #e9e5af / light gray #f3f3f3f3',
  'sys.title.imgPC': 'Icon (PC)',
  'sys.title.imgMobile': 'Icon (H5)',
  'sys.title.img1': 'Please upload the icon',
  'sys.title.img2': 'Recommended: width unlimited, height 40px, format png',
  'pay.title.insideName': 'internal name',
  'pay.title.payViewName': 'Client name',
  'pay.title.groupLevel': 'Group level',
  'pay.title.sort': 'sort',
  'pay.title.recommendDesc': 'Type: recommendation',
  'pay.title.externalChain': 'External chain payment',
  'pay.title.builtGrouping': 'Built-in grouping',
  'pay.title.builtGrouping1': 'Built in group: {payDesc}',
  'pay.title.img': 'Icon',
  'pay.title.attributes': 'attribute',
  'pay.title.attributes1': 'display',
  'pay.title.attributes2': 'latent',
  'pay.title.attributes3': 'Recommendation',
  'pay.title.edit': 'edit',
  'pay.title.confirmOrder': 'Confirmation of order',
  'pay.title.confirmOrder1': 'Please check whether it has arrived?',
  'sys.title.loadingCallBtnFail': 'Failed to load call button',
  'sys.title.callSuccess': 'Dialing success',
  'sys.title.callError': 'Dialing errors',
  'sys.title.callError1': 'Call timeout, please wait',
  'sys.title.orderNo': 'Order number',
  'sys.title.thirdPlatform': 'The third party',
  'sys.title.userAccount': 'Member',
  'sys.title.payName': 'payment platform',
  'sys.title.payerName': 'Deposit information',
  'sys.title.withdrawalInfo': 'Withdrawal information',
  'sys.title.bankName': 'Collection information',
  'sys.title.orderAmount': 'Amount of money',
  'sys.title.orderAmount1': 'Recharge success',
  'sys.title.orderAmount0': 'Unpaid',
  'sys.title.orderAmount2': 'Expired',
  'sys.title.create': 'Creation / processing time',
  'sys.title.update': 'Processing time / personnel',
  'sys.title.dealTime': 'processing time',
  'sys.title.dealAdmin': 'Processing personnel',
  'sys.title.applyTime': 'Application time',
  'finance.export.depositOfflineExcel': 'Order recharge (offline payment) report.xls',
  'finance.export.depositOnlineExcel': 'Order recharge (online payment) report.xls',
  'pay.input.orderUserAccountPlatform': 'Order number, user name, payment platform',
  'sys.title.checkPaymentPercent': 'View success rate',
  'sys.title.orderStatus': 'Order status',
  'sys.title.dataType': 'data type',
  'sys.title.dataType0': 'Recharge record',
  'sys.title.dataType1': 'Member summary',
  'sys.title.dataType2': 'Channel summary',
  'pay.title.deviceSource': 'Order source',
  'pay.title.deviceSource1': 'PC terminal',
  'pay.title.deviceSource2': 'Mobile terminal',
  'pay.title.deviceSource3': 'Android terminal',
  'pay.title.deviceSource4': 'IOS terminal',
  'finance.export.orderDepositExcel': 'Order recharge report.xls',
  'finance.export.orderWithdrawalExcel': 'Withdraw order report.xls',
  'pay.title.confirmReason': 'Reasons for confirmation',
  'pay.title.confirmReason1': 'Please enter the reason for confirmation',
  'pay.title.confirmUnlock': 'Confirm unlock',
  'pay.title.confirmUnlock1': 'Confirm to unlock withdrawal',
  'pay.title.confirmWithdrawal': 'Confirmation of withdrawals',
  'pay.title.confirmWithdrawal1': 'Do you agree to withdraw with {name}?',
  'pay.title.wrongSplitAmount': 'Split amount error',
  'pay.title.wrongSplitAmount2': 'The split amount cannot be greater than the total amount',
  'pay.title.splitOrder': 'Are you sure to split it into {length} orders?',
  'pay.title.success': 'Success',
  'pay.title.success1': 'Are you sure to withdraw to the account?',
  'pay.title.fail': 'fail',
  'pay.title.fail1': 'Are you sure the withdrawal failed?',
  'pay.title.withdrawalOrder': 'Withdrawal order No',
  'pay.title.windControlAudit': 'Wind control audit',
  'pay.title.paymentReview': 'Audit of payment',
  'pay.title.requestWithdrawalTime': 'Time of application for withdrawal',
  'pay.title.paymentMethod': 'Way of payment',
  'pay.title.splitOrder1': 'Split order',
  'pay.title.splitMasterOrder': 'Split main order',
  'pay.title.splitMolecularOrder': 'Split order',
  'pay.title.molecularTransNo': 'Sub Order No.: {transNo}',
  'pay.title.masterTransNo': 'Master Order No.: {transNo}',
  'pay.title.refuseWithdrawCash': 'Refuse to cash in',
  'pay.title.confirmPayment': 'Confirmation of payment',
  'pay.title.payForMoney': 'Submission of payment',
  'pay.title.unlock': 'Unlock',
  'pay.title.denialReason': 'Reasons for refusal',
  'pay.title.withdrawalStatus2': 'Successful withdrawals',
  'pay.title.withdrawalStatus1': 'Waiting for payment',
  'pay.title.withdrawalStatus3': 'Rejected',
  'pay.title.withdrawalStatus0': 'Risk control to be reviewed',
  'pay.title.withdrawalStatus4': 'Payment on behalf',
  'pay.title.withdrawalStatus5': 'Failure to pay',
  'pay.title.withdrawalStatus6': 'Payment locking',
  'pay.title.withdrawalStatus8': 'Split success',
  'pay.title.withdrawalStatus_1': 'To be audited',
  'pay.title.withdrawalStatus_2': 'Successful withdrawals',
  'pay.title.withdrawalStatus_3': 'Rejected',
  'pay.title.withdrawalStatus_0': 'Risk control audit in progress',
  'pay.title.withdrawalStatus_4': 'Payment on behalf',
  'pay.title.withdrawalStatus_5': 'Failure to pay',
  'pay.title.choseWithDrawalChannel': 'Please select payment channel',
  'pay.title.rate': 'rate',
  'pay.title.eachOrderAmount': 'Each sum',
  'pay.title.splitAmountConfig': 'Split amount settings',
  'pay.title.splitAmount': 'Please enter the split amount',
  'pay.title.rejectReason': 'Please enter the reason for rejection',
  'pay.title.withdrawalSuccessTime': 'Withdrawal success time',
  'pay.title.withdrawalChannel': 'Payment channel',
  'pay.title.SuccessTimeOrFailTime': 'Success or failure time',
  'pay.title.withdrawalOrderUserAccount': 'Withdrawal order No., user name',
  'login.title.qrcode': 'Please verify the QR code',
  'login.install.verify0': 'Chrome version',
  'login.install.verify1': 'Android version',
  'login.install.verify2': 'IOS version',
  'login.title.idcard': 'Please enter the authentication code',
  'login.title.verifyIdcard': 'Please verify the authentication code',
  'login.title.verificationCode': 'Verification Code',
  'login.title.finishVerify': 'Complete validation',
  'lottery.title.userAccount': 'Membership account',
  'lottery.title.complainantType': 'Types of complaints',
  'lottery.title.targetId': 'Complaint object No',
  'lottery.title.targetId1': 'Post',
  'lottery.title.targetId2': 'comment',
  'lottery.title.complainantAndComplainantTime': 'Complainant / complaint time',
  'lottery.title.complainantDate': 'Date of complaint',
  'lottery.title.keyword': 'Keyword',
  'lottery.title.targetCode': 'Target number',
  'lottery.title.read': 'Read',
  'lottery.title.open': 'open',
  'lottery.title.close': 'Close',
  'lottery.title.dayLimit': 'Daily ceiling',
  'lottery.title.article': 'piece',
  'lottery.title.ordinaryStickers': 'General Post',
  'lottery.title.cash': 'cash',
  'lottery.title.flow': 'Flowing water',
  'lottery.title.point': 'integral',
  'lottery.title.expertStickers': 'Expert Stickers',
  'lottery.title.greatGodSticker': 'Guru Sticker',
  'lottery.title.attention': 'follow',
  'lottery.title.perPerson': 'Send For Everyone',
  'lottery.title.person': 'people',
  'lottery.title.comment': 'comment',
  'lottery.title.eachDelivery': 'Send For each one',
  'lottery.title.article1': 'strip',
  'lottery.title.like': 'thumbs-up',
  'lottery.title.everyTimeSend': 'Send For every times',
  'lottery.title.one': 'individual',
  'lottery.title.buyLotterySwitch': 'Lottery switch',
  'lottery.title.handicapTime': 'Handicap time',
  'lottery.title.switchOpen': 'open',
  'lottery.title.closingTime': 'Closing time',
  'lottery.title.inputNumber': 'please enter a number',
  'lottery.title.postReply': 'Post / Reply',
  'lottery.title.post': 'Post',
  'lottery.title.reply': 'Reply',
  'lottery.title.sticker': 'Post',
  'lottery.title.applyForGod': 'Apply to become a Guru',
  'lottery.title.recentWinningStreak': 'Recent winning streak',
  'lottery.title.inputPeriods': 'Please enter the number of stage',
  'lottery.title.periods': 'stage',
  'lottery.title.periods1': 'Number of stage',
  'lottery.title.inputPeriods1': 'Please select the number of stage',
  'lottery.title.periods2': 'Issue {item}',
  'lottery.title.weekWinRate': 'Week winning rate',
  'lottery.title.monthWinRate': 'Month winning rate',
  'lottery.title.addMemberLevel': 'Add member level',
  'lottery.title.levelName': 'Level name',
  'lottery.title.level': 'level',
  'lottery.title.addTime': 'Adding time',
  'lottery.title.addAdmin': 'Adding people',
  'lottery.title.addBannedMember': 'Add forbidden member',
  'lottery.title.inputMemberAccount': 'Please enter member account',
  'lottery.title.inputMemberAccount1': 'Please enter the member account number. Multiple accounts are separated by commas',
  'lottery.title.banCount': 'Duration',
  'lottery.title.inputBanCount': 'Please enter the duration',
  'lottery.title.reason': 'Reason',
  'lottery.title.inputReason': 'Please enter the reason',
  'lottery.title.confirmNotice': 'Confirmation prompt',
  'lottery.title.confirmNotice1': 'Are you sure you want to reject the order bonus?',
  'lottery.title.confirmNotice2': 'Are you sure you want to delete the selected forbidden member?',
  'lottery.title.confirmNotice3': 'Are you sure you want to delete the prize opening date of {month} month {day} in {year}?',
  'lottery.title.confirmNotice4': 'Are you sure you want to use the source number as the prize number?',
  'lottery.title.confirmNotice5': 'Are you sure that all the orders of {period} in {year} have been distributed?',
  'lottery.title.confirmNotice6': 'Are you sure you want to distribute the selected order bonus?',
  'lottery.title.confirmNotice7': 'Are you sure you want to delete the selected reply?',
  'lottery.title.confirmNotice8': 'Are you sure you want to modify the sort type?',
  'lottery.title.confirmNotice9': 'Are you sure you want to delete the selected post?',
  'lottery.title.confirmNotice10': 'Are you sure you want to reset the agent password? Do you need a new password for agent login after resetting?',
  'lottery.title.confirmNotice11': 'Are you sure to delete the Commission proportion?',
  'lottery.title.confirmNotice13': 'This submission affects the global default commission calculation percentage. Please check the information carefully?',
  'lottery.title.confirmNotice14': 'This submission affects the global comprehensive calculation percentage. Please check the information carefully?',
  'lottery.title.confirmNotice15': 'This submission affects the default commission calculation percentage of the global subordinate agent. Please check the information carefully?',
  'lottery.title.banTime': 'Forbidden time',
  'lottery.title.time': 'time',
  'lottery.title.timeStart': 'start time',
  'lottery.title.timeEnd': 'End time',
  'lottery.title.batchAdd': 'Batch addition',
  'lottery.title.batchRemove': 'Batch removal',
  'lottery.title.openDate': 'Time of draw a lottery',
  'lottery.title.openPeriods': 'Lottery stage of draw a lottery',
  'lottery.title.openNumber': 'Lottery number of draw a lottery',
  'lottery.title.openLottery1': 'Unfinished Award',
  'lottery.title.openLottery2': 'Finished Award',
  'lottery.title.confirmLotteryOpen': 'Award Completion',
  'lottery.title.lotteryResult': 'Lottery Award Result',
  'lottery.title.batchGrant': 'Batch Award',
  'lottery.title.orderDate': 'Order Date',
  'lottery.title.officialTime': 'Official',
  'lottery.title.platfromTime': 'Platform',
  'lottery.title.year': 'year',
  'lottery.title.inputYear': 'Please enter the year',
  'lottery.title.month': 'Month',
  'lottery.title.inputMonth': 'Please enter the month',
  'lottery.title.date': 'date',
  'lottery.title.inputDate': 'Please enter the date',
  'lottery.title.enteringPersonAndTime': 'Entered by / Entered time',
  'lottery.title.openPersonAndOpenTime': 'Draw a lottery by / Draw a lottery time',
  'lottery.title.addOpenDate': 'Add draw a lottery date',
  'lottery.title.enteringOpenNumber': 'Enter lottery number of draw a lottery',
  'lottery.title.enteringDate': 'Enter Date',
  'lottery.title.enteringNumber': 'Entry Number',
  'lottery.title.firstBall': 'First ball',
  'lottery.title.firstBall1': 'Please enter the number of first ball',
  'lottery.title.secondBall': 'Second ball',
  'lottery.title.secondBall1': 'Please enter the number of second ball',
  'lottery.title.thirdBall': 'Third ball',
  'lottery.title.thirdBall1': 'Please enter the number of third ball',
  'lottery.title.fourthBall': 'Fourth ball',
  'lottery.title.fourthBall1': 'Please enter the number of fourth ball',
  'lottery.title.fifthBall': 'Fifth ball',
  'lottery.title.fifthBall1': 'Please enter the number of fifth ball',
  'lottery.title.sixthBall': 'Sixth ball',
  'lottery.title.sixthBall1': 'Please enter the number of sixth ball',
  'lottery.title.seventhBall': 'Seventh ball',
  'lottery.title.seventhBall1': 'Please enter the number of seventh ball',
  'lottery.title.status1': 'Pending Adopted',
  'lottery.title.status2': 'Adopted',
  'lottery.title.status3': 'Abandoned',
  'lottery.title.firstLevelName': 'Name of class I lottery',
  'lottery.title.secondLevelName': 'Name of class II lottery',
  'lottery.title.hongkong': 'Hongkong Lottery',
  'lottery.title.markSix': 'Liuhe Lottery',
  'lottery.title.playName': 'Play Name',
  'lottery.title.playName1': 'Please choose how to play',
  'lottery.title.bonusNumber': 'Winning numbers',
  'lottery.title.bonusAmount': 'Winning amount',
  'lottery.title.grantAdminAndGrantTime': 'Award by / Award Time',
  'lottery.title.grantDate': 'Award Time',
  'lottery.title.orderNumber': 'Order Number',
  'lottery.title.number': 'Number',
  'lottery.title.orderTimeAndOpenTime': 'Order time / Draw a lottery time',
  'lottery.title.orderStatus1': 'Waiting for payment',
  'lottery.title.orderStatus2': 'Waiting for the award',
  'lottery.title.orderStatus3': 'Drawing',
  'lottery.title.orderStatus4': 'Billing',
  'lottery.title.orderStatus5': 'Winning',
  'lottery.title.orderStatus6': 'No win',
  'lottery.title.orderStatus7': 'Invalid Order',
  'lottery.title.orderStatus8': 'Cancel Order',
  'lottery.title.betAmount': 'Bet Amount',
  'lottery.title.eachBetAmount': 'Each Bet Amount',
  'lottery.title.totalAmount': 'Total Sum Amount',
  'lottery.title.galleryName': 'Gallery Name',
  'lottery.title.isHeat': 'Is it popular?',
  'lottery.title.isHeat1': 'Popular',
  'lottery.title.isHeat0': 'Non popular',
  'lottery.title.thumbnail': 'Thumbnail',
  'lottery.title.periodsMgt': 'Specific Stage Management',
  'lottery.title.isDisplaySort': 'Whether to display order by views',
  'lottery.title.ptrr': 'Likes / Unlike / reads / comments',
  'lottery.title.praiseCount': 'Praise count',
  'lottery.title.treadCount': 'Unlike count',
  'lottery.title.readCount': 'Reading count',
  'lottery.title.reviewCount': 'Comment count',
  'lottery.title.lookBigPic': 'View the big picture',
  'lottery.title.likeCount': 'Praise points',
  'lottery.title.content': 'Comment content',
  'lottery.title.content1': 'Please enter comments',
  'lottery.title.UserAccountAndContent': 'User name, comment content',
  'lottery.title.sendPushMsg': 'Send push message',
  'lottery.title.pushPlatform': 'Push platform',
  'lottery.title.pushDate': 'Push date',
  'lottery.title.pushPlatform1': 'Please select a push platform',
  'lottery.title.android': 'Android',
  'lottery.title.ios': 'IOS',
  'lottery.title.title': 'Title',
  'lottery.title.title1': 'Please fill in the push title',
  'lottery.title.title2': 'Please enter the title of the post',
  'lottery.title.contents': 'Push content',
  'lottery.title.contents1': 'Please fill in the push content',
  'lottery.title.pushAdminAndContents': 'Pusher / time',
  'lottery.title.addSuccess': 'Added successfully!',
  'lottery.title.addException': 'Increase anomaly',
  'lottery.title.addLikeCountAndReadCount': 'Increase likes or reads',
  'lottery.title.choseType': 'Selection type',
  'lottery.title.choseType1': 'Please select Add type',
  'lottery.title.countNumber': 'Number',
  'lottery.title.countNumber1': 'Please enter quantity',
  'lottery.title.commentSuccess': 'Comment succeeded!',
  'lottery.title.commentError': 'Commentary error',
  'lottery.title.postAndReply': 'Post reply',
  'lottery.title.numberCode': 'number',
  'lottery.title.replyAdmin': 'Reply to people',
  'lottery.title.secondReply': 'Two level recovery',
  'lottery.title.upperNumberCode': 'Superior number',
  'lottery.title.firstReply': 'First order reply',
  'lottery.title.replyTime': 'Recovery time',
  'lottery.title.replyLevel': 'Reply hierarchy',
  'lottery.title.conten': 'content',
  'lottery.title.addLikeAndRead': 'Increase likes or reads',
  'lottery.title.addLikeAndRead1': 'Increase the number of likes, reads and documents',
  'lottery.title.follow': 'documentary',
  'lottery.title.postNew': 'Release new posts',
  'lottery.title.category': 'classification',
  'lottery.title.category1': 'Please select a classification',
  'lottery.title.postDate': 'Date of posting',
  'lottery.title.adPic': 'Advertising picture',
  'lottery.title.adPic1': 'Please upload the advertisement picture',
  'lottery.title.public': 'Is it public?',
  'lottery.title.public1': 'Please choose whether to publish',
  'lottery.title.public2': 'open',
  'lottery.title.public3': 'Reply can be viewed',
  'lottery.title.pushSingleSticker': 'Push or not',
  'lottery.title.pushSingleSticker1': 'Please select post type',
  'lottery.title.pushSingleSticker2': 'Non push sheet',
  'lottery.title.pushSingleSticker3': 'Push sheet',
  'lottery.title.secondaryPlay': 'Two level play',
  'lottery.title.secondaryPlay1': 'Please choose the second level play method',
  'lottery.title.thirdPlay': 'Three level play',
  'lottery.title.thirdPlay1': 'Please choose three levels of play',
  'lottery.title.amountPerBet': 'Amount per note',
  'lottery.title.amountPerBet1': 'Please enter the amount of each note',
  'lottery.title.ranking': 'Ranking',
  'lottery.title.ranking1': 'Roof placement',
  'lottery.title.ranking2': 'Recommend',
  'lottery.title.giftChoice': 'Gift choice',
  'lottery.title.giftChoice1': 'waste money for nothing',
  'lottery.title.giftChoice2': 'Send points',
  'lottery.title.readSendCash': 'Cash for reading',
  'lottery.title.readSendCash1': 'Please enter the amount',
  'lottery.title.readSendPoint': 'Points for reading',
  'lottery.title.readSendPoint1': 'Please enter points',
  'lottery.title.postAccount': 'Posting account number',
  'lottery.title.postAccount1': 'Please enter the posting account',
  'lottery.title.setStickerType': 'Set post type',
  'lottery.title.stickerType': 'Post type',
  'lottery.title.stickerType1': 'Please enter the post type name',
  'lottery.title.typeName': 'Type name',
  'lottery.title.showOrder1': 'Please enter the order of presentation',
  'lottery.title.showOrder': 'Display order',
  'lottery.title.addType': 'Add type',
  'lottery.title.moveBeforeDelete': 'Please transfer your posts to another category before deleting them.',
  'lottery.title.postAdmin': 'Poster',
  'lottery.title.categoryAndTitle': 'Category / Title',
  'lottery.title.readContentLike': 'Read / comment / like',
  'lottery.title.postAndEditTime': 'Post / edit time',
  'lottery.title.unpin': 'Cancel the ceiling',
  'lottery.title.cancelRecom': 'Cancel recommendation',
  'lottery.title.viewReply': 'View reply',
  'lottery.title.addQuantity': 'Quantity added',
  'lottery.title.addSticker': 'New posts',
  'lottery.title.deleteSticker': 'Delete posts',
  'lottery.title.updateCategory': 'Change classification',
  'lottery.title.setCategory': 'Setup classification',
  'lottery.title.targetType': 'Target type',
  'lottery.title.likeContent': 'Like object content',
  'lottery.title.likeTime': 'Praise time',
  'lottery.title.beLikeAccount': 'Account number of the person concerned',
  'lottery.title.attentionTime': 'Attention time',
  'lottery.title.taskTime': 'Mission time',
  'lottery.title.type': 'type',
  'lottery.title.readingTask1': 'Reading task - General Post',
  'lottery.title.readingTask2': 'Reading task - expert post',
  'lottery.title.readingTask3': 'Reading task - Poster',
  'lottery.title.readTask': 'Reading task',
  'lottery.title.focusTask': 'Focus on tasks',
  'lottery.title.contentTask': 'Commentary task',
  'lottery.title.likeTask': 'Praise mission',
  'lottery.title.taskTarget': 'Mission objectives',
  'lottery.title.completed': 'Completed',
  'lottery.title.isReceive': 'Whether to receive',
  'lottery.title.received': 'Have received',
  'lottery.title.unaccalimed': 'Uncollected',
  'lottery.title.upgradeTime': 'Upgrade time',
  'agent.title.verificationFail': 'Validation failed',
  'agent.title.verificationFail1': 'The user name already exists. Please re-enter',
  'agent.title.confirmPassWrong': 'The two passwords do not match!',
  'agent.title.fillAgentInfo': 'Fill in agent information',
  'agent.title.agentType': 'Proxy type',
  'agent.title.ordinaryAgent': 'Ordinary agent',
  'agent.title.agentLevel': 'Agency level',
  'agent.title.manualAmount': 'Adjustment amount',
  'agent.title.agentLevel1': 'First tier agent',
  'agent.title.agentLevel2': 'Two tier agency',
  'agent.title.agentLevel3': 'Three tier agency',
  'agent.title.adChannel': 'Advertising channel',
  'agent.title.addAdChannel': 'Add advertising channel',
  'agent.title.adCode': 'Advertising channel code',
  'agent.title.adCode1': 'Please select advertisement code',
  'agent.title.adName': 'Advertisement name',
  'agent.title.adName1': 'Please enter the correct advertisement name',
  'agent.title.adAddress': 'Advertising address',
  'agent.title.adAddress1': 'Please enter the correct advertising address',
  'agent.title.adDesc': 'Advertising description',
  'agent.title.adDesc1': 'Please enter the correct advertising description',
  'agent.title.adPutDate': 'Date of launch',
  'agent.title.adPutDate1': 'Please select release date',
  'agent.title.payName': 'Name of payment',
  'agent.title.payName1': 'Please enter the correct payment name',
  'agent.title.bankNo': 'Bank card number',
  'agent.title.bankNo1': 'Please enter the correct bank card number',
  'agent.title.adMgt': 'Advertising management',
  'agent.title.onlyOne': 'Only one advertising agency channel can be selected',
  'agent.title.outOfIndex': 'Advertising agency channel is not in the selection range, please re select.',
  'agent.title.baseInfo': 'Essential information',
  'agent.title.payInfo': 'Payment information',
  'agent.title.complete': 'complete',
  'agent.title.nextStep': 'Next step',
  'agent.title.backStep': 'Previous step',
  'agent.title.oneMore': 'Add one more.',
  'agent.title.resetPassSuccess': 'Password reset succeeded',
  'agent.title.newPassIs': 'Reset password succeeded. The new password is:',
  'agent.title.unfreezeAgent': 'Do you want to unfreeze this agent?',
  'agent.title.activationAgent': 'Do you want to activate this agent?',
  'agent.title.freezeAgent': 'Do you want to freeze this agent?',
  'agent.title.rejectActivationAgent': 'Do you want to decline activation of this agent?',
  'agent.title.confirmOperate': 'Operation confirmation',
  'agent.title.trackCode': 'Trace code',
  'agent.title.registerTimeAndLastLoginTime': 'Registration time / last login',
  'agent.title.status0': 'not active',
  'agent.title.status1': 'Activated',
  'agent.title.status2': 'Frozen',
  'agent.title.status3': 'Rejected',
  'agent.title.activation': 'activation',
  'agent.title.freeze': 'Frozen',
  'agent.title.thaw': 'Thaw',
  'agent.title.resetPass': 'Reset login password',
  'agent.title.userCodeNameMail': 'User name, code, name, email',
  'agent.title.registerTime': 'Registration time',
  'agent.title.upperCode': 'Superior CODE',
  'agent.title.upperAgentCode': 'Please enter superior agent code',
  'agent.title.platform': 'platform',
  'agent.title.platformDetail': 'Platform details',
  'agent.title.desc': 'Platform win / loss: {resultAmount}, commission proportion: {commissionPercent}, commission earned: {Commission}',
  'agent.title.monthSettlementCommission': 'Periodic settlement commission',
  'agent.export.agentMonthExcel': 'Agent monthly settlement Commission report.xls',
  'agent.title.agentName': 'Agent name',
  'agent.title.depositAmount': 'deposit',
  'agent.title.withdrawAmount': 'drawing',
  'agent.title.totalChangeMoney': 'Service Charge',
  'agent.title.commissionReport1': 'Agent commission = offline platform Commission - offline discount - offline deposit and withdrawal service fee',
  'agent.title.commissionReport2': 'Offline platform Commission = (platform a wins * {platformCost} * platform a commission ratio) + (platform B wins * {platformCost} * platform B commission ratio) + (platform C wins * {platformCost} * platform C commission ratio) +....',
  'agent.title.commissionReport3': 'Offline discount = the sum of all the discounts issued by the agent\'s subordinate members',
  'agent.title.commissionReport4': 'Service charge for offline deposit and withdrawal = (offline deposit + offline withdrawal) * {minAmount}',
  'agent.title.commissionReport5': 'Agent commission = (platform win / loss * {platformCost} - system bonus - user deposit / withdrawal amount * {minAmount}) * Commission proportion.',
  'agent.title.commissionReport6': 'Platform win / loss = total win / loss of each game platform.',
  'agent.title.commissionReport7': 'System bonus = the sum of all dividends paid on behalf of subordinate members.',
  'agent.title.commissionReport8': 'User deposit and withdrawal amount = the total amount of deposit and withdrawal on behalf of subordinate members.',
  'agent.title.commissionReport9': 'Commission proportion = agency commission proportion.',
  'agent.title.commissionForm': 'Commission Report',
  'agent.title.dataForm': 'Data report',
  'agent.title.childFlow': 'Offline pipelining',
  'agent.title.childBonus': 'Offline discount',
  'agent.title.childDeposit': 'Offline deposit',
  'agent.title.childWithdrawal': 'Offline drawing',
  'agent.title.childResult': 'Bottom line winning or losing',
  'agent.title.childCommission': 'Offline platform Commission',
  'agent.title.viewDetail': 'View details',
  'agent.title.childDWFee': 'Service charge for offline deposit and withdrawal',
  'agent.title.commission': 'Commission',
  'agent.title.childPlatformResult': 'Offline platform wins',
  'agent.title.minimumMonthlyTotalNetProfit': 'Minimum monthly total net profit',
  'agent.title.minimumMonthlyTotalNetProfit1': 'Please enter the minimum monthly total net profit',
  'agent.title.maximumMonthlyTotalNetProfit': 'Maximum monthly total net profit',
  'agent.title.maximumMonthlyTotalNetProfit1': 'Please enter the maximum monthly total net profit',
  'agent.title.addAgentCommissionRatio': 'Add agent commission proportion',
  'agent.title.activeMember': 'Active member',
  'agent.title.activeMember1': 'Please enter active member',
  'agent.title.commissionRatio': 'commission rate',
  'agent.title.commissionRatio1': 'Please enter Commission proportion',
  'agent.title.cancel': 'cancel',
  'agent.title.save': 'Preservation',
  'agent.title.defaultAgentDivision': 'Default agent split by platform percentage',
  'agent.title.platformFeeRatio': 'Platform fee proportion',
  'agent.title.platformWinLose': 'Platform win / loss coefficient',
  'agent.title.depositWithdrawalFeeMui': 'Service charge coefficient of deposit and withdrawal',
  'agent.title.comprehensiveCost': 'Please enter the comprehensive fee (percentage 0 - 100 )',
  'agent.title.eachMonthSettlementDay': 'Monthly settlement date',
  'agent.title.agentTaxPercentage': 'Platform tax rate',
  'agent.title.agentSharePercent': 'Proportion',
  'agent.title.childAgent': 'Sub agent commission settings',
  'agent.title.agentCommission': 'Agency commission',
  'agent.title.domainCheck': 'The domain names at the beginning of HTTP, HTTPS and WWW cannot be entered. Please omit.',
  'agent.title.fillDomainInfo': 'Fill in domain name information',
  'agent.title.agentDomain': 'Proxy domain name',
  'agent.title.agentDomain1': 'Please enter the domain name',
  'agent.title.isDefault': 'Is it the default?',
  'agent.title.isDefault1': 'Please choose whether to default',
  'agent.title.isDefault2': 'default',
  'agent.title.isDefault3': 'Non default',
  'agent.title.domain': 'domain name',
  'agent.title.domain1': 'Default domain name',
  'agent.title.domain2': 'Non default domain name',
  'agent.title.addDomain': 'Add domain name',
  'agent.title.userNameDomainCode': 'User name, domain name, code',
  'agent.title.currentStatus': 'current state',
  'common.title.detailInfo': 'detailed information',
  'agent.title.addRemark': 'Add remarks',
  'agent.title.addRemarkSuccess': 'Add comment succeeded!',
  'agent.title.addRemarkFail': 'Failed to add comment',
  'agent.title.addRemarkError': 'Add comment error',
  'agent.title.bankName': 'Bank name',
  'agent.title.bankAccount': 'Account name',
  'agent.title.bankAccount1': 'Please enter account name',
  'agent.title.bankAddr': 'Branch address',
  'agent.title.bankAddr1': 'Please enter the branch address',
  'agent.title.bankNumber': 'Bank account',
  'agent.title.normal': 'normal',
  'agent.title.activationCard': 'Do you want to activate this bank card?',
  'agent.title.deleteCard': 'Do you want to delete this bank card?',
  'agent.title.offlineCard': 'Do you want to disable this bank card?',
  'agent.title.bankInfo': 'Bank information',
  'agent.title.addBank': 'Add bank card',
  'agent.title.qrCode': 'QR code picture',
  'agent.title.pubQrCode': 'Publicity QR code',
  'agent.title.phoneNumber': 'Phone number',
  'user.title.registerTime1': 'Registration time',
  'user.title.firstDepositTime': 'First deposit time',
  'user.title.lastLoginTime1': 'Last login time',
  'user.title.lastDepositTime': 'Last deposit time',
  'user.title.lastWithdrawalTime': 'Last withdrawal time',
  'user.title.taotalDepositAmount': 'Total recharge amount',
  'user.title.totalWithdrawalAmount': 'Total withdrawal amount',
  'user.title.totalBonus1': 'Total discount',
  'user.title.totalBetFlow': 'Total flow',
  'user.title.goFail': 'Jump failure',
  'user.title.disableLogin': 'This account is not activated or frozen. You can\'t jump to login.',
  'agent.export.agentChildUserExcel': 'Agent user.xls',
  'user.title.agentCommissionConfig': 'Agent commission settings',
  'user.title.goingTo': 'Jump...',
  'user.title.bonusBinding': 'Preferential binding',
  'user.title.lastWithdrawalTime1': 'Last withdrawal time',
  'user.title.loginAsAgent': 'Log in as agent',
  'user.title.birthday': 'Birthday',
  'user.title.upperAgent': 'Superior agent',
  'user.title.accountFunds': 'Account funds',
  'user.title.freezingFunds': 'Frozen funds',
  'user.title.availableFunds': 'Funds available',
  'user.title.profileStatistics': 'General statistics',
  'user.title.historyPay': 'Historical payment',
  'user.title.exportChildUser': 'Export user report under name.xls',
  'user.title.fillBankCardInfo': 'Fill in bank card information',
  'user.title.adjustAccountBalanceSuccess': 'The account balance is adjusted successfully. The adjusted balance:',
  'user.title.adjustAccountBalanceFail': 'Failed to adjust account balance',
  'user.title.adjustAccountBalanceError': 'Error in adjusting account balance',
  'user.title.manualTransfer1': 'Please select reconciliation type',
  'user.title.increaseAmount': 'Increase amount',
  'user.title.decreaseAmount': 'Reduce the amount',
  'user.title.agencySpecificCommissionRatio': 'Percentage of exclusive Commission',
  'user.title.addAgencySpecificCommissionRatio': 'Add agent exclusive Commission proportion',
  'user.title.previousBalance': 'Previous balance',
  'user.title.afterBalance': 'After balance',
  'user.title.approved': 'Agreed',
  'user.title.notApproved': 'Not examined and approved',
  'user.title.pendingApproved': 'Pending approval',
  'user.title.rejected': 'Rejected',
  'user.title.historyBill': 'Historical bill',
  'user.title.deleteThisFee': 'Delete this charge?',
  'user.title.costTime': 'Cost generation time',
  'user.title.costType': 'Cost type',
  'user.title.costCreateTime': 'Expense creation time',
  'user.title.settled': 'Settled',
  'user.title.unsettlement': 'Unsettled',
  'user.title.changeFee': 'Amendment fee',
  'user.title.addFee': 'Additional cost',
  'user.title.notCalculated': 'Not calculated',
  'user.title.Calculated': 'Calculated',
  'user.title.fillCostInfo': 'Fill in expense information',
  'user.title.uploadPromotionPicture': 'Upload promotion pictures',
  'user.title.oldPromotionPicture': 'Old promotion pictures',
  'user.title.uploadFile': 'Please upload the file',
  'user.title.imageName': 'Picture name',
  'user.title.imageName1': 'Please enter a picture name',
  'user.title.imageName2': 'Please enter the name of the promotion picture',
  'user.title.addPromotionPicture': 'Add promotion picture',
  'user.title.confirmActivation': 'Confirm activation',
  'user.title.activationPicture': 'Activate this picture?',
  'user.title.banPicture': 'Do you want to disable this picture?',
  'user.title.deletePicture': 'Delete this picture?',
  'user.title.newChildCount': 'Number of new registrations',
  'user.title.activationChildCount': 'Number of active downlines',
  'user.title.lowerBetCount': 'The total number of bettors at the lower level',
  'user.title.depositChildCount': 'Number of deposit lines',
  'user.title.firstDepositChildCount': 'Number of first deposit and end of line',
  'user.title.whitdrawalChildCount': 'Number of withdrawal lines',
  'user.title.totalDepositChildAmount': 'Total deposit offline',
  'user.title.totalWithdrawalChildAmount': 'Total withdrawal offline',
  'user.title.totalBonusChild': 'Total offline benefits',
  'user.title.totalBetFlowChild': 'Total downline flow',
  'user.title.totalResultChild': 'Always win or lose offline',
  'user.title.confirmWithdrawal': 'Do you confirm the withdrawal?',
  'user.title.confirmConfirm': 'Can\'t be changed after confirmation?',
  'user.title.rejectWithdrawal': 'Do you want to decline this withdrawal?',
  'user.title.rejectConfirm': 'Can\'t be changed after rejection?',
  'user.title.withdrawalNumber': 'Presentation number',
  'user.title.agree': 'Agree!',
  'user.title.userAccountAndNumber': 'User name / number',
  'user.title.fillRemarkInfo': 'Fill in notes',
  'user.title.confirmBinding': 'Confirm binding',
  'user.title.confirmBinding1': 'Are you sure to bind this offer?',
  'user.title.alreadyBiding': 'Offer already bound',
  'user.title.changeBindingBonus': 'The agent has already bound {bonusName} This enrollment offer. Are you sure you want to replace it?',
  'user.title.alreadyBindingBonus': '{agentAccount} this agent has already bound the {bonusName} offer.',
  'user.title.registerBonusBiding': 'Registration offer binding related',
  'user.title.registerGiftAmount': 'Registered gift amount',
  'user.title.flowTimes': 'Flow multiple',
  'user.title.binding': 'binding',
  'user.title.noBackFlowAgent': 'Is there a no return discount for members under this agent? (water discount and real-time return discount)',
  'user.title.haveBackFlowAgent': 'Do you want to set up a return discount for members under this agent? (water discount and real-time return discount)',
  'user.title.resetPayPass': 'Reset payment password',
  'user.title.haveBackFlow': 'Return water',
  'user.title.noBackFlow': 'No return water',
  'user.title.addCommonAgent': 'Add general agent',
  'user.title.noSelect': 'No choice',
  'user.title.assignUser': 'Please select the users to be assigned',
  'user.title.choseSalesperson': 'Please select the telemarketing personnel to be given',
  'user.title.wrongChose': 'Wrong choice',
  'user.title.assignUserError': 'The user selected for distribution must be greater than or equal to the selected telemarketing personnel',
  'user.title.userType': 'customer type',
  'user.title.importUser': 'Importing users',
  'user.title.silentUser': 'Silent user',
  'user.title.registerUndepositUser': 'Register non deposited users',
  'user.title.memberListImport': 'Member list import',
  'user.title.importInfo': 'Import information',
  'user.title.importRemark': 'Import remarks',
  'user.title.importSrouce': 'Import source',
  'user.title.stepTwo': 'Step 2 select and assign the telemarketing personnel',
  'user.title.allSalesperson': 'All telemarketing personnel',
  'user.title.assign': 'distribution',
  'user.title.assignList': 'Allocation list',
  'user.title.assignListDetail': 'Distribution list details',
  'user.title.assignTime': 'Allocate time-',
  'user.title.isRecycle': 'Is it recycled?',
  'user.title.confirmRecycle': 'Are you sure you want to recycle?',
  'user.title.assignedTo': 'Assign to',
  'user.title.assignedUser': 'Distributive person',
  'user.title.recycled': 'Recovered',
  'user.title.recycle': 'recovery',
  'user.title.recycleAll': 'All recycling',
  'user.title.confirmRecycle1': 'Note: after the number is recycled, the performance generated by the number will not be calculated.',
  'user.title.assignTime1': 'Allocation time',
  'user.title.userAttribute': 'user attribute',
  'user.title.assignPersonCount': 'Distribution number',
  'user.title.alreadyAssignList': 'Assigned list',
  'user.title.importListMode': 'The format of import list is as follows',
  'user.title.importListMode1': 'Column 1: phone number',
  'user.title.importListMode2': 'Column 2: import details',
  'user.title.importListMode3': 'Third column: import notes',
  'user.title.teleSaleAssignList': 'Telemarketing - distribution list',
  'user.title.importDesc': 'Import instructions',
  'user.title.assignMgt': 'Distribution management',
  'user.title.waitAssignList': 'Waiting list',
  'user.title.lastLogin': 'Last login',
  'user.title.activationTime': 'Activation time',
  'user.title.activationFirstDeposit': 'First save after activation',
  'user.title.activationTotalDeposit': 'Total deposit after activation',
  'user.title.salesperson': 'Telemarketing specialist-',
  'user.title.Salesperson1': 'Please select the telemarketing personnel',
  'user.title.Salesperson2': 'No telemarketing personnel selected',
  'user.title.times': 'second',
  'user.title.firstDepositCount': 'First deposit {regNotDepositCount} person',
  'user.title.recoverCount': 'Retrieve {silentUserCount} people',
  'user.title.registerCount': 'Register {importRegCount} people',
  'user.title.saleStatus': 'Sales status (you can click any status to enter the user list)',
  'user.title.undialedUser': 'Subscriber not dialed',
  'user.title.followUpUsers': 'Users to be followed up',
  'user.title.dialed': 'Already dial',
  'user.title.dialedThisMonth': 'Dialed this month',
  'user.title.connectionRate': 'Connection rate',
  'user.title.teleQuality': 'Call quality',
  'user.title.performanceOverview': 'Performance overview',
  'user.title.averageCallDuration': 'Average call duration',
  'user.title.commissioner': 'Commissioner',
  'user.title.numberDials': 'Number of calls',
  'user.title.chooseSalesperson': 'Select telemarketing personnel',
  'user.title.uncalledUserList': 'User list not dialed',
  'user.title.dialedUserList': 'Dialed users list',
  'user.title.followUpListUsers': 'List of users to be followed up',
  'user.title.activationDeposit': 'Deposit after activation',
  'user.title.notDialed': 'Not dialed',
  'user.title.keepFollow': 'Continue to follow up',
  'user.title.cancelFollow': 'Cancel follow up',
  'user.title.affiliatedSales': 'Electrical pins',
  'user.title.invitationCodeUser': 'Invitation code user',
  'user.title.myPerformance': 'My achievements',
  'user.title.performanceDetails': 'Details of performance',
  'user.title.performanceList': 'Performance details',
  'user.title.dailyPerformanceStatistics': 'Daily performance statistics',
  'user.title.registrationNoDeposit': 'Newly registered but not deposited',
  'user.title.dialCount': 'Dial and measure',
  'user.title.activationsCount': 'Activation number',
  'user.title.currentPerformanceOverview': 'Current performance overview',
  'user.title.calledThisMonth': 'Dialed this month',
  'user.title.seatNumber': 'Seat number',
  'user.title.currentAgentAssignor': 'Current seat allocator',
  'user.title.seatMgt': 'Telemarketing - seat management',
  'user.title.assignSeatSalesperson': 'Distribution of telemarketing seats',
  'user.title.seatSalesperson': 'Seat personnel',
  'user.title.seatSalesperson1': 'Please input the assigned telemarketing personnel',
  'user.title.times1': 'frequency',
  'user.title.percent': 'Percentage (%)',
  'user.title.seatSalesperson2': 'Please select the person to be assigned',
  'user.title.offlineOutThreeDay': 'Users not logged in for more than three days',
  'user.title.userInfo': 'User information',
  'user.title.registerAndLogin': 'Sign up / login',
  'user.title.telemarketing': 'Telemarketing',
  'user.title.remarkInfo': 'Remarks information',
  'user.title.editAt': 'Editor in',
  'user.title.confirm': 'Determine',
  'user.title.waitIntoDialList': 'Whether to enter the list of users to be dialed',
  'user.title.confirmWaitIntoDialList': 'Please confirm whether to enter the list of users to be dialed',
  'user.title.waitIntoDialedList': 'Whether to enter the dialed users list',
  'user.title.confirmWaitIntoDialedList': 'Please confirm whether to enter the dialed user list',
  'user.title.waitIntoFollowList': 'Whether to enter the list of users to be followed up',
  'user.title.confirmWaitIntoFollowList': 'Please confirm whether to enter the list of users to be followed up',
  'user.title.platformSerialNumber': ', platform serial number:',
  'user.title.gameSerialNumber': 'Game serial number',
  'user.title.rawData': 'Raw data (game platform time)',
  'user.title.verified': 'Certified',
  'user.title.unfilled': 'Not filled',
  'user.title.notCertified': 'Uncertified',
  'user.title.userInfoExcel': 'Member information report.xls',
  'user.title.riskControlLevel': 'Wind control level',
  'user.title.dateEnrollment': 'Date of admission',
  'user.title.firstDepositDate': 'First deposit date',
  'user.title.bankCardList': 'Bank card list',
  'user.title.unBinding': 'Unbind',
  'user.title.confirmUnBinding': 'Are you sure to unbind?',
  'user.title.confirmEnableBankCard': 'Are you sure to enable this bank card?',
  'user.title.isDisable': 'Is it forbidden?',
  'user.title.confirmDisableBankCard': 'Do you want to disable this bank card?',
  'user.title.bankRelated': 'Bank related',
  'user.title.bankCode': 'Bank code',
  'user.title.accountRelated': 'Account related',
  'user.title.unbindingAll': 'Unbind all',
  'user.title.confirmUnbindingAllCard': 'Note: after this operation, all bank cards belonging to the user will be unbound.',
  'user.title.changeUpperAgent': 'Modify parent agent',
  'user.title.oldAgent': 'Original agent',
  'user.title.newAgent': 'New agent',
  'user.title.newAgentAccount': 'New agent account',
  'user.title.deviceRelateUser': 'Log in to the associated user of the device',
  'user.title.devicId': 'Device ID',
  'user.title.devicIdAppType': 'Equipment source',
  'user.title.relateUser': 'Associated users',
  'user.title.relateUserNum': 'Number of Linked User Accounts',
  'user.title.emailAuthentication': 'Mailbox authentication',
  'user.title.newMail': 'New mailbox',
  'user.title.oldMail': 'Old mailbox',
  'user.title.lockFundsList': 'Locked funds list',
  'user.title.bonusLock': 'Preferential lock',
  'user.title.depositLock': 'Deposit lock',
  'user.title.confirmOffer': 'Please confirm whether to issue?',
  'user.title.confirmRejectApply': 'Are you sure you want to decline this offer?',
  'user.title.confirmCancel': 'Confirm cancel',
  'user.title.confirmCancelBonus': 'Are you sure you want to cancel this offer?',
  'user.title.baseBonus': 'Preferential principal',
  'user.title.lockAmount': 'Lock amount',
  'user.title.getBonusTime': 'Preferential collection time',
  'user.title.flowCompletionProgress': 'Flow completion progress',
  'user.title.completedFlow': 'Flow completed',
  'user.title.targetFlow': 'Target flow',
  'user.title.confirmUnlockDeposit': 'Are you sure to unlock this deposit?',
  'user.title.inviteUserRecordList': 'Invitation member record list',
  'user.title.getBonus': 'Preferential treatment',
  'user.title.loginIpRelateUser': 'Log in IP associated user',
  'user.title.verifiedName': 'Real name authentication',
  'user.title.realName': 'Real name',
  'user.title.newRealName': 'New real name',
  'user.title.newIdNo': 'New ID No',
  'user.title.oldRealName': 'Old real name',
  'user.title.oldIdNo': 'Old ID number',
  'user.title.realName1': 'Please enter the correct real name',
  'user.title.idNo1': 'Please enter the correct ID number',
  'user.title.verifyPhone': 'Mobile phone authentication',
  'user.title.phoneNumber': 'Cell-phone number',
  'user.title.newPhoneNumber': 'New mobile phone number',
  'user.title.oldPhoneNumber': 'Old cell phone number',
  'user.title.phoneNumber1': 'Please input the correct mobile number',

  'user.title.aliPayAccount': 'Alipay account',
  'user.title.alipayPhone': 'Alipay mobile phone number',
  'user.title.alipayEmail': 'Alipay email number',
  'user.title.alipayRealName': 'Alipay real name',
  'user.title.delAlipay': 'Delete your Alipay account',
  'user.title.askDelAlipay': 'Please confirm to delete your Alipay account',
  'user.title.confirmUnbindingAllAliPay': 'Note: After this operation, all Alipay accounts belonging to the user will be unbound.',
  'user.title.confirmUnbindingAllUSDT': 'Note: After this operation, all USDT accounts belonging to the user will be unbound.',
  'user.title.confirmUnbindingAllVirtual': 'Note: After this operation, all virtual currency accounts belonging to this user will be unbound.',
  'user.title.delUSDT': 'Example Delete a USDT address',
  'user.title.askDelUSDT': 'Please confirm to delete the USDT address?',

  'user.title.getAccountBalanceFail': 'Failed to get account amount.',
  'user.title.getAccountBalanceError': 'Error getting account amount.',
  'user.title.getBackSuccess': 'Get back to success',
  'user.title.batchGetBack': 'In batch retrieval, please check the account balance later.',
  'user.title.getBackFail': 'Retrieve failure',
  'user.title.getBackError': 'Retrieve error',
  'user.title.refreshSuccess': 'Refresh success',
  'user.title.refreshFail': 'refresh failed',
  'user.title.refreshError': 'refresh error',
  'user.title.accountInfo': 'Account information (unit: yuan)',
  'user.title.accountInfoVN': 'Account information (unit: VND)',

  'user.title.getBackAll': 'Retrieve all',
  'user.title.refreshAll': 'Full refresh',
  'user.title.totalBalance': 'Total balance',
  'user.title.mainAccount': 'Main account',
  'user.title.detail': 'details',
  'user.title.refresh': 'Refresh',
  'user.title.money': 'element',
  'user.title.moneyVND': 'VND',
  'user.title.point': 'integral',
  'user.title.requestTimeAndOfferTime': 'Application time | release time',
  'user.title.bonusContent': 'Preferential content',
  'user.title.bonusType': 'Preferential type',
  'user.title.offerAdmin': 'Distributor',
  'user.title.resetWithdrawalPass': 'Reset withdrawal password',
  'user.title.inviteRecord': 'Invitation record',
  'user.title.relatedDevice': 'Associated device',
  'user.title.relateIP': 'Correlation IP',
  'user.title.bankCard': 'Bank card',
  'user.title.noeLogin': 'Not logged in',
  'user.title.relate': 'Associated',
  'user.title.noBindingBankCard': 'Bank card not bound',
  'user.title.relateBankCard': 'Related bank card',
  'user.title.female': 'Female sex',
  'user.title.male': 'Male',
  'user.title.unverifiedID': 'Identity not authenticated',
  'user.title.verifiedMail': 'Mailbox authenticated',
  'user.title.unverifiedMail': 'Email not authenticated',
  'user.title.verifiedPhone': 'Phone certified',
  'user.title.mobilePhoneAttribution': 'Mobile home',
  'user.title.confirmResetUserPass': 'Are you sure you want to reset the user password? Do you need a new password to log in after the reset?',
  'user.title.confirmResetUserWithdrawal': 'Are you sure you want to reset the user\'s withdrawal password?',
  'user.title.confirmChangeSourceToRegister': 'Do you want to delete the member source agent and register yourself instead?',
  'user.title.noneSet': 'Not set up',
  'user.title.cancelAgent': 'Revoke agency',
  'user.title.playerInviteCode': 'Player invitation code',
  'user.title.invited': ', invited:',
  'user.title.noneInvitedRecord': 'No invitation record yet',
  'user.title.noneLoginRecord': 'Not signed in yet',
  'user.title.changeRegisterSource': 'Modify registration source',
  'user.title.signPoint': 'Check in score',
  'user.title.userLevel1': 'Membership level',
  'user.title.expireDate': 'Due time',
  'user.title.permanent': 'Permanent validity',
  'user.title.totalManualTransfer': 'General manual reconciliation',
  'user.title.wechat': 'WeChat',
  'user.title.loginTimes': 'Login 9999 {loginCount} times',
  'user.title.pointChange': 'Integral change',
  'user.title.remarkCount': 'There are {length} comments',
  'user.title.getRiskInfoFail': 'Failed to get risk control information.',
  'user.title.getRiskInfoError': 'Error getting risk control information.',
  'user.title.transactionTime': 'Transaction time',
  'user.title.addBonusError': 'Add offer error',
  'user.title.addBonus': 'Add discount',
  'user.title.bonusName1': 'Please enter the name of the offer',
  'user.title.bonusName2': 'Please input how much target flow is needed to withdraw',
  'user.title.withdrawTargetFlow': 'Withdrawable target flow',
  'user.title.orderNo': 'Please enter the order number',
  'user.title.processingFail': 'Processing failed, please try again later',
  'user.title.adjustedLevelSuccess': 'Level adjustment succeeded!',
  'user.title.adjustedLevelFail': 'Failed to adjust level',
  'user.title.adjustedLevelError': 'Adjustment level error',
  'user.title.liuheLevel': 'Liuhe rank',
  'user.title.adjustLiuheLevel': 'Adjust the six levels of membership',
  'user.title.liuheLevel1': 'Please select Six Harmonies level',
  'user.title.adjustUserLevel': 'Adjust membership level',
  'user.title.adjustAccountPointSuccess': 'Adjustment of account points succeeded. Points after adjustment:',
  'user.title.adjustAccountPointFail': 'Failed to adjust account points',
  'user.title.adjustAccountPointError': 'Error in adjusting account points',
  'user.title.pointAdjust': 'Integral adjustment',
  'user.title.changePoint': 'Addition and subtraction integral',
  'user.title.changePoint1': 'Please enter the points to add or subtract',
  'user.title.changedPoint': 'Integral of addition and subtraction',
  'user.title.showColor': 'Display color',
  'user.title.showColor1': 'Please select display color',
  'user.title.defaultBlack': 'Black (default)',
  'user.title.red': 'Red',
  'user.title.blue': 'blue',
  'user.title.green': 'green',
  'user.title.riskLevel1': 'Please select the risk level',
  'user.title.noneBindingMail': 'User mailbox is not bound',
  'user.title.sendMailSuccess': 'Mail sent successfully',
  'user.title.sendMailFail': 'Failed to send mail',
  'user.title.sendMailError': 'Send mail error',
  'user.title.loadTemplateFail': 'Failed to load template',
  'user.title.loadTemplateError': 'Error loading template',
  'user.title.sendMail': 'Send emails',
  'user.title.sendMail1': 'Send mail',
  'user.title.optionalTemplate': 'Optional template',
  'user.title.mailTitle': 'Mail title',
  'user.title.mailTitle1': 'Please enter a message title',
  'user.title.mailContent': 'Mail content',
  'user.title.mailContent1': 'Please enter the message content',
  'user.title.sendSiteTextSuccess': 'Succeeded in sending in station message',
  'user.title.sendSiteTextFail': 'Failed to send in station message',
  'user.title.sendSiteTextError': 'Error in sending station message',
  'user.title.sendSiteText': 'Send in station message',
  'user.title.siteText': 'mail',
  'user.title.missOrder': 'You can go to member management - recharge order management for manual confirmation after payment.',
  'user.title.countIn': 'Credited to deposit and withdraw',
  'user.title.orderName1': 'Please enter the order name, otherwise the default value will be used',
  'user.title.orderName': 'Order number',
  'user.title.orderName2': 'Please enter the order number',
  'user.title.unbindingSeatNumber': 'The seat number is not bound. Please bind the seat number before operation',
  'user.title.recentMainAccountTran': 'Recent main account transactions',
  'user.title.last7DayBet': 'Last seven days',
  'user.title.bonusBonus': 'Preferential treatment',
  'user.title.userPoint': 'Membership score',
  'user.title.operateLog': 'Operation log',
  'user.title.allUser': 'All users',
  'user.title.depositRate': 'Deposit rate',
  'user.title.depositRate1': 'Deposit rate: deposit user / total user',
  'user.title.depositUserComposition': 'Composition of deposit users',
  'user.title.depositAmount': 'Deposit amount (current day)',
  'user.title.totalDepositCount': 'Total deposits',
  'user.title.totalDepositAmount': 'Total deposit amount',
  'user.title.senderRecipientTitle': 'From / to / Title',
  'user.title.recipient': 'Addressee',
  'user.title.sender': 'Sender',
  'user.title.registerAndFirstAndLastLoginTime': 'Registration, First Login, and Last Login Information',
  'user.title.unDeposit': 'No deposit',
  'user.title.totalDepositTotalWithdrawal': 'Total deposit',
  'user.title.realNamePhoneMail': 'Real name | mobile phone | email',
  'user.title.userListExcel': 'Member list report.xls',
  'user.title.friendsInvite': 'Friend invitation',
  'user.title.minDepositCount': 'Minimum deposit times',
  'user.title.maxDepositCount': 'Maximum deposit times',
  'user.title.depositCount': 'Number of deposits',
  'user.title.minDepositAmount': 'Minimum deposit amount',
  'user.title.maxDepositAmount': 'Maximum deposit amount',
  'user.title.depositAmount1': 'Deposit amount',
  'user.title.resultExport': 'Results export',
  'user.title.firstDepositRate': 'First survival rate',
  'user.title.rate': 'ratio',
  'user.title.7DaysLost': '7 days lost: users who have not logged in for 7 consecutive days',
  'user.title.14DaysLost': '14 days lost: users who have not logged in for 14 consecutive days',
  'user.title.30DaysLost': '30 days lost: users who have not logged in for 30 consecutive days',
  'user.title.7DaysLostAndBack': 'Backflow users: users lost in 7 days and logged in within the time period',
  'user.title.lostAndUserCount': 'Loss rate: Lost users / total users',
  'user.title.lostBackAndTotalLost': 'Backflow rate: backflow users / total lost users',
  'user.title.7DaysLost1': 'Loss of 7 days',
  'user.title.14DaysLost1': 'Loss of 14 days',
  'user.title.30DaysLost1': 'Loss of 30 days',
  'user.title.lostAndLostBack': 'Lost and returned users',
  'user.title.lostAndLostBack1': 'Loss rate and return rate',
  'user.title.lostUser': 'Loss user',
  'user.title.lostBackUser': 'recurring user',
  'user.title.lostRate': 'Wastage rate',
  'user.title.lostBackRate': 'Reflux rate',
  'user.title.newUserCount': 'Number of new users',
  'user.title.silentUserCount': 'Number of silent users',
  'user.title.silentUser90Days': 'Silent users: users who have not logged in for {days} consecutive days',
  'user.title.silentUserRate': 'Proportion of silent users: silent users / total users',
  'user.title.silentUserRate1': 'Proportion of silent users',
  'user.title.absoluteValue': 'absolute value',
  'user.title.retentionRate': 'Retention',
  'user.title.dayAfter': 'Days later',
  'user.title.weekAfter': 'Zhou Hou',
  'user.title.monthAfter': 'After month',
  'user.title.retentionUser': 'Retained user: the new user who deposits is called retained user',
  'sys.added.prize1': 'Prize added',
  'sys.stock': 'Stock',
  'sys.download': 'download',
  'sys.stockNum': 'Stock number',
  'sys.stockNum1': 'Please enter inventory',
  'sys.hasStock': 'Inventory type',
  'sys.hasStock0': 'Unlimited',
  'sys.hasStock1': 'Limited quantity',
  'sys.hasStock3': 'Please select the prize type',
  'lottery.lotteryTime': 'Lucky draw time',
  'sys.set': 'Set up',
  'sys.update': 'modify',
  'sys.platformCode': 'Platform CODE',
  'sys.msg24': 'Time to return water discount (if two time to return water are set, the system will issue the discount according to the earlier creation time)',
  'sys.msg28': 'Weekly salary\'s gift',
  'sys.msg29': 'Please enter salary and gift',
  'sys.msg30': 'Monthly salary and gift',
  'sys.msg31': 'Please input monthly salary and gift',
  'sys.vip6': 'VIP {vipLevel} maximum amount should be greater than minimum amount!',
  'sys.msg41': 'Bet amount method: integral multiple rate: {pointPercent}, maximum no more than: {maxPoint}',
  'sys.msg42': 'Payment method: amount multiple rate: {moneyPercent}, maximum no more than: {maxMoney} yuan|',
  'sys.msg42VN': 'Payment method: amount multiple rate: {moneyPercent}, maximum no more than: {maxMoney} VND|',
  'sys.msg61': 'Preferential amount',
  'sys.msg66': 'Deposit amount: {minDeposit} ~ {maxDeposit} daily requirement: {betMultiple} times or more',
  'sys.msg67': 'Free cash: {giftPercent}%,max cash: {maxBonusAmount} | flow multiple: {betMultiple}',
  'sys.msg87': 'About to delete article type of Title {name}',
  'sys.msg93': 'Mobile - upload game logo',
  'sys.msg94': 'Mobile - upload game logo',
  'sys.msg95': 'About to delete configuration item {name}!',
  'sys.msg105': 'About to disable picture group with name: {imgName}',
  'sys.submitPer': 'submitter',
  'sys.submitTime': 'Submission time',
  'sys.inputYear': 'Year of importation',
  'sys.h5': 'Support H5',
  'sys.h51': 'Please select whether H5 is supported',
  'sys.pcPic': 'PC pictures',
  'sys.h5Pic': 'H5 pictures',
  'sys.operatePermission': 'Operation authority',
  'sys.uploadApp': 'Upload app file',
  'user.title.totalUserCount': 'Total:',
  'user.title.totalDepositUserCount': 'Total deposits',
  'user.title.totalFirstDepositUserCount': 'First deposit amount',
  'common.operateSuccess2': 'The operation is successful. The system will process it automatically. Please refresh the query later.',
  'common.export.type2': 'General agent export',
  'common.export.type1': 'Total member export',
  'common.radio.seconds': 'second',
  'menu.operation.frontContent.nav': 'Navigation management',
  'menu.information.lotteryUserTrace.lotteryUserDailyTask': 'Daily tasks',
  'menu.information.lotteryUserTrace': 'Member trail',
  'menu.information.lotteryOrder.orderList': 'Purchase order',
  'menu.information.lotteryOrder.giveBonusList': 'Awards record',
  'menu.information.lotteryOrder': 'Liuhe order',
  'menu.information.lotteryManager.generalManager': 'General configuration',
  'menu.information.lotteryManager.userBanList': 'Forbidden management',
  'menu.information.lotteryManager.dailyTaskManager': 'Daily tasks',
  'menu.information.lotteryManager.lotteryLevelSetting': 'Level setting',
  'menu.information.lotteryManager': 'Liuhe management',
  'menu.information.lotteryOpen.queryLotteryEntryList': 'Award source entry',
  'menu.information.lotteryOpen.queryLotteryHistoryList': 'Lottery results',
  'menu.information.lotteryOpen.queryLotteryOpenDateList': 'Lottery date',
  'menu.information.lotteryOpen': 'Lottery Management',
  'menu.information': 'information',
  'menu.queryMarket': 'My list',
  'menu.unLoggedList': 'Unlisted list',
  'menu.queryAllocation': 'Allocation list',
  'menu.querySeat': 'Seat management',
  'menu.queryTeam': 'Team performance',
  'menu.queryMyScore': 'My achievements',
  'menu.queryAllScore': 'View the details of the Commissioner',
  'menu.callListA': 'Call details',
  'menu.callRecord': 'Call Record',
  'menu.userInfoCallRecord': 'Member details call record',
  'menu.tele': 'Electric pin system',
  'menu.queryAgent': 'Proxy list',
  'menu.agentContact': 'Agent information',
  'menu.queryPhoto': 'Promotional pictures',
  'menu.agentCommissionSetting': 'Commission setting',
  'menu.queryOtherCost': 'Other agency fees',
  'menu.agentDomain': 'Proxy domain name',
  'menu.commissionReport': 'Commission Report',
  'menu.agentReport': 'Proxy statement',
  'menu.agent': 'Agent system',
  'menu.addAdvertising': 'New advertising expenses',
  'menu.queryAdAgent': 'List of advertising channels',
  'menu.ad': 'Advertising management',
  'menu.market': 'Market promotion',
  'menu.riskSetting': 'Withdrawal approval',
  'menu.userPropAuth': 'Member attribute review',
  'menu.bonusLockList': 'Preferential lock',
  'menu.depositLockList': 'Deposit lock',
  'menu.checkAgentCommissionByRisk': 'Agent commission risk control audit',
  'menu.queryGameTrans': 'Abnormal game transfer',
  'menu.risk': 'Risk Management',
  'menu.overall': 'Overall trend',
  'menu.reportBetRecord': 'Betting record report',
  'menu.sportUnSettlement': 'Sports unsettled records',
  'menu.realTimeStatistics': 'Real time statistics',
  'menu.analyze.onlineUser': 'Online users',
  'menu.reportPlatform': 'Platform overview',
  'menu.reportChannel': 'Channel Report',
  'menu.reportGamePlatform': 'Game platform report',
  'menu.analyze.reportManualTransfer': 'Reconciliation statement',
  'menu.reportDeposit': 'Deposit statement',
  'menu.reportWithdrawal': 'Withdrawal statement',
  'menu.reportDividend': 'Preferential statement',
  'menu.analyze.userGameReport': 'User Game Report',
  'menu.userDeposit': 'User recharge Report',
  'menu.paymentStatistics': 'Payment channel Report',
  'menu.analyze.paymentTab': 'Payment success rate report',
  'menu.operationLog': 'Operation log',
  'menu.analyze.smsNameVerifyLog': 'Certification generation record',
  'menu.analyze': 'Data analysis',
  'menu.queryPayOrder': 'Recharge order management',
  'menu.finance.queryOfflinePayOrder': 'Offline payment review',
  'menu.finance.queryOnlinePayOrder': 'Online payment management',
  'menu.finance.payFrontConfig': 'Payment classification settings',
  'menu.finance.payConfig': 'Payment channel setting',
  'menu.finance.withdrawPay': 'Payment channel setting',
  'menu.checkAgentCommissionByFinance': 'Agency commission financial audit',
  'menu.finance.config.payChannel': 'Payment channel setting',
  'menu.finance.config.withdraw': 'Payment channel setting',
  'menu.finance.config': 'Payment settings',
  'menu.finance': 'Financial Center',
  'menu.queryRole': 'Role management',
  'menu.adminAccount': 'Background account management',
  'menu.sys.userSysAdmin': 'System parameter management',
  'menu.sys.lottery.queryLotteryMethodList': 'Gameplay management',
  'menu.sys.lottery.queryLotteryPropList': 'Attribute management',
  'menu.sys.lottery.queryLotteryRateList': 'Odds management',
  'menu.sys.lottery.queryLotteryHistoryList': 'Lottery results',
  'menu.sys.lottery': 'Lottery Management',
  'menu.queryMailPool': 'Mailbox configuration',
  'menu.queryMailTemplate': 'Mail template',
  'menu.queryGameList': 'Game list settings',
  'menu.paymentSuccessRate': 'Payment success rate alert settings',
  'menu.slotManage': 'Slot management',
  'menu.payIpWhitelist': 'Payment IP white list',
  'menu.sys.ipBlockList': 'User IP blacklist',
  'menu.sys.deviceBlockList': 'Blacklist of user equipment',
  'menu.ipWhitelist': 'Background IP white list',
  'menu.ticket': 'Work order system',
  'menu.unlockCondition': 'Auto unlock pipeline settings',
  'menu.uploadPackage': 'APP package management',
  'menu.sys': 'System setup',
  'menu.queryMenu': 'Menu management',
  'menu.queryButton': 'Button management',
  'menu.queryNotify': 'Notification type management',
  'menu.queryConfig': 'system parameter',
  'menu.ee.withdrawPay': 'Payment channel setting',
  'menu.paySetting': 'Payment parameters',
  'menu.queryAdmin': 'Administrator Account Management ',
  'menu.ee': 'Egg',
  'menu.pictureGroup': 'Picture management',
  'menu.queryGamePlatform': 'Game platform settings',
  'menu.signQueryGamePlatform': 'Game platform logo settings',
  'menu.queryWithdraw': 'Withdrawal order management',
  'menu.C2CWithdraw': 'C2C Withdrawal order management',
  'constants.riskLevelType_-10': 'Limited access to benefits',
  'constants.nav_0': 'home page',
  'constants.nav_1': 'Real person',
  'constants.nav_2': 'Sports',
  'constants.nav_3': 'Electronics',
  'constants.nav_4': 'Chess and card',
  'constants.nav_5': 'fishing',
  'constants.nav_6': 'lottery',
  'constants.nav_7': 'Diamond Club',
  'constants.nav_8': 'Discount',
  'constants.nav_9': 'Concession Hall',
  'constants.nav_10': 'Other',
  'constants.transferType_6': 'Frozen',
  'constants.transferType_7': 'Thaw',
  'constants.regSourceType_4': 'Invitation',
  'constants.bonusType_1': 'Preferential water treatment',
  'constants.bonusType_2': 'Deposit discount',
  'constants.bonusType_3': 'Invitation to discount',
  'constants.bonusType_4': 'Sign in preference',
  'constants.bonusType_5': 'Manual review offer',
  'constants.bonusType_6': 'Continuous deposit preference',
  'constants.bonusType_7': 'Registration preferences',
  'constants.bonusType_8': 'Preferential deposit channels',
  'constants.bonusType_9': 'Note preference',
  'constants.bonusType_10': 'Betting preference',
  'constants.bonusType_11': 'Water return discount',
  'constants.bonusType_12': 'Real time deposit offer',
  'constants.bonusType_13': 'Information binding offer',
  'constants.bonusType_14': 'Lottery discount',
  'constants.bonusType_15': 'Sign in bonus',
  'constants.bonusType_16': 'Continuous deposit and investment preference',
  'constants.bonusType_19': 'Daily task discount',
  'constants.bonusType_24': 'Invitation to discount(New)',
  'constants.bonusType_26': 'Coded red envelope',
  'constants.bonusType_28': 'First Withdrawal Offer',
  'constants.bonusType_30': 'Big Spin Offer',
  'constants.bonusType_31': 'Accumulated deposit and investment discounts',
  'constants.bonusType_32': 'Game pen save',
  'constants.bonusType_33': 'Preferential withdrawal channels',
  'constants.bonusType_34': 'Seven-day deposit offer',
  'constants.bonusType_38': 'Recharge page discount',
  'constants.gameSport3_XA': 'Ai Ai competition',
  'constants.gameSport3_LH': 'Thunder and lightning competition',
  'constants.gameSport3_FB': 'Speed sports',
  'constants.gameSport3_SBO': 'SBO sports',
  'constants.gameSport3_JC': 'Competitive lottery Sports',
  'constants.gameSport3_AISPORT': 'AI sports',
  'constants.gameSport3_FBTY': 'FB sports',
  'constants.gameSport3_HG': 'crown sports',
  'constants.gameSport3_PM': 'PM sports',
  'constants.gameSport3_SBOI': 'SBOI sports',
  'constants.gameChess6_TM': 'Tian Mei chess and card',
  'constants.gameChess6_LC': 'Dragon City Chess',
  'constants.signType_0': 'Popular',
  'constants.signType_1': 'activity',
  'constants.signType_2': 'A Grand Prix',
  'constants.gameSignType_0': 'Popular',
  'constants.gameSignType_1': 'Electronics',
  'constants.gameSignType_2': 'Real person',
  'constants.gameSignType_3': 'Sports',
  'constants.gameSignType_4': 'lottery',
  'constants.gameSignType_5': 'fishing',
  'constants.gameSignType_6': 'Chess and card',
  'analyze.card.rechargeRate': 'Recharge rate',
  'game.title.betAmount1': 'Amount of bet',
  'game.title.playerProfit1': 'Player profitability',
  'user.title.channel': 'channel',
  'sys.navName': 'Navigation name',
  'sys.navName.prompt': 'Please enter a navigation name',
  'sys.nav.type': 'Navigation type',
  'sys.nav.type.prompt': 'Please select a navigation type',
  'sys.nav.img': 'Navigation pictures',
  'sys.nav.img.prompt': 'Please upload the navigation picture',
  'sys.nav.modal.list': 'Navigation list',
  'sys.title.limitLength200': 'Please enter less than 200 characters',
  'agent.settlementDate.month': 'Settlement month',
  'agent.settlementDate.startDate': 'start',
  'agent.settlementDate.endDate': 'End',
  'pay.title.cancelOrder': 'Cancellation of order',
  'pay.title.cancelOrder1': 'Are you sure you want to cancel the order?',
  'sys.title.orderAmount3': 'Cancelled',
  'pay.title.rejectInfo': 'Refuse information',
  'login.install.current': 'Current version number',
  'lottery.title.confirmNotice16': 'Confirm to reset the agent payment password. After resetting, the new password is required for agent withdrawal?',
  'lottery.title.day': 'day',
  'agent.title.resetPassSuccess1': 'Reset withdrawal password succeeded',
  'agent.title.newPassIs1': 'Reset the withdrawal password successfully. The new password is:',
  'user.title.address': 'address',
  'user.title.updatePromotionPicture': 'Modify promotion picture',
  'user.title.unTied': 'Untying',
  'user.title.silentRate': 'Silent user',
  'user.title.assignDetail': 'Distribution details',
  'user.title.activationCount': 'Activate {importCount} people',
  'user.title.dial': 'dial',
  'user.title.loading': 'Loading...',
  'user.title.gender': 'Gender',
  'user.title.devicTime': 'Correlation time',
  'user.title.idNo2': 'ID card No.',
  'user.title.device': 'equipment',
  'user.title.unVerifiedPhone': 'Phone not certified',
  'user.title.playerInvite': 'Player invitation',
  'user.title.registerSource': 'Registration source',
  'user.title.riskDetail': 'Details of wind control',
  'user.title.addBonusSuccess': 'Offer added successfully',
  'user.title.adjustedRiskLevel': 'Adjust risk level',
  'user.title.loadingUserInfoFail': 'Failed to load user information',
  'user.title.loadingUserInfoError': 'Error loading user information',
  'user.title.firstDepositRate1': 'First deposit rate: first deposit user / new user',
  'agent.export.agentReportExcel': 'Agent report.xls',
  'user.title.from': 'from',
  'user.title.to': 'reach',
  'user.title.last7': 'Past 7 days',
  'user.title.last30': 'Past 30 days',
  'user.title.last60': 'Past 60 days',
  'user.title.queryType': 'Query type',
  'user.title.registerSelf': 'Self registration',
  'user.title.registerAgent': 'Agent channel',
  'user.title.channelSource': 'Channel sources',
  'user.title.giveRequire': 'Distribution restrictions',
  'game.title.changeGamePlatformSign': 'Modify game platform logo',
  'game.title.signType': 'Identification type',
  'game.title.hotSignType': 'Popular logo type',
  'game.title.signStatus': 'Identification status',
  'game.title.hotSignStatus': 'Hot status',
  'game.title.changeStatus_0': 'Identifier disabled',
  'game.title.changeStatus_1': 'Logo enabled',
  'game.title.changeStatus_01': 'Hot disabled',
  'game.title.changeStatus_10': 'Hot enabled',
  'common.finance.autoTransferOutGame': 'Automatically transfer {platformName} out of the game',
  'admin.pay.manualDepositWithDrawals': 'Manual storage',
  'admin.finance.rejectWithdrawals': 'Refuse to cash in',
  'admin.finance.rejectWithdrawalsReason': 'Application for withdrawal rejected, reduced balance returned',
  'admin.finance.recharge': 'Recharge',
  'common.bonus.bonusToGame': '{fullName} bonus automatically transferred to the game',
  'common.bonus.issueBonus': '{fullName} bonus',
  'common.finance.customerServiceManualTransfer': 'Customer service manual account adjustment, {userName}',
  'common.finance.bonusAprove': '{userName} approval, {bonusName}',
  'admin.bonus.realTimeDepositBonus': 'Real time deposit rebate, {date}',
  'admin.bonus.remittanceChannelBonus': 'Remittance channel dividend, {date}',
  'admin.bonus.dividends': 'Bonus payout, {date}',
  'common.bonus.inviteBonus': 'Invite bonus, {date}',
  'common.bonus.signDrawBonus': 'Bonus of signing in lottery, {date}',
  'common.bonus.continuousDepositDrawBonus': 'Draw bonus of continuous deposit, {date}',
  'common.bonus.continuousDepositPointsBonus': 'Continuous deposit bonus, {date}',
  'common.bonus.flowRebate': '{type} flow rebate, {date}',
  'common.bonus.betBonus': '{type} dividend, {date}',
  'common.bonus.rescueFundBonus': 'Rescue money, {date}',
  'common.bonus.activityType1Prize': 'Lucky wheel prize',
  'common.bonus.activityType2Prize': 'Shake the prize',
  'common.bonus.activityType4Prize': 'Blind Box Prizes',
  'common.bonus.activityType5Prize': 'Cash Wheel Prizes',
  'common.bonus.alwaysRebate': 'Flow rebate {date} when {gametype}',
  'common.bonus.signPointsBonus2': '{userAccount} sign in bonus, {date}',
  'front.bonus.noteBonus': 'Note bonus',
  'front.bonus.memberInfoBindingBonus': 'Member information binding bonus',
  'front.bonus.agentRegisterBonus': 'Give registration preference through agent registration',
  'front.bonus.depositBonus': 'Deposit Bonus',
  'front.bonus.upgradeReward': '{bonusName} - upgrade bonus',
  'front.bonus.weekReward': '{bonusName} - weekly salary reward',
  'front.bonus.monthReward': '{bonusName} - monthly salary reward',
  'front.bonus.customerServiceRetrieval': 'Customer service returns {platformKey}',
  'admin.finance.assetsAccountMsg1': 'Customer service supplement, failed to retrieve from the game, {platform code}',
  'admin.finance.assetsAccountMsg2': 'Customer service supplement, failed to transfer into the game, {platform code}',
  'front.bonus.customerServiceBatchRetrieval': 'Customer service batch retrieve {platformKey}',
  'front.bonus.autoReplenishment1': 'Automatic order filling, failed to retrieve from the game, {platformCode}',
  'front.bonus.autoReplenishment2': 'Automatic order filling, failed to transfer into the game, {platformCode}',
  'common.finance.autoTransferInGame': 'Automatically transfer to the game {platformName}',
  'front.pay.applyForWithdrawal': 'Application for cash withdrawal',
  'front.pay.applyForWithdrawalMinusAmount': 'Claim less amount',
  'common.bonus.addBonusesBackground': 'Add bonus in the background:{name}',
  'front.pay.adjustableWithdrawal': 'Adjust withdrawal: {betflowBalance} - > {availBalance}',
  'admin.bonus.approveBonus': 'Approved bonus: {bonusName}',
  'admin.bonus.effectiveFlow': '{bonusName}, set valid pipeline: {validBetflow}',
  'admin.bonus.cancelBonus': 'Cancel bonus: {bonusName}',
  'common.bonus.playerManuallyApply': 'Players apply manually: {userAccount}',
  'front.bonus.extraBonus': 'Player check in bonus: {userAccount}',
  'front.bonus.redeemPointsManually': 'Players manually check in points exchange: {userAccount}',
  'front.bonus.continuousDepositBonus': 'Continuous deposit bonus',
  'front.bonus.checkInBonus': 'Attendance bonus',
  'front.bonus.invitationBonus': 'Invitation bonus',
  'admin.bonus.bounusCopy': '{articleName} (copy)',
  'admin.bonus.uploadNoticeError': 'Line {num}; wrong parameter, please check carefully.',
  'common.userAccountNotExist4': 'user does not exist',
  'admin.bonus.bonusArrivalNotice': '[{bonusName}] notice of dividend receipt!',
  'admin.bonus.bonusArrivalNotice1': 'Hello, your {bonusName} bonus has arrived, the amount is {bonusAmount}, please check it.',
  'admin.msg.withDrawalsApproveNotice': 'Your withdrawal application {amount} has been approved successfully',
  'admin.msg.wihtDrawalsPayoutNotice': 'The withdrawal you applied for on {date} has passed the review, among which the withdrawal application = {amount1}, (you bear the handling fee = {amount2}. Actual withdrawal = {amount3}). The withdrawal has passed the review, please check later, thank you for your participation, please feel free to contact us if you have any questions',
  'common.msg.withDrawalsSuccess': 'Your withdrawal application {amount} has been sent to your bank card',
  'common.msg.withDrawalsSuccessNotice': 'Payment amount = {amount}, has been paid to your bank card, please check. Thank you for your participation, if you have any questions, please feel free to contact us',
  'admin.msg.riskControlApproveNotice': '(risk control operation) the user {userAccount} applies for withdrawing {amount} yuan, which has been approved by {userName} and can be audited by the finance department',
  'admin.msg.manualConfirmRechargeNotice': '(financial operation) user {userAccount} recharges {orderAmount}, which is manually confirmed by {userName}',
  'admin.msg.riskControlRejectNotice': '(risk control operation) user {userAccount} applied for withdrawing {amount} yuan, which has been rejected by {Username}',
  'admin.msg.financeRejectWithdrawalsNotice': '(financial operation) user {userAccount} applied for withdrawing {amount} yuan, which has been rejected by {userName}',
  'admin.msg.financeApproveNotice': '(financial operation) user {userAccount} applied for withdrawing {amount} yuan, which has been paid out by {userName}',
  'admin.msg.financePayforTimeoutNotice': '(financial operation) the user {userAccount} applied for withdrawing {amount} yuan, which has been agreed by {userName}, and the {payName} payment request timed out. Please check the order status of the payment platform',
  'admin.msg.financePayforExceptionNotice': '(Financial operation) the user {userAccount} applied for withdrawal of {amount} yuan, which has been agreed by {userName}. The {payName} payment request is abnormal. Please check the status of the payment platform',
  'admin.msg.financePayforFailNotice': '(financial operation) the user {userAccount} applied for withdrawing {amount} yuan, which has been agreed by {userName}, and the {payName} payment request failed: {message}, please check the order status of the payment platform',
  'admin.msg.financePayforSuccess': '(financial operation) the user {userAccount} applies for withdrawing {amount} yuan, which has been agreed by {username}, and {payName} is in the payment',
  'admin.msg.financePayforSuccess1': '(financial operation) the user {userAccount} applied for withdrawing {amount} yuan, which has been successfully paid by {channel} on behalf of the user',
  'admin.msg.financePayforFail': '(financial operation) the user {userAccount} applied for withdrawing {amount} yuan, and {channel} failed to pay the payment on behalf',
  'admin.msg.paymentSuccessRate1': 'Financial operation) payment method: {payMark}, payment channel: {viewName}, payment success rate: {successRate}, lower than the success rate of early warning. Please pay attention to the control.',
  'admin.msg.paymentSuccessRate2': 'Financial operation) payment method: {payMark}, payment channel: {viewName}, payment success rate: {successRate}, lower than the success rate of early warning. The payment method has been automatically disabled. Please check.',
  'admin.msg.companyDeposit': '(financial operation) player: {userAccount}, applicant company\'s contribution {amount}, order No. {orderNo}',
  'front.finance.windControlAudit': '(risk control) user {account} applies for withdrawing {amount} yuan, please review by risk control.',
  'front.finance.rechargeSuccess': '(system) user {userAccount} successfully recharged {orderAmount} element.',
  'admin.sys.ftpPathError': 'FTP path creation error',
  'admin.sys.ftpReaptFileError': 'File already exists, rebuild error',
  'admin.msg.realNameName': 'Real name: {userName}',
  'admin.finance.withdrawals': 'Cash withdrawal',
  'admin.pay.manualTransfer': 'Manual reconciliation',
  'admin.pay.manualDeposit': 'Deposit manually',
  'admin.pay.manualTransferRemoval': 'Manual account adjustment, manual withdrawal:{userName}',
  'sys.activity.win.type': 'Winning exhibition type',
  'sys.activity.win.type.prompt': 'Please select the winning type',
  'sys.activity.falseWin': 'False winning information',
  'sys.activity.realWin': 'Real winning information',
  'sys.activity.lotteryStyle': 'Lottery Method',
  'sys.activity.selectLotteryStyle': 'Please select the lottery method',
  'sys.activity.lotteryStyle1': 'The Big Wheel',
  'sys.activity.lotteryStyle2': 'Slot Machine',

  'activity.batch.userAccount': 'AccountName',
  'activity.batch.count': 'size',
  'activity.batch.days': 'days',
  'activity.batch.status': 'status',
  'activity.batch': 'BatchImport',
  'activity.batchDetail': 'Batch Import Detail',
  'menu.activityBatch': 'BatchImport',
  'activity.batch.desc1': '1.AccountName;',
  'activity.batch.desc2': '2.Add Szie;',
  'activity.batch.desc3': '3.Effective days;',

  'sys.winningProbability1': 'Please enter the winning probability within 11',
  'sys.pcImage': 'PC end image',
  'sys.APPImage': 'Mobile pictures',
  'sys.startTime2': 'Opening time',
  'sys.bonus.lock.type': 'Lock type',
  'sys.bonus.lock.type.1': 'Preferential amount',
  'sys.bonus.lock.type.2': 'Preferential amount + principal',
  'sys.bonus.deposit.lock.type': 'Unlock related',
  'sys.bonus.deposit.lock.type.0': 'Unlocking',
  'sys.bonus.deposit.lock.type.1': 'Unlock the recharge lock for this order',
  'sys.extraLogo': 'Extra icons',
  'sys.msg201': 'PC side - upload game additional logo',
  'sys.msg202': 'Mobile - upload additional logo of game',
  'menu.member.signMember': 'Membership tag',
  'menu.operation.balanceRate': 'Yu Bao',
  'menu.operation.balanceRate.programSetting': 'Scheme setting',
  'menu.operation.balanceRate.buyRecord': 'Purchase record',
  'constants.bonusType_21': 'New sign in offer',
  'constants.newBonusType_21': 'New sign in bonus',
  'constants.bonusMainType_21': 'New sign in bonus',
  // 'constants.newBonusMainType_21': 'New sign in bonus',
  'constants.gameSlot1_IGS': 'IG electron',
  'constants.gameSlot1_PT2': 'PT electron',
  'constants.gameSlot1_GG2': 'GG2 electron',
  'constants.gameSport3_CMD': 'CMD Sports',
  'constants.gameSport3_WS168': 'WS168 Cockfight',
  'constants.gameSport3_S128': 'S128 Cockfight',
  'constants.gameSport3_BBIN': 'BBIN',
  'constants.gameSport3_TP': 'TP',
  'constants.gameSport3_BTI': 'BTI Sports',
  'constants.gameSport3_DS': 'DS88 Sport',
  'constants.gameSport3_DS888': 'DS888 Cockfight',

  'constants.gameLottery4_KK': 'KK lottery',
  'constants.gameChess6_DGC': 'DG chess cards',
  'sys.bonus.domain.type': 'Restrict domain name or not',
  'sys.bonus.domain.type.prompt': 'Restricted domain name cannot be empty',
  'sys.bonus.domain.noLimited': 'Unlimited',
  'sys.bonus.domain.Limited': 'Restricted domain name',
  'sys.bonus.domain.input.prompt': 'Domain name list (comma separated)',
  'sys.bonus.domain.nullPrompt': 'Please enter the domain name',
  'sys.bonus.domain.input.maxPrompt': 'Maximum length 256, do not exceed',
  'sys.bonus.domain.prompt': 'Please enter the free domain name (top-level domain name only); for example: baidu.com, baidu.com',
  'front.bonus.selfRegisterBonus': 'Free registration discount through self registration',
  'sys.frontMatch.matchName': 'Name of competition',
  'sys.frontMatch.hTeam': 'Name of the home team',
  'sys.frontMatch.hTeamLogo': 'Home team Icon',
  'sys.frontMatch.gTeam': 'Name of visiting team',
  'sys.frontMatch.gTeamLogo': 'Visiting team Icon',
  'sys.frontMatch.jumpUrl': 'Jump address',
  'sys.frontMatch.insertMatch': 'New tournament',
  'sys.frontMatch.updateMatch': 'Amending tournaments',
  'menu.operation.frontContent.match': 'Event management',
  'sys.bonus.refuseMessage': 'Refuse information',
  'sys.bonus.signInOnlyExistOn': 'Only one offer can be set.',
  'sys.validit.joinUserLevel': 'Participating member level',
  'sys.validit.pleaseSelectJoinUserLevel': 'Please select the lowest level of members who can participate in the activity',
  'sys.signInCnd': 'Check-in condition',
  'sys.signInDay': 'day',
  'sys.signInTotalDeposit': 'Accumulated deposit amount',
  'sys.signInOneDeposit': 'Amount of single deposit',
  'sys.signInGiveAmount': 'Reward amount',
  'sys.signInGivePoint': 'Bonus points',
  'sys.signInBetflowMultiple': 'Flow multiple',
  'sys.signInOtherAmount': 'Extra bonus',
  'sys.signInOtherPoint': 'Extra points',
  'sys.signInTotalBetflowCnd': 'Effective bets',
  'sys.pcPicH5SmallPic': 'PC / H5 small icon',
  'sys.pcSmallPic': 'PC small icon',
  'sys.h5SmallPic': 'H5 small icon',
  'menu.sys.popularPlatformGame': 'Popular game platform settings',
  'sys.addGame': 'Add game',
  'sys.select.gameList': 'Please select a game',
  'sys.edit.popular': 'Modify popular information',
  'sys.popularType': 'Popular types',
  'user.title.signName': 'Label name',
  'user.title.signName1': 'Please enter a label name',
  'user.title.addMemberSign': 'New member tag',
  'common.button.addMemberSign': 'Add member tag',
  'sys.title.deleteMemberSignName': 'Member tags to be deleted: {signName}',
  'sys.lengthLimit5': 'Input up to 7 Chinese characters',
  'user.button.markMember': 'Tagged user',
  'user.title.noneSign': 'Currently, there is no optional tag. Please go to the member tag page to add a tag',
  'user.msg.markMember': 'Marking success',
  'user.msg.markMember1': 'Marking failed',
  'user.title.memberSign': 'Label',
  'sys.cellphoneNumber4': 'Please enter your Vietnam mobile number',
  'constants.gameChess6_BL': 'Bole chess / electronic',
  'constants.gameSlot1_AWS': 'AWS electron',
  'sys.rateBonus.allStatus': 'whole',
  'sys.rateBonus.create': 'New scheme',
  'sys.rateTable.amountLimit': 'Single quota',
  'sys.rateTable.totalRate': 'Gross interest rate',
  'sys.rateTable.programCycle': 'Scheme settlement cycle',
  'sys.rateTable.scheduleCycle': 'Program cycle',
  'sys.rateTable.settlementCycle': 'Settlement cycle',
  'sys.rateTable.timeType': 'hour',
  'sys.rateTable.rateLimit': 'Interest ceiling',
  'sys.rateTable.needBetflow': 'Flow requirements',
  'sys.rateTable.capital': 'Principal',
  'sys.rateTable.rate': 'Interest',
  'sys.rateTable.multiple': 'times',
  'sys.rateTable.settlement': 'Sales status',
  'sys.rateTable.totalStock': 'Total share',
  'sys.rateTable.selled': 'Sold',
  'sys.rateTable.going': 'Interest bearing',
  'sys.rateTable.edit': 'Editor',
  'sys.rateTable.market': 'Upper shelf',
  'sys.rateTable.takeOff': 'Lower shelf',
  'sys.rateTable.sort': 'sort',
  'sys.singleTime': 'Single time',
  'sys.accumulative': 'accumulative',
  'bonus.rateTitle.createBalanceRate': 'New yu\'ebao scheme',
  'bonus.rateTitle.editBalanceRate': 'Edit yu\'ebao scheme',
  'bonus.rateTitle.bonusName': 'Scheme name',
  'bonus.rateTitle.bonusName1': 'Please enter scheme name',
  'bonus.rateTitle.sort': 'order',
  'bonus.rateTitle.sort1': 'Please enter the order',
  'bonus.rateTitle.minBuyAmount': 'Minimum purchase amount',
  'bonus.rateTitle.minBuyAmount1': 'Please enter the minimum purchase amount',
  'bonus.rateTitle.maxBuyAmount': 'Maximum purchase amount',
  'bonus.rateTitle.maxBuyAmount1': 'Please enter the maximum purchase amount',
  'bonus.rateTitle.buyAmountRightNotice': 'Please enter the correct amount',
  'bonus.rateTitle.totalRate': 'Total interest (%)',
  'bonus.rateTitle.totalRate1': 'Please enter the total interest',
  'bonus.rateTitle.settlementCycle': 'Settlement cycle (hours)',
  'bonus.rateTitle.settlementCycle1': 'Please enter settlement period',
  'bonus.rateTitle.settlementCycleNotice': 'In the scheme cycle, interest will be issued once per settlement cycle, and the interest rate of each settlement cycle is "total interest rate / (scheme cycle / settlement cycle) = interest rate of settlement cycle". Assuming that the total interest rate is 3%, the scheme period is 24 hours and the settlement period is 1 hour, 0.125% interest will be paid in each settlement period.',
  'bonus.rateTitle.schemeCycle': 'Scheme period (hours)',
  'bonus.rateTitle.schemeCycle1': 'Please enter scheme period',
  'bonus.rateTitle.loopType': 'Cyclic computation',
  'bonus.rateTitle.loopType1': 'Please select cycle calculation mode',
  'bonus.rateTitle.loopTypeNotice': 'Cycle calculation on: cycle settlement of interest to the upper limit of interest or customer\'s initiative collection according to the scheme cycle. Assume that the interest of RMB 10 will be settled in 3 hours of the cycle, and continue to settle in the 6th hour until the upper limit or withdrawal occurs; closed cycle calculation: after the end of the scheme cycle, the next cycle will not be settled. Assume that the interest of RMB 10 will be settled within 3 hours of the cycle, and it will not be settled after one settlement.',
  'bonus.rateTitle.maxRateAmount': 'Maximum interest amount',
  'bonus.rateTitle.maxRateAmount1': 'Please enter the maximum interest amount',
  'bonus.rateTitle.capitalBetflowMultiple': 'Current multiple of principal',
  'bonus.rateTitle.capitalBetflowMultiple1': 'Please enter the current multiple required for principal withdrawal',
  'bonus.rateTitle.rateBetflowMultiple': 'Current interest multiple',
  'bonus.rateTitle.rateBetflowMultiple1': 'Please enter the current multiple required for interest withdrawal',
  'bonus.rateTitle.totalStock': 'Total number',
  'bonus.rateTitle.totalStock1': 'Please enter the total number of copies',
  'bonus.rateTitle.userBuyCount': 'Number of shares members can purchase',
  'bonus.rateTitle.userBuyCount1': 'Please enter the maximum number of members to purchase',
  'bonus.rateTitle.buyAgainTime': 'Time between re purchases (hours)',
  'bonus.rateTitle.buyAgainTime1': 'Please enter the interval',
  'bonus.rateTitle.buyUserVip': 'Purchase required level',
  'bonus.rateTitle.buyUserVip1': 'Please select the level required for purchase',
  'sys.rateTable.deleteNotice': 'There is still a plan that has not been redeemed, and it cannot be deleted.',
  'bonus.rateMsg.buyAmountNotice': 'The minimum purchase amount cannot be greater than the maximum purchase amount',
  'bonus.rateMsg.scheduleNotice1': 'Settlement period cannot be greater than scheme period',
  'bonus.rateMsg.scheduleNotice2': 'Scheme period must be divisible by settlement period',
  'bonus.buyRecord.buyTime': 'Buying time',
  'bonus.buyRecord.ransomTime': 'Redemption time',
  'bonus.buyRecord.status_1': 'Interest bearing',
  'bonus.buyRecord.status_2': 'Redemption',
  'bonus.buyRecord.status_3': 'Redeemed',
  'bonus.buyRecordTable.bonusName': 'Scheme name',
  'bonus.buyRecordTable.programAmount': 'Programme amount',
  'bonus.buyRecordTable.captipleAmount': 'Principal',
  'bonus.buyRecordTable.rateAmount': 'Interest',
  'bonus.buyRecordTable.programSchedule': 'Programme plan',
  'bonus.buyRecordTable.schemeCycle': 'Scheme cycle: {schemeCycle} hours',
  'bonus.buyRecordTable.settlementCycle': 'Settlement cycle: {settlementCycle} hours',
  'bonus.buyRecordTable.loopType': 'Circulation mode',
  'bonus.buyRecordTable.status': 'state',
  'bonus.buyRecordTable.status_1': 'Interest bearing',
  'bonus.buyRecordTable.status_2': 'Redemption',
  'bonus.buyRecordTable.status_3': 'Redeemed',
  'bonus.buyRecordTable.time': 'time',
  'bonus.buyRecordTable.buyTime': 'Buying time',
  'bonus.buyRecordTable.ransomTime': 'Redemption time',
  'bonus.buyRecordTable.finishTime': 'Interest end time',
  'bonus.buyRecordTable.ransomAdmin': 'Redeemer',
  'bonus.buyRecordTable.operate': 'operation',
  'bonus.buyRecordTable.forceRansom': 'Mandatory Redemption',
  'bonus.buyRecordTable.capitalBetflowMultiple': 'Principal redemption flow requirements: {capitalBetflowMultiple}',
  'bonus.buyRecordTable.rateBetflowMultiple': 'Interest redemption flow requirements: {rateBetflowMultiple}',
  'bonus.buyRecordTable.maxRateAmount': 'Maximum interest amount: {maxRateAmount}',
  'bonus.buyRecordTable.confirmForceRansomMsg': 'Confirmation prompt',
  'bonus.buyRecordTable.confirmForceRansom': 'Are you sure you want to forcibly redeem the scheme?',
  'admin.bonus.rejectBonus': 'Bonus denied: {bonusName}',
  'admin.msg.financePayforManualFail': '(Financial operation) The user {userAccount} applied for withdrawal of {amount} yuan, which has been manually set by the user {userName} as the payment failure',
  'admin.msg.deposit': '(Financial operation) Player: {userAccount}, apply for deposit {amount}, order number: {orderNo}',
  'admin.pay.depositType': 'Deposit type',
  'sys.registerMember': 'Non-Agent Member',
  'admin.pay.deletePayment': 'Please disable before deleting！',
  'sys.title.bonusArtId': 'Article ID',
  'sys.title.onlinePay': 'Online payment',
  'sys.title.offlinePay': 'Offline payments',
  'sys.title.officePay': 'Company Deposit',
  'pay.earlyWarning.addEarlyWarning': 'Add alert',
  'pay.earlyWarning.earlyWarningThreshold': 'Early warning threshold',
  'pay.earlyWarning.earlyWarningThreshold1': 'Please enter a warning threshold',
  'pay.earlyWarning.editEarlyWarning': 'Fill in the warning information',
  'pay.earlyWarning.successRoteEarlyWarning': 'Channel success rate alarm',
  'admin.finance.payEarlyWarningNotify': '{customizeName} success rate is less than {earlyWarningThreshold}%, please check in time',
  'sys.msg1421': 'Personal details',
  'sys.attribution1': 'IP Ownership',
  'menu.gameMonitor': 'Global game monitoring',
  'user.userChangeParentAgent': 'Change parent agent',
  'user.userChangeParentAgent1': 'Please select a member to change the superior agent',
  'user.addTHAUser': 'New users',
  'user.addTHAUser.withdrawPassword': "Withdraw password",
  'user.addTHAUser.agentCode': "Agent number",
  'user.phoneIsValid': 'Whether the number is verified',
  'user.updateBank': "Modify bank card",
  'finance.payGroup.remark': 'Payment instructions',
  'finance.payGroup.addRemark': 'Add payment instructions',
  'finance.payGroup.externalLinkAmountRange': "External link amount range display",
  'sys.uniqueLimit.IP': 'IP only restrictions',
  'sys.uniqueLimit.device': 'Device-only restrictions',
  'sys.uniqueLimit.phone': 'Mobile phone number limit',
  'sys.receiveCount': 'Pickup times',
  'user.member.signMember': 'Member tags',
  'sys.title.deleteFail': 'Delete failed, please try again',
  'user.title.realtimeListExcel': 'Member real-time statistics report.xls',
  'user.title.currentResultAmount': 'Winning or losing',
  'bet.queryFrm.gameName': 'Game name',
  'bet.queryFrm.agentName': 'Proxy account',
  'bet.queryFrm.betweenResultAmount': 'Winning and losing interval',
  'common.queryFrm.searchGameName': 'Game name',
  'common.queryFrm.searchAgentName': 'Proxy account',
  'common.queryFrm.searchMinResultAmount': 'Minimum win',
  'common.queryFrm.searchMaxResultAmount': 'Maximum win or lose',
  'constants.gameSlot1_NEWSA': 'New SA',
  'constants.gameFish5_NEWSA': 'New SA',
  // 4.02
  'admin.withdraw.currentChannelDisable': 'The current channel is disabled, please use another channel',
  'withdraw.loadConfigInfoFail': 'Loading proxy configuration information failed',
  'withdraw.loadConfigInfoError': 'Failed to load payment configuration information error',
  'withdraw.label.withdrawChannel': 'Payment channel',
  'withdraw.label.withdrawChannel1': 'Please select the payment channel',
  'withdraw.label.Code': 'Tripartite Code',
  'withdraw.channel.submit.title.prompt': 'Submit payment channel',
  'withdraw.channel.submit.content.prompt': 'After adding the payment channel, please fill in the payment channel parameters, otherwise an error will occur during the payment！',
  'sys.bonus.editDisplaySort': 'Sort event hall',
  'sys.editSuccess': 'Modified sort successfully！',
  'sys.editFail': 'fail to edit',
  'sys.editError': 'correct mistakes',
  'sys.approveLock': 'Approval lock',
  'sys.confirmConsent3': 'OK to start review？',
  'sys.confirmConsent4': 'Whether to lock the withdrawal for review',
  'sys.confirmConsent5': 'Risk control lock prompt',
  'sys.confirmConsent6': 'This risk control record is being reviewed by (userAccount) and locked',
  'sys.confirmConsent7': 'The risk control record {userAccount} has been reviewed and unlocked',
  'sys.confirmConsent8': 'The risk control record is forcibly unlocked by the administrator {userAccount}, and has been unlocked',
  'risk.approveLock': 'Review locked',
  'risk.approveUnLock': 'Review unlocked',
  'pay.title.adminUnlock': 'Administrator unlock',
  'sys.autofresh': 'Auto Refresh',
  'sys.autofresh.none': 'Do not refresh',
  'sys.autofresh.15s': '15 seconds refresh',
  'sys.autofresh.30s': '30 seconds refresh',
  'sys.autofresh.60s': '60 seconds refresh',
  'pay.title.withdrawalStatus10': 'Approval locked',
  'pay.title.withdrawalStatus11': 'Approval unlocked',
  'constants.riskLevelType_-5': 'Restricted deposit',
  'user.button.kickOffLine': 'Kick off line',
  'user.button.whetherOffline': 'Whether to go offline',
  'menu.operationalStatistics': 'Operational statistics',
  'menu.killAnalysis': 'Kill count analysis',
  'menu.discountAnalysis': 'Activity discount analysis',
  'member.title.regCount': 'Registered',
  'member.title.firstDepositTotal': 'First deposit',
  'member.title.firstDepositRate': 'First deposit rate',
  'member.title.firstDepositCount': 'Total first deposit amount on the day',
  'member.title.secondDepositCount': '2 deposits on the day',
  'member.title.thirdDepositCount': '3 deposits on the day',
  'member.title.fourthDepositCount': '4 deposits on the day',
  'member.title.fifthDepositCount': '5 deposits on the day',
  'member.title.depositCount': 'Total number of deposits',
  'member.title.depositTotal1': 'Total deposit amount',
  'member.title.withdrawalCount': 'Total withdrawals',
  'member.title.withdrawalTotal': 'Total withdrawal amount',
  'member.title.depositWithdrawalDiff': 'Deposit difference',
  'member.title.tripartitePlatformProfit': 'All tripartite platforms are profitable',
  'member.title.bonusName': 'Promotion name',
  'member.title.attendCount': 'The number of participants',
  'member.title.depositTotal': 'Participating member total deposit',
  'member.title.withdrawTotal': 'Participating member total withdrawal',
  'member.title.profitAndLoss': 'Activity profit and loss',
  'member.title.codeBonusAmount': 'Activity reward',
  'member.title.codeBonusStrSet': 'Password setting',
  'member.title.applicationConditions': 'Application conditions',
  'member.title.luckyDrawOpportunity': 'How to get the lucky draw opportunity',
  'member.title.raffleLife': 'Raffle life',
  'member.title.participationRestriction': 'Participation restriction',
  'member.extra.attendCountPage': 'Number of participants on this page',
  'member.extra.depositTotalPage': 'Total deposits on this page (yuan)',
  'member.extra.depositTotalPageVN': 'Total deposits on this page (VND)',
  'member.extra.bonusTotalPage': 'Total Offers on this page (yuan)',
  'member.extra.bonusTotalPageVN': 'Total Offers on this page (VND)',
  'member.extra.withdrawTotalPage': 'Total withdrawals on this page (yuan)',
  'member.extra.withdrawTotalPageVN': 'Total withdrawals on this page (VND)',
  'member.extra.profitAndLossPage': 'Total profit and loss on this page (yuan)',
  'member.extra.profitAndLossPageVN': 'Total profit and loss on this page (VND)',
  'member.extra.attendCountTotal': 'Total number of participants',
  'member.extra.depositTotalTotal': 'Total deposit (yuan)',
  'member.extra.depositTotalTotalVN': 'Total deposit (VND)',
  'member.extra.bonusTotalTotal': 'Total discount (yuan)',
  'member.extra.bonusTotalTotalVN': 'Total discount (VND)',
  'member.extra.withdrawTotalTotal': 'Total withdrawal (yuan)',
  'member.extra.withdrawTotalTotalVN': 'Total withdrawal (VND)',
  'member.extra.profitAndLossTotal': 'Total activity profit and loss (yuan)',
  'member.extra.profitAndLossTotalVN': 'Total activity profit and loss (VND)',

  'member.title.platformName': 'Platform name',
  'member.title.platformFlow': 'Platform flow',
  'member.title.platformWinAndLoss': 'Platform win or lose',
  'member.title.betCount': 'Total number of bets on the day',
  'member.title.kill': 'Kill count',
  'menu.announcementList': 'Announcement list',
  'sys.title.pubTime': 'release time',
  'sys.title.title': 'Announcement title',
  'sys.title.content': 'Announcement content',
  'sys.title.pubAmdin': 'publisher',
  'sys.title.isRead': 'Have you read',
  'sys.title.readTime': 'Elapsed time',
  'sys.title.datePlatform': 'Date / Platform',
  'user.title.operationalStatisticsExcel': 'Operational data statistical report.xls',
  'user.title.killAnalysisExcel': 'Kill count analysis report.xls',
  'user.title.discountAnalysisExcel': 'Preferential activity analysis report.xls',
  'user.title.countTime': 'Statistics Time',
  'constants.bonusType_23': 'VIP deposit discount',
  'constants.gameSlot1_PT1': 'PT1 electron',
  'constants.payLevel1_0': 'First class member',
  'constants.payLevel1_1': 'All members',
  'constants.payLevel1_2': 'Secondary member',
  'constants.payLevel1_3': 'Third tier members',
  'constants.payLevel1_4': 'Level 4 members',
  'constants.payLevel1_5': 'Level 5 member',
  'constants.payLevel1_6': 'Level 6 member',
  'constants.payLevel1_7': 'Level 7 member',
  'constants.payLevel1_8': 'Level 8 member',
  'constants.payLevel1_9': 'Level 9 member',
  'constants.payLevel1_10': 'Level 10 member',
  'constants.gameLive2_WM': 'WM',
  'constants.gameLive2_WE': 'WE real person',
  'constants.gameLive2_EVO': 'EVO real person',
  'constants.gameLive2_AE': 'AE real person',
  'constants.gameLive2_XG': 'XG real person',
  // 'constants.gameLive2_Evolution': 'Evolution real person',
  'pay.title.ipWhite': 'White list IP',
  'pay.title.operateDetail': 'Operator ︱ operation time',
  'pay.add.newIpWhite': 'Add white list',
  'pay.query.keyword': 'Channel name or IP',
  'pay.label.ipWhite': 'Please fill in the white list IP',
  'pay.setting.prompt': 'Tips',
  'pay.setting.promptDetail': 'Please set the parameters first',
  'pay.label.tokenKeyDetail': 'Encrypt information',
  'user.title.authRealName': 'Real name authentication',
  'user.title.authEmail': 'Mailbox authentication',
  'user.title.authPhone': 'Mobile phone number certification',
  'user.title.registerAndLastLoginTime': 'Registration time | last login time',
  'sys.deposit': 'Recharge',
  'sys.needDeposit': 'need',
  'user.title.fundOverview': 'Fund overview',
  'sys.registerItem.msg1': '{typename} registry entry',
  'sys.validit.length': 'Field length',
  'sys.validit.requireSwith': 'Required or not',
  'constants.require.status_1': 'Required',
  'constants.require.status_0': 'Not required',
  'menu.operation.frontContent.RegisterItem': 'Registration item management',
  'user.title.realWechat': 'Real wechat',
  'user.title.realQQ': 'Real QQ',
  'user.title.showQQContact': 'View QQ',
  'user.title.showWechatContact': 'View wechat',
  'user.title.changeQQContact': 'Modify QQ',
  'user.title.changeWechatContact': 'Modify wechat',
  'user.title.oldWechat': 'Old wechat',
  'user.title.newWechat': 'New wechat',
  'user.title.oldQQ': 'QQ',
  'user.title.newQQ': 'New QQ',
  'user.title.pleaseEnterNewWechat': 'Please enter a new wechat account',
  'user.title.pleaseEnterNewQQ': 'Please enter a new QQ number',
  'common.radio.requireTrue': 'Change to required',
  'common.radio.requireFalse': 'Change to not required',
  'sys.firstDepositTimeLimit': 'Time limit of first deposit',
  'sys.selectFirstDepositTimeLimit': 'Please select the time limit of first save',
  'menu.newSetting': 'VIP membership level',
  'agent.SubordinateTransfer': 'Transfer to sub agent or member',
  'constants.agentSubordinate_0': 'Subordinate agent',
  'constants.agentSubordinate_1': 'Junior member',
  'agent.subordinateTransfer_0': 'Please select agent or member',
  'agent.subordinateTransfer_1': 'Please select personnel',
  'agent.subordinateTransfer_2': 'Please enter the transfer amount',
  'common.select.beginTime': 'Please select a start time',
  'common.select.endTime': 'Please select the end time',
  'common.title.questionnaire': 'Questionnaire name',
  'common.title.questionnaireDesc': 'Questionnaire description',
  'common.title.respondents': 'Respondents',
  'common.title.questionnaireOperate': 'Questionnaire management operation',
  'common.title.questionOperate': 'Topic operation',
  'menu.operation.questionnaire': 'questionnaire investigation',
  'user.disableNotice1': 'Are you sure you want to disable this questionnaire?',
  'user.enableNotice1': 'Are you sure you want to enable this questionnaire?',
  'sys.addQuestionnaire': 'Add questionnaire',
  'sys.enterQuestionnaireTitle': 'Please enter the name of the questionnaire',
  'sys.enterQuestionnaireDesc': 'Please enter the questionnaire description',
  'sys.enterBeginDate': 'Please select a start date',
  'sys.enterRespondents': 'Please select survey object',
  'sys.enterEndDate': 'Please select the end date',
  'common.title.questionDesc': 'Title Description',
  'common.title.questionType': 'Topic type',
  'common.title.isMust': 'Required or not',

  'guessRecordData.roundNo': 'Round Number',
  'guessRecordData.orderNo': 'Order Number',
  'guessRecordData.createTime': 'Betting Time',
  'guessRecordData.showId': 'Live Stream Session',
  'guessRecordData.roomNumber': 'Room Number',
  'guessRecordData.groupName': 'Game Type/Draw Result',
  'guessRecordData.nickname': 'Bettor',
  'guessRecordData.antes': 'Base Bet',
  'guessRecordData.multiple': 'Multiplier',
  'guessRecordData.status0': 'Bet Placed',
  'guessRecordData.status1': 'Cancelled',
  'guessRecordData.status2': 'Paid Out',
  'guessRecordData.payAmount': 'Total Amount',
  'guessRecordData.sendAwardAmount': 'Paid Amount',
  'guessRecordData.details': 'Details',

  'guessResultLogData.resultName': 'Draw Result Name',
  'guessResultLogData.resultData': 'Closing and Draw Information',
  'guessResultLogData.status0': 'Betting in Progress',
  'guessResultLogData.status1': 'Betting Closed',
  'guessResultLogData.status2': 'Confirmed',
  'guessResultLogData.status3': 'Result Announced',
  'guessResultLogData.status4': 'Cancelled',
  'guessResultLogData.status5': 'Modification Confirmed',
  'guessResultLogData.status6': 'Pending Void',
  'guessResultLogData.status7': 'Pending Modification',
  'guessResultLogData.startTime': 'Start Time',
  'guessResultLogData.sealTime': 'Closing Time',
  'guessResultLogData.confirmTime': 'Confirmation Time',
  'guessResultLogData.reviewTime': 'Review Time',
  'guessResultLogData.mark': 'Description',
  'guessResultLogData.showPic': 'Result Screenshot',
  'guessResultLogData.sealPic': 'Closing Screenshot',
  'guessResultLogData.showClosePic': 'Closing Video',
  'guessResultLogData.showDetails': 'View Details',

  'guessRecordDetailsData.odds': 'Odds',


  'sys.enterQuestionDesc': 'Please enter a Title Description',
  'sys.enterQuestionType': 'Please select a topic type',
  'sys.title.editBonus': 'Edit offer',
  'sys.giftType': 'Gift type',
  'sys.rewardCashAmount': 'Cash award',
  'sys.enterRewardCashAmount': 'Please enter the cash reward amount',
  'sys.cashBetflow': 'Current multiple of cash reward',
  'sys.enterCashBetflow': 'Please enter the cash bonus\'s withdrawable daily multiple',
  'sys.rewardPointAmount': 'Bonus points',
  'sys.enterRewardPointAmount': 'Please enter bonus points',
  'sys.rewardSwingTimes': 'Bonus times',
  'sys.enterRewardSwingTimes': 'Please input the number of times of shaking rewards',
  'sys.rewardSpinTimes': 'Number of lucky wheel Awards',
  'sys.enterRewardSpinTimes': 'Please enter the number of lucky wheel rewards',
  'sys.rewardConditionType': 'Reward condition type',
  'sys.enterRewardConditionType': 'Please select the reward condition type',
  'sys.title.result': 'Findings',
  'sys.title.searchType': 'Search type',
  'sys.title.searchType1': 'Order No',
  'sys.title.searchType2': 'Member account',
  'sys.title.searchType3': 'Name of payment channel',
  'sys.title.searchType4': 'Third party order number',
  'menu.lottery': 'Lottery Management',
  'menu.queryLotteryMethodList': 'Gameplay management',
  'menu.queryLotteryPropList': 'Attribute management',
  'menu.queryLotteryRateList': 'Odds management',
  'menu.popularPlatformGame': 'Popular game platform settings',
  'menu.ipBlockList': 'User IP blacklist',
  'menu.deviceBlockList': 'Blacklist of user equipment',
  'menu.queryOfflinePayOrder': 'Offline payment review',
  'menu.queryOnlinePayOrder': 'Online payment management',
  'menu.config': 'Payment settings',
  'menu.payGroup': 'Payment group settings',
  'menu.payConfig': 'Payment channel setting',
  'menu.withdrawPay': 'Payment channel setting',
  'menu.payEarlyWarning': 'Channel early warning settings',
  'menu.payCallbackIpWhite': 'Payment callback white list setting',

  'menu.payChannel': 'Payment channel setting',
  'menu.withdraw': 'Payment channel setting',

  'menu.onlineUser': 'Online users',
  'menu.reportManualTransfer': 'Member Reconciliation statement',
  'menu.agentManualTransfer': 'Agency reconciliation report',
  'menu.userGameReport': 'User Game Report',
  'menu.smsNameVerifyLog': 'Certification generation record',
  'menu.upgrade': 'Upgrade mode',
  'menu.upgradeSetting': 'Level setting',
  'menu.upgradeUser': 'Player list',
  'menu.upgradeReport': 'Issue record',
  'menu.programSetting': 'Scheme setting',
  'menu.buyRecord': 'Purchase record',
  'menu.queryPushMessageList': 'Push management',
  'menu.signMember': 'Membership tag',
  'menu.balanceRate': 'Yu Bao',
  'menu.articleMgmt': 'Article management',
  'menu.articleTypeMgmt': 'Article type management',
  'menu.nav': 'Navigation management',
  'menu.pageMgmt': 'Page management',
  'menu.match': 'Event management',
  'menu.RegisterItem': 'Registration item management',
  'menu.checkin': 'Sign in reward record',
  'menu.integralExchange': 'Points exchange record',
  'menu.paymentTab': 'Payment success rate report',
  'menu.bonusArticle': 'Article management',
  'menu.bonusApplyRole': 'Mutex settings',
  'constants.transferType_16': 'The superior agent is transferred manually',
  'sys.addLotteryLimit': 'Maximum number of settings',
  'sys.cancelLottery': 'Disqualification',
  'sys.emptyLottery': 'Clear the lottery eligibility',
  'sys.content2': 'Whether to cancel the lottery qualification of the selected member？',
  'sys.enterCountLimit': 'Please enter a maximum number of times',
  'sys.countLimit': 'Maximum number of times',
  'sys.countLimitLength': 'The maximum number of times is 9999',
  'sys.noneLimit': 'Unlimited',
  'menu.userSysAdmin': 'System parameter management',
  'menu.questionnaire': 'Questionnaire',
  'sys.title.maintainBegin': 'Maintenance start time',
  'sys.title.maintainEnd': 'Maintenance end time',
  'sys.button.maintainTickTock': 'Scheduled maintenance',
  'sys.button.add': 'Add',
  'sys.button.edit': 'Edit',
  'sys.button.button': 'Button',
  'sys.button.addTitle': 'Add Button',
  'sys.button.editTitle': 'Edit Button',
  'sys.button.menu': 'Menu',
  'sys.button.selectMenu': 'Please Select Menu',
  'sys.button.buttonCode': 'Button Code',
  'sys.button.enterButtonCode': 'Please Enter Button Code',
  'sys.button.buttonName': 'Button Name',
  'sys.button.enterButtonName': 'Please Enter Button Name',
  'sys.button.menuName': 'Menu Name',
  'sys.button.deleteConfirm': 'Are you sure you want to delete this button?',
  'sys.menu.add': 'Add',
  'sys.menu.edit': 'Edit',
  'sys.menu.menu': 'Menu',
  'sys.menu.addTitle': 'Add Menu',
  'sys.menu.editTitle': 'Edit Menu',
  'sys.menu.parentMenu': 'Parent Menu Node',
  'sys.menu.selectParentMenu': 'Select Parent Menu Node',
  'sys.menu.menuLevel': 'Menu Level',
  'sys.menu.selectMenuLevel': 'Please Select Menu Level',
  'sys.menu.menuCode': 'Menu Code',
  'sys.menu.menuName': 'Menu Name',
  'sys.menu.isLeaf': 'Is Leaf Node',
  'sys.menu.yes': 'Yes',
  'sys.menu.no': 'No',
  'sys.menu.menuUrl': 'Backend URL Address',
  'sys.menu.enterMenuUrl': 'Please Enter Backend URL Address',
  'sys.menu.menuOrder': 'Menu Order',
  'sys.languageCurrency.languageConfig': 'Multi-Language Configuration',
  'sys.languageCurrency.currencyConfig': 'Multi-Currency Configuration',
  'sys.language.add': 'Add',
  'sys.language.edit': 'Edit',
  'sys.language.icon': 'Icon',
  'sys.language.iconSpec': 'Icon specification is 130*130',
  'sys.language.language': 'Language',
  'sys.language.language.sign': 'Language Sign',
  'sys.language.enterLanguage': 'Please enter language',
  'sys.language.enterLanguage.sign': 'Please enter language sign',
  'sys.language.cancel': 'Cancel',
  'sys.language.confirm': 'Confirm',
  'sys.language.initError': 'Please initialize edit parameters first',
  'sys.language.operationSuccess': 'Operation successful',
  'sys.language.uploadSuccess': 'Upload successful',
  'sys.language.uploadFailed': 'Upload failed',
  'sys.language.setDefaultConfirm': 'Are you sure you want to set the selected language as the default language?',
  'sys.language.enableConfirm': 'Are you sure you want to enable the selected language?',
  'sys.language.disableConfirm': 'Are you sure you want to disable the selected language?',
  'sys.language.currentDefault': 'Current Default Language',
  'sys.language.setAsDefault': 'Set as Default',
  'sys.language.addLanguage': 'Add Language',
  'sys.currency.add': 'Add',
  'sys.currency.edit': 'Edit',
  'sys.currency.icon': 'Icon',
  'sys.currency.iconSpec': 'Icon specification is 130*130',
  'sys.currency.currencyName': 'Currency Name',
  'sys.currency.enterCurrencyName': 'Please enter currency name',
  'sys.currency.currencyAbbr': 'Currency Abbreviation',
  'sys.currency.enterCurrencyAbbr': 'Please enter currency abbreviation',
  'sys.currency.currencySign': 'Currency Symbol',
  'sys.currency.enterCurrencySign': 'Please enter currency symbol',
  'sys.currency.cancel': 'Cancel',
  'sys.currency.confirm': 'Confirm',
  'sys.currency.operationSuccess': 'Operation successful',
  'sys.currency.uploadSuccess': 'Upload successful',
  'sys.currency.uploadFailed': 'Upload failed',
  'sys.currency.setDefaultConfirm': 'Are you sure you want to set the selected currency as the default currency?',
  'sys.currency.enableConfirm': 'Are you sure you want to enable the selected currency?',
  'sys.currency.disableConfirm': 'Are you sure you want to disable the selected currency?',
  'sys.currency.currentDefault': 'Current Default Currency',
  'sys.currency.setAsDefault': 'Set as Default',
  'sys.currency.addCurrency': 'Add Currency',
  'sys.currency.noIcon': 'No Icon',
  'sys.addMaintenanceInfoSuccess1': 'Successfully added preset maintenance information！',
  'sys.addMaintenanceInfoFail1': 'Failed to add preset maintenance information',
  'sys.addMaintenanceInfoError1': 'Error adding preset maintenance information',
  'sys.addMaintenanceInfoNotice': 'Add preset maintenance information prompt',
  'sys.addMaintenanceInfoNotice1': 'Are you sure to replace the existing preset information',
  'sys.addMaintenanceInfoNotice2': 'Are you sure to preset maintenance for this time period',
  'member.remark.delete.all': 'delete all',
  'user.title.getBack': 'retrieve',
  'sys.msgContentTooLong': 'The content exceeds 1000 characters in length, please check the text content and copy it from WordPad.',
  'constants.PAY_LEVEL1_VIP_MODEL_2_-1': 'All available',
  'constants.PAY_LEVEL1_VIP_MODEL_2_0': 'Level 0 available',
  'constants.PAY_LEVEL1_VIP_MODEL_2_1': 'Level 1 available',
  'constants.PAY_LEVEL1_VIP_MODEL_2_2': 'Level 2 is available',
  'constants.PAY_LEVEL1_VIP_MODEL_2_3': '3 levels available',
  'constants.PAY_LEVEL1_VIP_MODEL_2_4': '4 levels available',
  'constants.PAY_LEVEL1_VIP_MODEL_2_5': '5 levels available',
  'constants.PAY_LEVEL1_VIP_MODEL_2_6': '6 levels available',
  'constants.PAY_LEVEL1_VIP_MODEL_2_7': '7 levels available',
  'constants.PAY_LEVEL1_VIP_MODEL_2_8': '8 levels available',
  'constants.PAY_LEVEL1_VIP_MODEL_2_9': '9 levels available',
  'constants.PAY_LEVEL1_VIP_MODEL_2_10': 'Available at level 10',
  'sys.offerCreateTime': 'Offer creation time',
  'sys.betflowBonusGivePeriodType': 'Billing period type',
  'sys.betflowBonusGivePeriodTime': 'Billing Period',
  'sys.enterBetflowBonusGivePeriodType': 'Select the settlement period type',
  'sys.betflowBonusGivePeriodTypeDaily': 'Daily',
  'sys.betflowBonusGivePeriodTypeWeekly': 'Weekly',
  'sys.betflowBonusGivePeriodTypeMonthly': 'Monthly',
  'sys.enterBetflowBonusGivePeriodTime': 'Enter the settlement period',
  'menu.four': '4D lottery',
  'menu.bet': '4D ticket',
  'menu.drawOpen': '4D draw open',
  'menu.fourConfig': '4D lottery config',
  'fourd.export.excel': '4D lottery ticket.xls',
  'fourd.merchant.profit': 'Merchant profit',
  'fourd.bet.countNumber': 'Total odd bet',
  'fourd.bet.betCountNumber': 'Total bet',
  'fourd.future.openPeriods': 'Expected draw time',
  'fourd.title.enteringOpenNumber': 'Enter lottery numbers, please separate multiple numbers with (,) comma',
  'fourd.title.firstPrize': 'First prize',
  'fourd.title.twoPrize': 'second prize',
  'fourd.title.therePrize': 'Third prize',
  'fourd.title.fourPrize': 'Finalist',
  'fourd.title.fivePrize': 'Comfort general',
  'fourd.bet.countBetAmount': 'Total bet amount',
  'fourd.titile.payAmount': 'Award amount',
  'fourd.title.lookDrawInfo': 'View lottery information',
  'fourd.title.payBetCount': 'Number of winning bets',
  'fourd.title.openType': 'Draw type',
  'sys.title.weekType': 'week',

  'menu.promote': 'Promotion Management',
  'menu.promoteSetting': 'Reward Configuration',
  'menu.promoteRewardReport': 'Reward Report',
  'menu.promoteInvitationReport': 'Invitation Report',
  'menu.mlmSetting': 'Renrendai configuration',
  'menu.mlmReport': 'Report for everyone',

  'mlm.title.betflowCheck': 'Effective betflow is satisfied',
  'mlm.title.depositCheck': 'Definition of valid number of invitations: Deposit is met',
  'mlm.title.settingEnable': 'Whether to enable invitation achievements',
  'mlm.title.desc1': 'Statistics from the opening date (the opening date is displayed here)',
  'mlm.invite.id': 'serial number',
  'mlm.invite.promoteName': 'Achievement Name',
  'mlm.invite.promoteImgUrl': 'Picture',
  'mlm.invite.inviteNumber': 'The cumulative number of valid invitations',
  'mlm.invite.extraAmount': 'Incentive amount',
  'mlm.invite.betflowMultiple': 'flow multiple',
  'mlm.invite.extraPoint': 'Reward Points',
  'mlm.invite.operation': 'Operation',
  'mlm.invite.settingAdd': 'Add invitation achievement',
  'mlm.invite.settingForm': 'Invitation achievement configuration',
  'mlm.invite.field1': 'Achievement name',
  'mlm.invite.field2': 'Total number of valid invitations',
  'mlm.invite.field3': 'Reward amount',
  'mlm.invite.field4': 'rollover multiple',
  'mlm.invite.field5': 'Reward Points',
  'mlm.invite.field6': 'Whether to restrict the same IP and the same device',
  'mlm.invite.field7': 'PC task icon',
  'mlm.invite.field8': 'H5 side task icon',
  'mlm.invite.field9': 'Picture',
  'mlm.invite.field10': 'Inviter username',
  'mlm.invite.field11': 'Number of invited registrants',
  'mlm.invite.field12': 'Invite username',
  'mlm.invite.field13': 'Invite reward amount',
  'mlm.invite.field14': 'Distribution status',
  'mlm.invite.field15': 'Accumulated effective turnover',
  'mlm.invite.field16': 'Is it a valid member',
  'mlm.invite.field17': 'Whether it is the same IP device',
  'mlm.invite.field18': 'Invite valid users',
  'mlm.invite.field19': 'Bonus type',
  'mlm.invite.field20': 'Bonus',
  'mlm.invite.field21': 'Points',
  'mlm.invite.field22': 'The invitation achievement has been issued',
  'mlm.invite.field23': 'Betting rebate has been distributed',
  'mlm.invite.field24': 'Points for inviting students have been issued',
  'mlm.invite.field25': 'Pen',
  'mlm.invite.field26': 'Front desk invitation description',

  'table.title.promote.level': 'Level',
  'table.title.promote.bonus': 'Bonus amount',
  'table.title.promote.multiple': 'Sequence multiple',
  'table.title.promote.extra.status': 'Are there any extra rewards?',
  'table.title.promote.extra.nothing': 'No extra reward',
  'table.title.promote.extra.perecent': 'Reward percentage',
  'table.title.promote.extra.level': 'Participation level: {level} or above',
  'table.title.promote.upgradeCnd': 'Upgrade conditions and rewards',
  'table.title.promote.extra.upgradeCount': 'Invite {count} or more people',
  'table.title.promote.extra.upgradeAmount': 'Reward {amount}',
  'table.title.promote.extra.upgradeMultiple': 'Need to complete {multiple} times the pipeline',
  'table.title.promote.finishCnd': 'Finishing conditions',
  'table.title.promote.checkInCount': 'Number of check-ins: {count}',
  'table.title.promote.totalDeposit': 'Cumulative deposit: {amount}',
  'table.title.promote.betflowAmount': 'Valid bet: {amount}',
  'table.title.promote.balanceFee': 'Yuebao interest: {amount}',
  'table.title.promote.operate': 'Operation',
  'sys.smg167': 'Are you sure to delete the {level} promotion reward configuration? ',
  'btnText.addPromoteSetting': 'Add configuration',
  'input.placeholder.msg': 'Promotion level',
  'btnText.editPromoteSetting': 'Edit configuration',
  'form.titalName.promote': 'Promotion Configuration',
  'form.lableName.promote.level': 'Promote level',
  'form.lableName.promote.level.prompt': 'Please enter the promotion level',
  'form.lableName.promote.amount': 'Reward amount',
  'form.lableName.promote.amount.prompt': 'Please enter the reward amount',
  'form.lableName.promote.multiple': 'promote multiples',
  'form.lableName.promote.multiple.prompt': 'Please enter the serial number',
  'form.lableName.promote.extra': 'Extra bonus',
  'form.lableName.promote.extraPercent': 'Extra Percentage of Reward',
  'form.lableName.promote.extraPercent.prompt': 'Please enter the percentage of extra reward',
  'form.lableName.promote.extraLevel': 'Extra reward participation level',
  'form.lableName.promote.extraLevel.prompt': 'Please select the extra reward participation level',
  'form.lableName.promote.avoidRelegation': 'Avoid relegation Condition',
  'form.lableName.promote.upgradeCount': 'Upgrade conditions',
  'form.lableName.promote.upgradeCount.prompt': 'Please enter the upgrade conditions',
  'form.lableName.promote.upgradeAmount': 'Upgrade bonus',
  'form.lableName.promote.upgradeAmount.prompt': 'Please enter the upgrade reward',
  'form.lableName.promote.upgradeMultiple': 'Upgrade bonus rollover multiple',
  'form.lableName.promote.upgradeMultiple.prompt': 'Please enter the upgrade bonus turnover multiple',
  'form.lableName.promote.checkIn': 'Number of check-ins',
  'form.lableName.promote.checkIn.prompt': 'Please choose whether to set check-in times conditions',
  'form.lableName.promote.checkInCount': 'Number of check-ins',
  'form.lableName.promote.checkInCount.prompt': 'Please fill in the number of check-ins',
  'form.lableName.promote.totalDeposit': 'Accumulated Deposit',
  'form.lableName.promote.totalDeposit.prompt': 'Please choose whether to set accumulative deposit conditions',
  'form.lableName.promote.totalDepositAmount': 'Accumulated Deposit',
  'form.lableName.promote.totalDepositAmount.prompt': 'Please fill in the cumulative deposit amount',
  'form.lableName.promote.betflow': 'valid bet',
  'form.lableName.promote.betflow.prompt': 'Please choose whether to set a valid bet amount condition',
  'form.lableName.promote.betflowAmount': 'Valid bet',
  'form.lableName.promote.betflowAmount.prompt': 'Please fill in a valid bet amount',
  'form.lableName.promote.balanceFee': 'Yuebao Interest',
  'form.lableName.promote.balanceFee.prompt': 'Please choose whether to set up balanceFee interest conditions',
  'form.lableName.promote.balanceFeeAmount': 'Yuebao interest amount',
  'form.lableName.promote.balanceFeeAmount.prompt': 'Please fill in the interest amount of Yu`e Bao',
  'form.lableName.promote.extraLevel.1': 'VIP1 level and above',
  'form.lableName.promote.extraLevel.2': 'VIP2 level and above',
  'form.lableName.promote.extraLevel.3': 'VIP3 level and above',
  'form.lableName.promote.extraLevel.4': 'VIP4 level and above',
  'form.lableName.promote.extraLevel.5': 'VIP5 level and above',
  'form.lableName.promote.extraLevel.6': 'VIP6 level and above',
  'form.lableName.promote.extraLevel.7': 'VIP7 level and above',
  'form.lableName.promote.extraLevel.8': 'VIP8 level and above',
  'form.lableName.promote.extraLevel.9': 'VIP9 level and above',
  'form.lableName.promote.extraLevel.10': 'VIP10 level and above',
  'user.title.addBankCard': 'Add bank card',
  'user.title.addBankCardSuccess': 'Add bank card successfully',
  'user.title.addBankCardError': 'Failed to add bank card',
  'user.title.addBankCardMendAuthMobilePhone': 'Adding a bank card requires binding a mobile phone number',
  'user.title.addBankCardMendAuthWithdrawPWD': 'Adding a bank card requires setting up a withdrawal password',
  'lable.addBankCard.name': 'bank card account name',
  'lable.addBankCard.name.msg': 'Please enter the bank card account name',
  'lable.addBankCard.bankName': 'Bank Name',
  'lable.addBankCard.bankName.msg': 'Please select a bank name',
  'lable.addBankCard.bankName.msg1': 'Please enter the bank name',
  'lable.addBankCard.bankNumber': 'Bank Card Account Number',
  'lable.addBankCard.bankNumber.msg': 'Please enter the bank card account number',
  'lable.addBankCard.subBank': 'Name of opening bank',
  'lable.addBankCard.subBank.msg': 'Please enter the name of the bank that opened the account',
  'agent.title.subTotalShareProfit': 'Total net profit of subordinate agents: {shareProfit}',
  'agent.title.subTotalShareCom': 'Sum of subordinate agent commission: {shareCommission}',
  'agent.title.subTotalShareFee': 'Subordinate agent commission: {shareFee}',
  'agent.title.billAmount': 'Billing commission',
  'agent.billType.selfAmount': 'self-income: {selfAmount}',
  'agent.billType.subAmount': 'Inferior income: {subAmount}',
  'agent.billType.billAmount': 'Settlement income: {totalAmount}',
  'agent.title.superiorAccount': 'Superior Agent',
  'agent.title.superiorAccount2': 'Superior Agent Account',
  'agent.title.level': 'Level',
  'agent.title.level.all': 'All',
  'agent.title.level.1': 'level one',
  'agent.title.level.2': 'Level Second',
  'agent.title.level.3': 'Level Three',
  'agent.monthlyTable.agentLevel': '{level}level agent',
  'agent.monthlyTable.superiorAccount': 'Superior Agent: {account}',
  'agent.commissionReport.pageBetflow': 'This page flow',
  'agent.commissionReport.pageBonus': 'This page offer',
  'agent.commissionReport.pageDeposit': 'This page deposit',
  'agent.commissionReport.pageWithdraw': 'This page withdrawal',
  'agent.commissionReport.pageResult': 'This page wins or loses',
  'agent.commissionReport.totalBetflow': 'Total Betflow',
  'agent.commissionReport.totalBonus': 'Total Bonus',
  'agent.commissionReport.totalDeposit': 'Total Deposit',
  'agent.commissionReport.totalWithdraw': 'Total withdrawal',
  'agent.commissionReport.totalResult': 'Total Win or Lose',
  'agent.monthlyReport.pageProfit': 'This page monthly profit and loss',
  'agent.monthlyReport.pageBetflow': 'This page betting',
  'agent.monthlyReport.pageBonus': 'This page offer',
  'agent.monthlyReport.pageTrans': 'page handling fee',
  'agent.monthlyReport.pageFinalProfit': 'Net profit on this page',
  'agent.monthlyReport.pageShareCom': 'This page rake',
  'agent.monthlyReport.pageBillAmount': 'This page settlement',
  'agent.monthlyReport.totalProfit': 'Total monthly profit and loss',
  'agent.monthlyReport.totalBetflow': 'Total Betflow',
  'agent.monthlyReport.totalBonus': 'Total Bonus',
  'agent.monthlyReport.totalTrans': 'Total transaction fee',
  'agent.monthlyReport.totalFinalProfit': 'Total Net Profit',
  'agent.monthlyReport.totalShareCom': 'Total rake',
  'agent.monthlyReport.totalBillAmount': 'Total BillAmount',
  'agent.title.agentSubUserResult': 'Members win or lose',

  'user.title.updateBirthday': 'Modify birthday',
  'user.title.oldBirthday': 'Old birthday',
  'user.title.newBirthday': 'New birthday',
  'user.title.pleaseEnterNewBirthday': 'Please enter new birthday information',
  'member.title.markCount': 'Number of people marked',
  'user.frmTitel.userModel': 'player sample',
  'user.frmTitel.userPeriod': 'Period',
  'user.frmTitel.daily': 'Daily',
  'user.frmTitel.weekly': 'Weekly',
  'user.frmTitel.monthly': 'Monthly',
  'user.frmTitel.with': 'of',
  'user.frmTitel.regisiter': 'Registered user',
  'user.frmTitel.regisiterAndDeposit': 'Register and deposit users',
  'user.frmTitel.keepCnd': 'Keeping behavior: after',
  'user.frmTitel.inCnd': 'Inner',
  'user.frmTitel.beted': 'Betting on',
  'user.frmTitel.online': 'Online',
  'user.frmTitel.countKeepNum': 'Count as retained user',
  'user.frmTitel.platform': 'Channel',
  'common.sendMail.writeEmail': 'Write Email',
  'common.sixLottery.deleteReply': 'Delete Reply',
  'common.betResult.lost': 'lost',
  'common.betResult.fair': 'Fair',
  'common.betResult.win': 'Win',
  'common.btn.reset': 'Reset',
  'common.btn.search': 'Search',
  'user.title.firstDeposit': 'First Deposit',
  'user.title.realNameAuth': 'Real-name authentication',
  'user.title.mobilePhoneAuth': 'Mobile phone number authentication',
  'user.title.emailAuth': 'Mailbox authentication',
  'user.title.userVIPLevel': 'Membership level',
  'user.title.startTime': 'Start Time',
  'user.title.endTime': 'End Time',
  'agent.title.domainPublic': 'Domain Name Type',
  'agent.title.domainPublicMsg': 'Please select the domain name type',
  'agent.title.domainPublic.public': 'Public domain name',
  'agent.title.domainPublic.private': 'Exclusive domain name',
  'agent.title.preventBlock': 'WeChat anti-blocking',
  'agent.title.agentAccountNotEmpty': 'The agent account corresponding to the exclusive domain name cannot be empty',
  'user.title.loginIPAddress': 'Login IP attribution',
  'user.title.userRelationTime': 'Current user association time',
  'user.title.loginIP': 'Login IP',
  'bonus.newInviteBonus.msg1': "Invitee deposits each time",
  'bonus.newInviteBonus.msg2': "As an inviter",
  'bonus.newInviteBonus.msg3': "Invitee VIP promotion bonus",
  'bonus.newInviteBonus.msg4': "Times the inviter's bonus",
  'bonus.newInviteBonus.msg5': "The inviter's salary withdrawal",
  'bonus.newInviteBonus.msg6': "Inviter promotion bonus withdrawal",
  'bonus.newInviteBonus.msg7': "Yuan and up",
  'bonus.newInviteBonus.msg8': "Times of the water",
  'bonus.newInviteBonus.msg9': "Water conditions",
  'promote.reward.title.regDate': 'Invite registration time',
  'promote.reward.title.finishDate': 'Invite completed time',
  'promote.reward.title.keyword': 'Keyword',
  'promote.reward.title.keyword.msg': 'invite/invite account',
  'promote.reward.table.promoteAccount': 'Inviting person',
  'promote.reward.table.targetAccount': 'Invite account',
  'promote.reward.table.targetRegDate': 'Invite registration time',
  'promote.reward.table.amount': 'Reward amount',
  'promote.reward.table.status': 'Status',
  'promote.reward.table.finishDate': 'Finish time',
  'promote.reward.table.moneyDate': 'Receipt time',
  'promote.reward.table.pageUnfinishedAmount': 'Unfinished Amount on this page',
  'promote.reward.table.pageFinishedAmount': 'This page has completed the amount',
  'promote.reward.table.totalUnfinishedAmount': 'Total UnfinishedAmount',
  'promote.reward.table.totalFinishedAmount': 'Total Finished Amount',
  'promote.invitation.title.queryDate': 'Query Date',
  'promote.invitation.table.countDate': 'Statistic date',
  'promote.invitation.table.activeCount': 'Active users of the day',
  'promote.invitation.table.participateCount': 'Users participating in the activity',
  'promote.invitation.table.participateRate': 'Activity participation rate',
  'promote.invitation.table.regCount': 'Number of new registration offline',
  'promote.invitation.table.firstDeposit': 'First deposit offline number',
  'promote.invitation.table.firstDepositRate': 'New registration first deposit rate',
  'promote.invitation.table.pageParticipateRate': 'Activity participation rate on this page',
  'promote.invitation.table.pageRegCount': 'Number of new registrations on this page',
  'promote.invitation.table.pageFirstDepositCount': 'Number of first deposit offline on this page',
  'promote.invitation.table.pageFirstDepositRate': 'The first deposit rate of new registrations on this page',
  'promote.invitation.table.totalParticipateRate': 'Total event participation rate',
  'promote.invitation.table.totalRegCount': 'Total new registration offline count',
  'promote.invitation.table.totalFirstDeopsitCount': 'Total FirstDeopsitCount',
  'promote.invitation.table.totalFirstDepositRate': 'Total new registration first deposit rate',
  'promote.upgrade.title.queryDate': 'Upgrade time',
  'promote.upgrade.title.keyword.msg': 'Member account',
  'promote.upgrade.table.userAccount': 'Member Account',
  'promote.upgrade.table.amount': 'Reward amount',
  'promote.upgrade.table.betflow': 'flow progress',
  'promote.upgrade.table.createTime': 'Receive time',
  'promote.upgrade.table.pageAmount': 'Reward amount on this page',
  'promote.upgrade.table.totalAmount': 'Total reward amount',
  'menu.promoteUpgradeReport': 'Upgrade reward report',
  'menu.historySearch': 'History Search',
  'menu.backupSetting': 'historical data backup configuration',
  'menu.queryHistoryBonus': 'Discount collection history',
  'menu.queryHistoryPayOrder': 'Recharge History',
  'menu.queryHistoryBalanceLog': 'Account change history record',
  'historySearch.tranLog.frm.userName': 'Member account',
  'historySearch.tranLog.frm.userName.msg': 'Please enter a member account',
  'historySearch.tranLog.frm.tranDate': 'Trading time',
  'historySearch.tranLog.frm.type': 'Transaction Type',
  'historySearch.setting.table.name': 'Backup item name',
  'historySearch.setting.table.day': 'Backup days',
  'historySearch.setting.table.status': 'Status',
  'historySearch.setting.table.remark': 'Backup item description',
  'bonus.checkinIntegral.msg1': 'VIP level reward setting',
  'bonus.checkinIntegral.msg2': 'VIP level for',

  'menu.queryLoginMember': 'Client-side statistics',

  'member.queryLoginMember.registeredUserTotal': 'Total Registered persons',
  'member.queryLoginMember.taodyUp': 'Today new',
  'member.queryLoginMember.logedUserToday': 'Total number of registrations today',
  'member.queryLoginMember.daysUp': 'Days from',
  'member.queryLoginMember.logedTimeToday': 'Log in today',
  'member.queryLoginMember.logedSuccRateToday': 'Login success rate today',
  'member.queryLoginMember.thePie': 'The pie chart',
  'member.queryLoginMember.columnar': 'A histogram',
  'member.queryLoginMember.logedTerminalStatistics': 'Login port overview',
  'sys.welcomeLogin.msg': 'Welcome to log in to GameStone Technology Intelligent Management Background',
  'bonus.title.createTime': 'Offer date',
  'bonus.log.remark': 'Remark information',
  'promote.reward.table.operateDetail': 'Operator/operating time',
  'promote.reward.table.operate': 'Operation',
  'promote.reward.table.showDetail': 'View progress',
  'promote.log.showDetail.account': '{account} completion progress',
  'promote.log.showDetail.checkIn': 'Check-in: {finish}/{target}',
  'promote.log.showDetail.deposit': 'Cumulative deposit: {finish}/{target}',
  'promote.log.showDetail.betflow': 'Accumulated betting: {finish}/{target}',
  'promote.log.showDetail.balanceFee': 'Yuebao interest: {finish}/{target}',
  'promote.log.showRefuseReason': 'Rejection Reason',
  'promote.reward.table.changeRefuse': 'Set as failed',
  'promote.reward.table.changeNormal': 'Set to normal',
  'promote.log.changeRewardStatus': 'Modify reward status',
  'promote.log.confirmChangeRewardStatus': 'Are you sure to modify the reward status of {target} members? ',
  'promote.reward.table.status.refuse': 'Reject',
  'constants.bonusType_25': 'Profit and loss discount',
  'constants.newBonusType_25': 'Profit and loss discount',
  'constants.bonusMainType_25': 'Profit and loss discount',
  'constants.newBonusMainType_25': 'Profit and loss discount',
  'sys.profitType': 'Profit and loss type',
  'sys.profitType.win': 'win',
  'sys.profitType.lost': 'Loss',
  'sys.profitType.all': 'all',
  'bonus.winLost.cnd.title': 'Set preferential conditions',
  'bonus.winLost.cnd.add': 'Add condition',
  'bonus.winLost.cnd.profitAmount': 'Profit/Loss (absolute value) reached',
  'bonus.winLost.cnd.profitAmount.msg': 'Please enter the absolute value of profit and loss',
  'bonus.winLost.cnd.giftAmount': 'Bonus Amount',
  'bonus.winLost.cnd.giftAmount.msg': 'Please enter the bonus amount',
  'bonus.winLost.frm.levelLimit': 'Participation level',
  'bonus.winLost.frm.levelLimit.msg': 'Please select participation level',
  'sys.includeAndMoreThan': 'and above',
  'user.title.minBalance': 'Please enter the minimum balance',
  'user.title.maxBalance': 'Please enter the maximum balance',
  'user.title.totalMainBalance': 'Total main account balance',
  'common.bonus.winLostBonus': '{type} profit and loss discount, {date}',
  'sys.winLost.giveType.independent': 'Independent distribution of each game platform',
  'sys.winLost.giveType.unify': 'Participate in the unified distribution of the game platform',
  'sys.winLost.giveType.msg': 'Please select the distribution method',
  'sys.winLost.giveType': 'Distribution method',
  'constants.riskLevelType_-8': 'Limited to receive upgrade mode salary',
  'front.bonus.upgradeReward.riskMsg.title': 'Risk control restriction',
  'front.bonus.upgradeReward.riskMsg.upgradeAmount': 'Risk control limits the distribution of upgrade mode upgrade rewards',
  'front.bonus.upgradeReward.riskMsg.weekRemark': 'Risk control limit distribution upgrade mode weekly salary',
  'front.bonus.upgradeReward.riskMsg.monthRemark': 'Risk control limit distribution upgrade mode monthly salary',
  'menu.leaderboard': 'Leaderboard',
  'menu.gameleaderboard': 'Third-party game platform rankings',
  'menu.proxyleaderboard': 'Channel Agent Ranking',
  'menu.userleaderboard': 'Member Ranking',
  'console.leaderboard': 'Rank',
  'console.firstAmountCount': 'First deposit',
  'console.activeUserCount': 'Active number',
  'console.userName': 'Member name',
  'console.depositAmount': 'Deposit (yuan)',
  'console.depositAmountVN': 'Deposit (VND)',
  'console.withdrawAmount': 'Withdraw (yuan)',
  'console.withdrawAmountVN': 'Withdraw (VND)',
  'console.betflow': 'Bet (yuan)',
  'console.betflowVN': 'Bet (VND)',
  'console.betflow2': 'Bet',
  'console.resultAmount': 'Win or lose (yuan)',
  'console.resultAmountVN': 'Win or lose (VND)',

  'console.totalBetflow': 'Platform valid betting',
  'smsAllocation.mobilePhone.status': 'Number Status',
  'smsAllocation.mobilePhone.status_1': 'Empty number',
  'smsAllocation.mobilePhone.status_2': 'Out of service',
  'smsAllocation.mobilePhone.status_0': 'Normal',
  'smsAllocation.mobilePhone.sendStatus': 'Send Status',
  'smsAllocation.mobilePhone.sendStatus.select': 'Select sending status',
  'smsAllocation.mobilePhone.sendStatus.done': 'Sent',
  'smsAllocation.mobilePhone.sendStatus.not': 'not sent',
  'smsAllocation.mobilePhone.importInfo': 'Remarks information',
  'smsAllocation.mobilePhone.sendPhoneText': 'Send SMS',
  'smsAllocation.mobilePhone.searchKeyword': 'Mobile phone number/user name/remarks information',
  'phoneAllocation.importData': 'Import',
  'phoneAllocation.selectSend': 'Selective Send',
  'phoneAllocation.allSend': 'Send all',
  "user.title.updPwdTime": "Change password date",
  "common.queryFrm.dayCnt": "I haven't changed my password in the last few days",
  "sys.riskUpdPwd": "Change password tag",
  "sys.riskUpdPwd.need": "YES",
  "sys.riskUpdPwd.notneed": "NO",
  'user.pay.type': 'Payment method',
  'user.title.payTypeList': 'Exclusive payment method',
  'user.title.confirmDelete': 'Confirm delete',
  'user.title.deletePayTypeMsg': 'Are you sure to delete this payment method? ',
  'common.title.payChannel': 'Payment Method',
  'user.title.payType': 'Payment Channel',
  'user.title.payName': 'Payment Name',
  'user.title.addUserPayType': 'Add payment method',
  'lable.addUserPayType.payType': 'Payment Method',
  'lable.addUserPayType.payType.msg': 'Please choose a payment method',
  'user.title.addPayTypeSuccess': 'Add payment method successfully',
  'sys.version.announcement.add': 'Add announcement',
  'sys.version.announcement.title': 'Title',
  'sys.version.announcement.title.msg': 'Please enter a title',
  'sys.version.announcement.content': 'Content',
  'sys.version.announcement.content.msg': 'Please enter content',
  'sys.version.announcement.status': 'Are you online?',
  'sys.version.announcement.status_0': 'Coming soon',
  'sys.version.announcement.status_1': 'Online',
  'sys.version.announcement.changeStatus': 'Release online',
  'sys.version.confirmPublic': 'Are you confirming the release online? ',
  'sys.withdraw.pickType.label': 'Receive validity period',
  'sys.withdraw.pickType.rule': 'Please select the validity period',
  'sys.withdraw.pickType.radio.value1': 'long term effective',
  'sys.withdraw.pickType.radio.value2': 'Member registration is valid within a few days',
  'sys.withdraw.pickExpireDays.rule': 'Please enter valid days',
  'sys.withdraw.pickExpireDays.day': 'days',
  'sys.withdraw.completeWithdrawDays.valid': 'Please fill in the time to complete the first withdrawal',
  'sys.withdraw.pickExpireDays.valid': 'Please fill in the effective date of collection',
  'sys.withdraw.rule': 'Please select the order of withdrawal',
  'sys.withdraw.withdrawType.label': 'Withdrawal order',
  "sys.withdraw.withdrawType.radio.value1": 'first mention',
  'sys.withdraw.completeWithdrawType.label': 'Completion of first withdrawal time',
  'sys.completeWithdrawType.rule': 'Please select the time to complete the first withdrawal',
  'sys.completeWithdrawType.prefix': 'Sign Up',
  'sys.giftAmount.label': 'bonus amount',
  'sys.giftAmount.rule': 'Please enter a credit amount',
  'sys.maxWithdrawAmount.label': 'Maximum withdrawal amount',
  'sys.maxWithdrawAmount.rule': 'Please enter the maximum withdrawal amount',
  'sys.deposit.applyType.label': 'sending type',
  'sys.deposit.applyType.rule': 'Please select a delivery type',
  'sys.deposit.applyType.radio.value1': 'auto delivery',
  'sys.deposit.applyType.radio.value2': 'Pick up manually',
  'sys.deposit.pickType.label': 'Receive validity period',
  'sys.deposit.pickType.rule': 'Please select the validity period',
  'sys.deposit.pickType.radio.value1': 'long term effective',
  'sys.deposit.pickType.radio.value2': 'Member registration is valid within a few days',
  'sys.deposit.pickExpireDays.rule': 'Please enter valid days',
  'sys.deposit.pickExpireDays.day': 'days',
  'sys.withdraw.applyType.label': 'sending type',
  'sys.withdraw.applyType.rule': 'Please select a delivery type',
  'sys.withdraw.applyType.radio.value1': 'auto delivery',
  'sys.withdraw.applyType.radio.value2': 'Pick up manually',
  'front.bonus.firstWithdrawBonus': 'Newcomer First Withdrawal Bonus',
  'front.bonus.firstRegisterBonus': 'Newcomer registration bonus',
  'front.bonus.firstDepositBonus': 'Newcomer First Deposit Bonus',
  'front.bonus.signInNewBonus': 'Newcomer Sign In Bonus',
  'front.bonus.lostNewBonus': 'Newcomer resurrection bonus',

  'report.radio.today.data': 'Real-time data',
  'report.radio.history.data': 'Historical data',

  'constants.ropeType_1': 'Red rope',
  'constants.ropeType_2': 'Green rope',
  'constants.ropeType_3': 'Yellow rope',
  'constants.ropeType_4': 'White rope',
  'constants.ropeType_5': 'Black rope',
  'constants.ropeType_6': 'Colorful rope',
  'sys.ropeType.pleaseEnterAccumulatedBet': 'Please enter accumulated bet',
  'sys.ropeType.pleaseSelectSyntheticRope': 'Please select the desired type of synthetic rope',
  'sys.ropeType.pleaseSelectQuantity': 'Please select the required quantity of synthetic rope',
  'sys.ropeType.ropeType': 'rope type',
  'sys.ropeType.pleaseSelectRopeType': 'Please select a rope type',
  'sys.ropeType.convertibleCash': 'convertible to cash',
  'sys.ropeType.pleaseEnterCashExchange': 'Please enter the cash you can exchange',
  'sys.ropeType.accumulatedBetting': 'Accumulated betting',
  'sys.ropeType.syntheticRopeRequiredType': 'Synthetic Rope Required Type',
  'sys.ropeType.amountNeededSynthesizeRope': 'Amount needed to synthesize rope',
  'sys.ropeType.prizeCreateTime': 'Reward generation time',
  'sys.ropeType.prizeUpdateTime': 'Award claim time',
  'sys.ropeType.convertIntoCash': 'Convert into cash',
  'sys.ropeType.totalAmountReceived': 'Total amount received',
  'sys.ropeType.totalDegree': 'Total degree',
  'pay.label.payeeName': 'Payee name',
  'pay.label.payeeName1': 'Please enter payee name',
  'pay.label.payeeName2': 'Enter up to 25 characters',
  'pay.label.payeeNumber': 'Payee account number',
  'pay.label.payeeNumber1': 'Please enter the Payee account number',

  'sys.title.userAccount.registrationTime': 'Member Registration time',
  'user.title.totalResult': 'Always win or lose',
  'bet.label.totalResult': 'Always win or lose (yuan)',
  'bet.label.totalResultVN': 'Always win or lose (VND)',
  'bet.label.pageResult': 'Win or lose on this page (yuan)',
  'bet.label.pageResultVN': 'Win or lose on this page (VND)',

  'onlineuser.export.excel': 'online user report.xlsx',
  'menu.onlineUserHistory': 'Online users (every 10 minutes)',
  'onlineUserHistory.title.countHourDesc': 'per hour\ten minutes',
  'onlineUserHistory.title.userCount10': '00：00～10：00',
  'onlineUserHistory.title.userCount20': '10：00～20：00',
  'onlineUserHistory.title.userCount30': '20：00～30：00',
  'onlineUserHistory.title.userCount40': '30：00～40：00',
  'onlineUserHistory.title.userCount50': '40：00～50：00',
  'onlineUserHistory.title.userCount60': '50：00～60：00',

  'menu.questList': 'Survey List',
  'menu.questRecord': 'Survey Records',
  'sys.title.questionTitle': 'Questionnaire name',
  'sys.title.userLevel': 'Member Level',
  'sys.title.userAwardTime': 'Points change date',
  'sys.title.userAwardPointBefore': 'Points before change',
  'sys.title.userAwardPointAfter': 'Points after change',
  'menu.userAwardRecord': 'Member points record',
  'sys.title.userAwardPoint': 'Points change amount',
  'sys.title.answerTime': 'Submission Time',
  'sys.form.surveyLog.keyword': 'Member account',

  'agent.title.attributes.check': 'Please select agent attributes',
  'agent.title.attributes': 'Agent Attributes',
  'agent.title.attributes.external': 'External Agent',
  'agent.title.attributes.internal': 'Internal Agent',
  'agent.title.account.manager.check': 'Please provide the account number of the account manager',
  'agent.title.account.manager': 'Account Manager',

  'pay.title.memberPaymentStatus': 'Member confirms payment status',
  'pay.title.memberPaymentStatus0': 'Unopened',
  'pay.title.memberPaymentStatus1': 'to be confirmed',
  'pay.title.memberPaymentStatus2': 'Not received',
  'pay.title.memberPaymentStatus3': 'Already arrived',
  'user.title.bindTime': 'Binding time',
  'push.title.msgId': 'Message ID',
  'menu.QueryMemberDevice': 'Member Device Information',
  'device.title.os': 'Member Device',
  'device.title.registrationId': 'Aurora ID',
  'user.title.isTop': 'Is Top',
  'user.title.top': 'Top',
  'user.title.topCancel': 'Un Top',

  'sys.vip.dayLimitWithdraw': 'Limit the number of withdrawals on the day',
  'sys.vip.dayLimitWithdrawAmount': 'Limit withdrawal amount on the day',

  'sys.msg153': 'If the conditions are met, members can manually claim the rewards on the event page, and they will become invalid after the expiration date.',
  'sys.msg154': 'Statistical deposit types',
  'sys.msg155': 'single deposit',
  'sys.msg156': 'Accumulated deposits',
  'bonus.titie.publicRewardSettings': 'Reward settings',
  'sys.withdrawalChannel': 'Withdrawal channels',
  'sys.msg157': 'Maximum withdraw amount must be greater than minimum withdraw amount',
  'sys.msg158': 'Minimum withdraw (including)',
  'sys.msg159': 'Please enter the minimum withdraw amount',
  'sys.msg160': 'Maximum withdraw (excluding)',
  'sys.msg161': 'Please enter the maximum withdraw amount',
  'sys.msg162': 'Withdrawal amount: {minAmount}~{maxAmount}',
  'sys.msg163': 'Single withdrawal',
  'sys.msg164': 'Cumulative withdrawals',
  'sys.selectWithdrawChannel': 'Please select a withdrawal channel',
  'sys.limitReceiveCount': 'Limit the number of times you can receive it',
  // im 国际化
  'menu.im': 'IM Management',
  'menu.immgmt': 'IM authority management',
  'menu.imMgmt': 'IM authority management',
  'menu.queryMsg': 'IM query messages',
  'user.friendRoom': 'View Room',
  'user.friendAllRoom': 'Room List',
  'user.friendInfo': 'Friend Info',
  'user.title.messagelist': 'Message List',
  'menu.querymsg': 'IM query messages',
  'im.user.binding': 'IM binding user',
  'im.user.title.binding': 'IM binding user',
  'im.user.title.role': 'IM role',
  'im.user.title.loginName': 'IM login name',
  'im.user.title.systemName': 'IM system name',
  'im.user.unbinding': 'IM unbinding user',
  'im.sys.title.confirmUnbinding': 'Confirm to unbind user',
  'im.sys.unbindingAccount': 'Account to be unbound: {userName}',
  'im.sys.login': 'im login',
  'im.sys.login.error': 'No im account bound',
  'pay.withdraw.rejectionNotification': 'Withdrawal rejection notification',


  'sys.user.virtualCurrencyAddress': 'Virtual currency address',
  'sys.user.virtualCurrencyAddress2': 'Virtual currency address list',
  'user.title.delVirtualCurrencyAddress': 'Delete virtual currency address',
  'user.title.askDelVirtualCurrencyAddress': 'Please confirm to delete the virtual currency address?',
  'user.title.updateVirtualCurrencyAddress': 'Modify virtual currency address information',
  'user.title.synchronizeDeposit': 'Synchronize deposit data',
  'user.title.synchronizeWithdrawal': 'Synchronize withdrawal data',
  'user.title.dataInDepositReport': 'The data in [Deposit Report] is',
  'user.title.dataInWithdrawReport': 'The data in [Withdrawal Report] is',
  'user.title.dataInMemberDetails': 'The data in [Member Details] is',
  'user.title.sureSynchronizedDeposit': 'Are you sure the deposit report data is synchronized to the member details data?',
  'user.title.sureSynchronizedWithdrawal': 'Are you sure the withdrawal report data is synchronized to the member details data?',
  'user.title.noSynchronizationRequired': 'The amount is the same, no need to synchronize',
  'pay.withdraw.msg9': '{0}Apply for withdrawal',
  'pay.withdraw.msg10': 'YBF Apply for withdrawal',
  'agent.title.completeInformation': 'Please enter complete information',

  'common.use.log.count': 'Total number of logins in the past six months',

  'agent.title.setPixelParam': 'Set pixel parameters',
  'agent.title.pixelId': 'Pixel Id',
  'agent.title.pixelAccessToken': 'Pixel access token',
  'member.title.pixelPush': 'Pixel push',
  'member.title.selectPixelPush': 'Please select pixels to push',
  'member.title.pixelPushThat': 'Push that user information to the pixel',

  'common.export.limit.exception': 'The exported data has exceeded the system setting of 10,000. Please add filter conditions and try again! ',
  'pay.title.financialTime': 'financial time',

  'agent.title.detail.activeUserNoDistinct': 'Same referral active on multiple days counts as one person',
  'agent.title.detail.depositUserNoDistinct': 'Same referral depositing on multiple days counts as one person',

  'pay.title.orderDescription': 'Order Description',
  'finance.title.orderDescription1': 'Please enter order description',

  'admin.bonus.singleDayDeposit': 'Single deposit on the same day',
  'admin.bonus.accumulatedDeposits': 'Accumulated deposits on the day',
  'admin.pay.selectDepositType': 'Please select deposit type',
  'admin.bonus.sevendayDepositDay': 'day',
  'admin.bonus.sevendayDepositGear': 'gear',
  'admin.bonus.sevendayDepositDayText': 'Day {day}',
  'admin.bonus.sevendayDepositGearText': 'Gear {gear}',

  'sys.allTransactionTypes': 'All transaction types',
  'admin.front.picture.domainName': 'Corresponding domain name',

  'sys.push.msg': 'Push message',
  'sys.push.immediate': 'Instant push',
  'sys.push.notify': 'Umeng Notice',
  'sys.push.type': 'Push type',
  'sys.confirm.enable': 'Confirm to enable it?',
  'sys.confirm.disable': 'Confirm to close?',
  'sys.push.phoneStatus': 'Mobile push status',
  'sys.push.mailStatus': 'Email push status',
  'sys.push.smsStatus': 'SMS push status',
  'push.msg.config.type1': 'Recharge',
  'push.msg.config.type2': 'withdraw',
  'push.msg.config.type3': 'Manual adjustment',
  'push.msg.config.type4': 'VIP upgrade bonus',
  'push.msg.config.type5': 'week salary',
  'push.msg.config.type6': 'week salary',
  'push.msg.config.type7': 'Instant push',
  'push.msg.config.type700': 'Sign In',
  'push.msg.config.type701': 'Re Sign In',
  'push.msg.config.timing': 'Timing push',

  'agent.title.setAdjustParam': 'Set adjust parameters',
  'agent.title.applicationID': 'Application ID',
  'agent.title.registrationID': 'Registration ID',
  'agent.title.loginID': 'Login ID',
  'agent.title.firstSubmitRecharge': 'Submit recharge for the first time',
  'agent.title.firstAddBankCard': 'Adding a bank card for the first time',
  'admin.bonus.dayBonusUpperLimit': 'Maximum discount for the day',
  'admin.bonus.relatedBonus': 'Related promotions',
  'sys.selectPromotionsBonus': 'Please select the promotions to be associated',

  'agent.setAgentUsdtRate': 'Set withdrawal rate',
  'agent.fillFixedExchangeRate': 'Please fill in the fixed exchange rate',
  'admin.bonus.client': 'Clients allowed to receive',
  'admin.bonus.calculationRules': 'Calculation Rules',
  'admin.bonus.calculationRules1': 'Calculating offers (old rules)',
  'admin.bonus.calculationRules2': 'Does not count discounts (new rule)',
  'admin.bonus.calculationRulesInfo': '[Calculating discounts]: Amount of bet placed - Winning amount of a bet = Loss amount [Do not calculate discounts]: Loss amount - Total discount received = Actual loss amount',
  'menu.matrixRoomMgmt': 'Room initial management',
  'user.title.addRoom': 'Create a chat room',
  'user.button.addRoom': 'Create a chat room',
  'user.button.room.select.func': 'Please select the room type',
  'user.title.room.name': 'Chat room name',
  'user.title.room.name.input': 'Please enter the chat room name',
  'user.title.room.title': 'Chat room notes',
  'user.title.room.title.input': 'Please enter chat room remarks',
  'user.title.room.title.max': 'Exceeds the chat room comment length',
  'user.title.room.service': 'Customer Service',
  'user.title.room.service.input': 'Please select customer service',
  'user.title.room.func': 'Chat room type',
  'user.title.room.order': 'order',
  'user.title.room.order.input': 'Please enter the chat room order',
  'user.title.updateRoom': 'Update a chat room',
  'common.title.account.freeze': 'freeze account',
  'common.title.account.unfreeze': 'unfressze account',
  'common.title.status.running': 'Normal',
  'common.title.status.freeze': 'Freeze',
  'sys.account.freeze': 'Account to be freeze：{matrixAccount}',
  'sys.account.unfreeze': 'Account to be unfreeze：{matrixAccount}',
  'user.button.room.message.list': 'Message list',
  'menu.matrixRoomContentMgmt': 'Chat room message management',
  'user.button.addRoomContent': 'Add message',
  'common.radio.room.list': 'Chat room list',
  'user.title.room.content': 'Message content',
  'user.title.room.content.status': 'Message status',
  'user.title.room.content.input': 'Please enter the message content',
  'common.radio.room.list.input': 'Please select a chat room list',
  'menu.ImNotifiMsgMgmt': 'Member notification message query',
  'user.title.room.id': 'Chat room ID',
  'member.title.account.name': 'Member account',
  'member.title.nickname': 'Member Nickname',
  'common.title.room.deploy': 'Release',
  'common.title.room.withdraw': 'Withdraw',
  'admin.title.addTelemarketingList': 'Add to telemarketing list',
  'admin.title.selectedMembers': 'Selected members',
  'admin.title.addMethod': 'Add method',
  'admin.title.remove': 'Remove',
  'admin.title.memberActivateCount': 'Import member list to activate users',
  'user.title.activatedDepositorsCount': 'Number of activated depositors',
  'user.title.activatedBetCount': 'Activate the number of bettors',
  'user.title.lastCallTime': 'Last call time',
  'user.title.depositTimeActivation': 'Deposit time upon activation',
  'user.title.betTimeActivation': 'Betting time when activated',
  'user.title.dialStatus': 'Dial status',
  'user.title.notConnected': 'Not connected',
  'user.title.connected': 'Connected',
  'user.title.numberCalls': 'Number of calls',
  'user.title.callPerson': 'call person',
  'user.title.dialTime': 'Dial time',
  'user.title.hangUpTime': 'Hang up time',
  'user.title.callDuration': 'Call duration',
  'agent.title.room.info': 'IM group information',
  'pay.withdraw.payMayaName': 'PayMaya name',
  'pay.withdraw.payMayaAccount': 'PayMaya account number',
  'pay.withdraw.grabPayName': 'GrabPay name',
  'pay.withdraw.grabPayAccount': 'GrabPay account number',
  'user.title.payMayaPhone': 'PayMaya mobile phone number',
  'user.title.payMayaRealName': 'PayMaya real name',
  'user.title.delPayMaya': 'Delete your PayMaya account',
  'user.title.askDelPayMaya': 'Please confirm to delete your PayMaya account',
  'user.title.confirmUnbindingAllPayMaya': 'Note: After this operation, all PayMaya accounts belonging to the user will be unbound',
  'user.title.grabPayPhone': 'GrabPay mobile phone number',
  'user.title.grabPayRealName': 'GrabPay real name',
  'user.title.delGrabPay': 'Delete your GrabPay account',
  'user.title.askDelGrabPay': 'Please confirm to delete your GrabPay account',
  'user.title.confirmUnbindingAllGrabPay': 'Note: After this operation, all GrabPay accounts belonging to the user will be unbound',
  'user.title.enterPayMayaPhone': 'Please enter PayMaya mobile number',
  'user.title.enterGrabPayPhone': 'Please enter your GrabPay mobile number',
  'user.title.enterPayMayaRealName': 'Please enter PayMaya real name',
  'user.title.enterGrabPayRealName': 'Please enter GrabPay real name',
  'user.title.email': 'Email',
  'user.title.importAndExport': 'Upload and export data',
  'user.title.importAndExportType': 'Export data',
  'user.title.pleaseEnterImportAndExportType': 'Please check export data first',
  'pay.withdraw.weChatName': 'WeChat name',
  'pay.withdraw.weChatAccount': 'WeChat account number',
  'user.title.weChatRealName': 'WeChat real name',
  'user.title.delWeChat': 'Delete WeChat account',
  'user.title.askDelWeChat': 'Please confirm to delete WeChat account',
  'user.title.confirmUnbindingAllWeChat': 'Note: After this operation, all WeChat accounts belonging to this user will be unbound',
  'user.title.enterWeChatAccount': 'Please enter WeChat account',
  'user.title.enterWeChatRealName': 'Please enter WeChat real name',
  'user.title.modifyChannelInformation': 'Modify {channelName} account information',

  'menu.source': 'Pixel source',
  'pixel.event': 'Push event',
  'pixel.all.event': 'All event',
  'pixel.rePush': 'Repush pixel',
  'pixel.rePush.select': 'Select the pixel source you want to push',
  'pixel.up.name': 'Modify configuration',
  'pixel.statistics.name': 'Pixel name/id',
  'pixel.statistics.completeRegistration': 'CompleteRegistration',
  'pixel.statistics.purchase': 'Purchase',
  'pixel.statistics.initiateCheckout': 'InitiateCheckout',
  'pixel.statistics.addPaymentInfo': 'AddPaymentInfo',
  'pixel.xls': 'Pixel statistical report.xls',
  'pixel.push.xls': 'Pixel push report.xls',
  'pixel.add': 'Add Pixel Source',
  'pixel.up': 'Edit Pixel Source',
  'pixel.select': 'Please select pixel source',
  'pixel.select.agent': 'Please select agent',
  'pixel.source.name': 'Pixel Name',
  'pixel.source.info': 'Pixel ID / Key',
  'pixel.id': 'Pixel ID',
  'pixel.detail': 'Pixel Push Details',
  'pixel.push.note': 'There may be many members to push, please wait patiently for the system to complete',
  'pixel.push.detail.title': 'Event Details',
  'pixel.push.detail.time': 'Push Time & Status',

  'pixel.block.name': 'Push Batch Name',
  'pixel.block.userCount': 'User Count',
  'pixel.block.shouldCount': 'Expected Total Push Events',
  'pixel.block.practicalCount': 'Actual Total Push Events',
  'pixel.block.regCount': 'Registration Events: Pushed / Not Pushed',
  'pixel.block.bakCount': 'First Bank Card Binding Events: Pushed / Not Pushed',
  'pixel.block.orderCount': 'Order Events: Pushed / Not Pushed',
  'pixel.block.depositCount': 'Purchase Events: Pushed / Not Pushed',
  'pixel.block.time': 'Push Time',

  'user.title.OneKeyRecycle': 'One-click recycling',

  'sys.rewardGoldenEgg': 'Reward Golden Egg',
  'sys.rewardRedEnvelope': 'Reward Red Envelope',
  'sys.setPrizeDay': 'Please set the prize for day {dayCount}',

  "sign.receive,type1": "Reward cash",
  "sign.receive,type2": "Reward golden egg",
  "sign.receive,type3": "Reward red envelope",
  'device.install.src.title': 'Installation source',
  'device.id.title': 'Device ID',
  'device.serial.title': 'Device',
  'user.title.withdrawalsProhibited': 'Withdrawals prohibited',
  'user.title.sign-inDays': 'Sign-in days',
  'pay.title.payerName': 'Payer Name',
  'user.title.paymentCode': 'Payment Code',
  'user.title.uploadPaymentCode': 'Please upload the payment code',

  'member.select.filterRepeat.account.title': 'Remove duplicate members',
  'member.select.filterRepeat.ip.title': 'Remove duplicate IP data',
  'constants.regSourceTypeJk4_0': 'Official',
  'user.title.pointCreateTime': 'Points issuance time',
  'user.title.pointAmount': 'Variable point amount',
  'user.title.pointAmountAfter': 'Amount after change',
  'user.title.pointAmountType': 'Point type',
  'bonus.pointType.1': 'Sign-in discount points',
  'bonus.pointType.2': 'Points redemption',
  'bonus.pointType.3': 'Real-time deposit bonus points',
  'bonus.pointType.4': 'Task discount points',
  'bonus.pointType.5': 'Deposit bonus points',
  'bonus.pointType.6': 'Manually adjust points',
  'bonus.pointType.7': 'Unknown',
  'bonus.pointType.8': 'Manually adjust points',

  'analyze.quick3.deviceSource': 'Invoice source',
  'analyze.quick3.lotNo': 'Issue number',
  'analyze.quick3.playName': 'How to play | Betting number',
  'analyze.quick3.status': 'Bet order status',
  'analyze.quick3.status0': 'To be drawn',
  'analyze.quick3.status1': 'Not yet drawn',
  'analyze.quick3.status2': 'Lottery has been drawn',
  'analyze.quick3.status3': 'User cancels order',
  'analyze.quick3.status4': 'Systematic order cancellation',
  'analyze.quick3.result': 'Profit and loss',
  'analyze.quick3.playId1': 'Sum',
  'analyze.quick3.playId2': 'two same',
  'analyze.quick3.playId3': 'Together',
  'analyze.quick3.deviceSource1': 'PC',
  'analyze.quick3.deviceSource2': 'H5',
  'analyze.quick3.deviceSource3': 'Android',
  'analyze.quick3.deviceSource4': 'IOS',
  'analyze.quick3.totalBets': 'Total number of bets',
  'analyze.quick3.totalBetAmount': 'Total bet amount',
  'analyze.quick3.unawardedAmount': 'Unawarded amount',
  'analyze.quick3.cancellationAmount': 'Cancellation amount',
  'analyze.quick3.totalUsers': 'Total users',
  'menu.betManagement': 'Bet management',
  'menu.gamePlayRanking': 'Play ranking',
  'menu.playOdds': 'Play odds',
  'menu.gameConfiguration': 'Play configuration',
  'menu.winningNumbers': 'Winning numbers',
  'menu.quick3': 'Fast Three',
  'analyze.quick3.nowOdds': 'Current odds',
  'analyze.quick3.reset': 'Restore last configuration',
  'finance.export.gamePlayRanking': 'Fast Three Play Ranking.xls',
  'analyze.quick3.gameType': 'Game Type',
  'analyze.quick3.maximumAmountSingleBet': 'Maximum Amount of Single Bet',
  'analyze.quick3.userMaximumBet': 'User Maximum Bet in Current Period',
  'analyze.quick3.currentPeriodMaximumBet': 'Gameplay Maximum Bet in Current Period',
  'analyze.quick3.gameplayEnableDisable': 'Gameplay Enable/Disable',
  'analyze.quick3.gameplayAbbreviation': 'Gameplay Abbreviation',
  'analyze.quick3.gameplay': 'Gameplay Introduction',
  'analyze.quick3.bettingExamples': 'Betting Examples',
  'analyze.quick3.sampleCode': 'Sample Code',
  'analyze.quick3.lotteryName': 'Lottery name',
  'analyze.quick3.deadlineIssue': 'Deadline of this issue',
  'analyze.quick3.fullyRandom': 'Fully random',
  'analyze.quick3.profitability': 'Profitability',
  'analyze.quick3.betDetails': 'Bet details',
  'analyze.quick3.bettingNumbers': 'Bet numbers',
  'analyze.quick3.numberBets': 'Number of bets',
  'analyze.quick3.totalBetAmount2': 'Total amount of bets',
  'analyze.quick3.singleBetAmount': 'Single bet amount',
  'analyze.quick3.prizes': 'Prizes to be won',

  'live.title.36': 'Receive red envelopes in the live broadcast room',
  'live.title.42': 'Bonus for completing live broadcast mission',
  'live.title.71': 'Live broadcast room turntable lucky draw cash prize',
  'live.title.80': 'The amount of gift redemption for the anchor, the total income of the anchor{changeMoney}',
  'live.title.107': 'Buy a bet',
  'live.title.142': 'Send [{0}]*{1}',
  'live.title.168': 'Send red envelopes in the live broadcast room',
  'live.title.208': 'Competition prize settlement',
  'live.title.209': 'Competition refund',
  'live.title.210': 'God of Gamblers has risen',
  'live.title.211': 'God of Gamblers has fallen',

  'user.title.connectedState': 'Connected state',
  'user.title.totalCalls': 'Total number of calls',

  'quick3.table.title': 'Room number/room name/host nickname',
  'analyze.card.depositBetInfo': 'Count the first members and the members with valid betting behavior on the day, and then add them together',

  'quick3.quick3Bets': 'Quick3 3 bets',
  'quick3.orderCancellation': 'Quick 3 order cancellation and return',
  'quick3.quick3Payout': 'Quick 3 Payout',

  'bonus.checkin.xls': 'Sign-in bonus record.xls',
  'bonus.integral.xls': 'Points redemption record.xls',
  'job.progress.xls': 'User task progress.xls',
  'job.progress.acceptTime': 'Task acceptance time',
  'job.progress.completeTime': 'Task completion time',
  'job.progress.receiveTime': 'Task receipt time',
  'job.progress.title': 'Title',
  'job.progress.userAccount': 'User ID/user name/nickname',
  'job.progress.status': 'Task status',
  'job.progress.status0': 'Task received',
  'job.progress.status1': 'Task completed',
  'job.progress.status2': 'Task collection is not completed',
  'job.progress.status3': 'Bonus has been collected',
  'job.progress.jobType': 'Task type',
  'job.progress.jobType0': 'Newbie task',
  'job.progress.jobType1': 'Daily task',

  'menu.MerberLoginLock': 'Locked User List',
  'user.title.loginLockTime': 'Login lock time',
  'user.title.notUnlocked': 'Not unlocked',
  'user.title.unlocked': 'Unlocked',
  'user.title.lockedState': 'Locked state',
  'user.title.loginPasswordChange': 'Login password change',
  'user.title.loginPassword': 'Login password',
  'user.title.generatePasswordDirectly': 'Generate password directly',
  'user.title.re-enter': 'Enter again',
  'user.title.pleaseEnterAgain': 'Please enter again',
  'user.title.confirmUnlock': 'Confirm to unlock?',
  'user.title.activatedBetStatus': 'Activated betting status',
  'user.title.activatedDepositStatus': 'Activated deposit status',
  'user.title.selectActivatedBetStatus': 'Select activated betting status',
  'user.title.selectActivatedDepositStatus': 'Select activated deposit status',

  'analyze.title.applicationScenario': 'Application scenario',
  'analyze.title.sendContent': 'Send content',
  'analyze.title.causeOfFailure': 'Failure reason',
  'analyze.title.verificationCodeFilledIn': 'Verification code backfilled',
  'analyze.title.backfillStatus': 'Backfill status',
  'analyze.title.registerToSend': 'Register to send',
  'analyze.title.loginToSend': 'Login to send',
  'menu.smsDeliveryRate': 'SMS delivery rate list',

  'front.onebuy.amount.sub': 'onebuy purchanse',
  'front.onebuy.amount.change': 'onebuy reward change',
  'front.onebuy.amount.return': 'onebuy order return',
  'front.onebuy.amount.rebuy': 'onebuy commodity rebuy',
  'admin.onebuy.excelExport.odrder': 'order data',
  'admin.onebuy.excelExport.commodity': 'commodity data',
  'admin.onebuy.excelExport.plan': 'plan data',
  'admin.onebuy.excelExport.platformStatistic': 'Data summary',
  'admin.onebuy.excelExport.platformDetailStatistic': 'Data details',

  'constants.transferType_18': 'One-buy Purchase Rush Purchase',
  'constants.transferType_19': 'One-buy purchase of goods',
  'constants.transferType_20': 'One-buy Redeem one dollar purchase bonus',
  'constants.transferType_21': 'One-buy Purchase Rush Purchase Return',
  'constants.onebuyType_1': 'One-buy Coupon',
  'user.title.onebuyBalance': 'One-buy Balance',
  'user.title.onebuyBalanceTooltip': 'One-buy Balance = Withdrawable Fund + Deposit Amount',
  'analyze.title.SMSLog': 'SMS log',
  'analyze.title.loginSMSStatistics': 'Login SMS statistics',
  'analyze.title.registrationSMSStatistics': 'Registration SMS statistics',
  'analyze.title.numberApplications': 'Number of applications',
  'analyze.title.numberSuccessfulBackfills': 'Number of successful backfills',
  'analyze.title.backfillSuccessRate': 'Number of successful backfills',
  'analyze.title.backfillFailureCount': 'Number of failed backfills',
  'analyze.title.backfillFailureRate': 'Backfill failure rate',

  'common.bonus.vipRewardType1': 'Upgrade Rewards',
  'common.bonus.vipRewardType2': 'Consecutive Rewards',
  'common.bonus.vipRewardType3': 'Birthday Rewards',
  'common.bonus.vipRewardType4': 'Slot Rescue Funds',
  'common.bonus.vipRewardType5': 'Live Casino Rescue Funds',
  'common.bonus.vipRewardType6': 'Sports Rescue Funds',
  'common.bonus.vipRewardType7': 'Lottery Rescue Funds',
  'common.bonus.vipRewardType8': 'Fishing Rescue Funds',
  'common.bonus.vipRewardType9': 'Card Game Rescue Funds',
  'common.bonus.vipRewardType10': 'H5 Free Chips',
  'common.bonus.vipRewardType11': 'Weekly Salary',
  'common.bonus.vipRewardType12': 'Monthly Salary',
  'common.bonus.vipRewardType13': 'PC Free Chips',
  'common.bonus.vipRewardType14': 'Lucky Spin Rewards',
  'common.bonus.vipRewardType15': 'Point',
  'common.bonus.vipRewardType16': 'APP Free Chips',
  'common.bonus.vipRewardType17': 'PWA Free Chips',
  'common.bonus.vipLevelBonusName': '{vipLevel}{bonusName}',
  'common.bonus.profitLoss': 'Profit and loss reward',
  'common.title.expirationDay': 'Expiration/Day',
  'common.title.flowIssued': 'Flow issued',
  'common.title.sufficientDeposit': 'Sufficient deposit',
  'common.title.grant': 'Grant',
  'common.title.usersSendComments': 'Users send comments',
  'front.vip.level': '{0} Level Benefits',
  'front.vip.up': '{0} Promotion Bonus',
  'front.vip.upMsg1': 'No promotion bonus available to claim.',
  'front.vip.upMsg2': 'The promotion bonus for the current level has already been claimed',
  'front.vip.birthday': '{0} Birthday Bonus',
  'front.vip.birthdayMsg1': 'Currently there is no birthday bonus to claim',
  'front.vip.birthdayMsg2': 'Please enter your date of birth',
  'front.vip.birthdayMsg3': 'Claim failed, the birthday bonus claim period has expired.',
  'front.vip.birthdayMsg4': 'The birthday bonus for this year at the current level has already been claimed.',
  'front.vio.depositMsg1': 'You have already claimed this bonus, please deposit again.',
  'front.vio.depositMsg2': 'Please deposit first, and then claim the bonus.',
  'front.vio.depositMsg3': 'No VIP level deposit bonus available to claim at the moment.',
  'front.vio.depositMsg4': 'No available bonuses to claim.',
  'sys.oneBuyCouponTimes': 'One-buy Coupon',
  'sys.enterOneBuyCouponTimes': 'Please enter the number of one-yuan purchase reward coupons',

  'common.userPoint.noEnough': 'The member does not have enough points',
  'user.title.addPointSuccess': 'Point modification successful. ',
  'user.title.addPointError': 'Point modification operation failed. ',
  'user.title.addPoint': 'Modify member points',
  'user.title.increasePoint': 'Add points',
  'user.title.decreasepoint': 'Deduct points',
  'sys.enterPreferentialPoint': 'Please enter the number of points',
  'sys.PreferentialPoint.msg': 'Number of points',

  'menu.yygCoupon': 'Coupon',
  'push.msg.config.typeOnebuy': 'One-Buy',
  'sys.msgDepositPage': 'Minimum deposit: {minDeposit}',
  'admin.bonus.depositPageBonus': 'Deposit bonus on recharge page,{date}',

  'sys.title.verificationRequestTime': 'Verification request time',
  'sys.title.numberVerificationFailures': 'Number of verification failures',
  'sys.title.timeIncorrectPasswordInput': 'Password input error time',
  'sys.title.numberIncorrectPasswords': 'Number of incorrect passwords',
  'sys.title.loginRequestTime': 'Login request time',
  'sys.title.numberLoginRequests': 'Number of login requests',
  'sys.title.restrictionMethod': 'Restriction method',
  'sys.title.IPBlacklist': 'IP blacklist',
  'sys.title.deviceBlacklist': 'Device blacklist',
  'sys.title.loginRestriction': 'Login restriction',
  'admin.onebuy.type.return': 'Refund',
  'admin.onebuy.name.return': 'One-buy purchase refund',

  'sys.title.blindBoxConfiguration': 'Blind Box Configuration',
  'sys.title.dailyOpeningTimes': 'Daily Blind Box Opening Times',
  'sys.title.dayTime': 'Daily Opening Time',
  'sys.title.dailyBlindBoxDrawLimit': 'Daily Blind Box Draw Limit',
  'sys.title.rebateRatio': 'Rebate Ratio',
  'sys.title.weight': 'Weight',
  'sys.title.orAbove': 'or above',
  'sys.title.depositsAndBet': 'Deposits and bets',
  'sys.title.maximumIssuance': 'Maximum issuance',


  'sys.title.setCashWheel': 'Set Cash Wheel',
  'sys.title.timePeriod': 'Time period',
  'sys.title.activityRewardAmount': 'Activity reward amount',
  'sys.title.directCashWithdrawalNotPossible': 'Direct withdrawal is not possible',
  'sys.title.initialAmountFirstLotteryDraw': 'First lottery initialization amount',
  'sys.title.numberDraws': 'Number of lottery draws',
  'sys.title.falseWithdrawalInformation': 'False withdrawal information',
  'sys.title.realWithdrawalInformation': 'Real withdrawal information',
  'sys.title.uploadAwardImage': 'Upload award image',
  'sys.title.addAwards': 'Add awards',
  'sys.title.conditionSettings': 'Condition settings',
  'sys.title.validNumberInvitations': 'Valid number of invitations',
  'sys.title.giveawayDraw': 'Giveaway draw',
  'sys.title.taskDescription': 'Task description',
  'sys.title.depositBonus': 'Deposit bonus',
  'sys.title.numberDeposits': 'Number of deposits',
  'sys.title.amountCannotLessThan': 'Each amount cannot be less than',
  'sys.title.downloadAPPLoginReward': 'Download APP login reward',
  'sys.title.downloadAPPLogDraw': 'Download APP and log in to giveaway draw',
  'sys.title.withdrawalRestrictions': 'Withdrawal restrictions',
  'sys.title.amountMustDepositRequirement': 'The full withdrawal of the bonus amount must meet the deposit',
  'sys.title.ifNotMetReduce': 'Reduce if not met',
  'sys.title.activityRules': 'Activity rules description',
  'sys.title.lotteryRecords': 'Lottery record',
  'sys.title.firstFewDraws': 'Number of draws',
  'sys.title.lotteryResults': 'Lottery results',
  'sys.title.amountAfterChange': 'Amount after change',
  'sys.title.completed': 'Completed',
  'sys.title.numberAssistsRecorded': 'Number of assists record',
  'sys.title.assistTime': 'Assistance time',
  'sys.title.numberLotteryDraws': 'Number of assists draws',
  'sys.title.withdrawalRecord': 'Withdrawal record',
  'sys.title.withdrawalTime': 'Withdrawal time',
  'sys.title.withdrawalAmount': 'Withdrawal amount',
  'sys.title.withdrawalRatio': 'Withdrawal ratio',
  'sys.title.meetDepositRequirements': 'Whether deposit requirements are met',
  'sys.title.timeSettings': 'Time Settings',
  'sys.title.addFalseWithdrawalInformation': 'Add false withdrawal information',
  'common.bonus.systemGive': 'System Gift',
  'common.bonus.deposit': 'Complete recharge',
  'common.bonus.appLogin': 'APP Login Rewards',
  'common.bonus.invite': 'Invite {count} friends',
  'sys.rolemanagement.rolename': 'Role Name',
  'sys.rolemanagement.rolenote': 'Role Note',
  'sys.rolemanagement.issuper': 'Super User',
  'sys.rolemanagement.rolewarnning': 'Please check at least one menu item',
  'sys.rolemanagement.menus.tree': 'Permission menu',
  'sys.rolemanagement.editTitle': 'Edit Role',
  'userDomain.title.status': 'Status',
  'userDomain.status.enabled': 'Enabled',
  'userDomain.status.disabled': 'Disabled',
  'sys.row.title': 'Row Number',
  'sys.user.name': 'User Account',
  'sys.user.use': 'Person using',
  'sys.user.selectRole': 'Select Role',
  'sys.user.selectRolePlaceholder': 'Please Select Role',
  'sys.user.status': 'Status',
  'sys.user.selectStatusPlaceholder': 'Please Select Status',
  'sys.user.enabled': 'Enabled',
  'sys.user.disabled': 'Disabled',
  'sys.role.delete1': 'To prevent errors, please disable before deleting',
  'sys.role.delete2': 'There are {count} user accounts using this role permission',
  'sys.role.delete3': 'Are you sure you want to delete this role?',
  'game.gameTypeMgmt.column.title.index': 'seq',
  'game.gameTypeMgmt.column.title.gameGroupName': 'game type',
  'game.gameTypeMgmt.column.title.gameDefaultSort': 'game sort',
  'game.gameTypeMgmt.column.title.gameGroupPcImg': 'PC unselect image',
  'game.gameTypeMgmt.column.title.gameGroupH5Img': 'H5 unselect image',
  'game.gameTypeMgmt.column.title.gameGroupAppImg': 'App unselect image',
  'game.gameTypeMgmt.column.title.gameGroupPcImgEnlarge': 'PC select image',
  'game.gameTypeMgmt.column.title.gameGroupH5ImgEnlarge': 'H5 select image',
  'game.gameTypeMgmt.column.title.gameGroupAppImgEnlarge': 'App select image',
  'game.gameTypeMgmt.column.title.gameStatus': 'enable',
  'game.gameTypeMgmt.column.title.operator': 'operator',
  'game.gameTypeMgmt.column.title.operateTime': 'operator time',
  'game.gameTypeMgmt.column.title.operateAction': 'action',
  'game.gamePlatformMgmt.column.title.index': 'index',
  'game.gamePlatformMgmt.column.title.gamePlatformName': 'game platform name',
  'game.gamePlatformMgmt.column.title.gameFullName': 'game full name',
  'game.gamePlatformMgmt.column.title.gameShowName': 'game show name',
  'game.gamePlatformMgmt.column.title.gamePlatformCode': 'game platform code',
  'game.gamePlatformMgmt.column.title.gameType': 'game type',
  'game.gamePlatformMgmt.column.title.percent': 'percent',
  'game.gamePlatformMgmt.column.title.status': 'status',
  'game.gamePlatformMgmt.column.title.desc': 'description',
  'game.gamePlatformMgmt.column.title.gameCount': 'game count',
  'game.gamePlatformMgmt.column.title.action': 'operate',
  'game.gamePlatformMgmt.editconfig': 'game config',
  'game.gameListMgmt.column.title.index': 'index',
  'game.gameListMgmt.column.title.gamePlatformName': 'platform name',
  'game.gameListMgmt.column.title.gameName': 'game name',
  'game.gameListMgmt.column.title.rpt.recommendRate': 'Official RPT',
  'game.gameListMgmt.column.title.rpt.showRate': 'RPT display interval',
  'game.gameListMgmt.column.title.rpt.boostRate': 'boost estimated value',
  'game.gameListMgmt.column.title.winPlayerRange': 'Winning Player Range',
  'game.gameListMgmt.column.title.player30MinRange': '30 Minutes Player Range',
  'game.gameListMgmt.column.title.maxPrizeRange': 'Maximum Prize Range',
  'game.gameListMgmt.placeholder.minPlayerCount': 'Minimum Player Count',
  'game.gameListMgmt.placeholder.maxPlayerCount': 'Maximum Player Count',
  'game.gameListMgmt.placeholder.minAmount': 'Minimum Amount',
  'game.gameListMgmt.placeholder.maxAmount': 'Maximum Amount',
  'game.gameListMgmt.validation.positiveIntegerOnly': 'Please enter a positive integer',
  'game.gameListMgmt.validation.maxValueExceeded': 'Value cannot exceed 2,147,483,647',
  'game.gameListMgmt.validation.maxPrizePairIncomplete': 'Min and max values must be filled in together',
  'game.gameListMgmt.column.title.gameFullName': 'game platform',
  'game.gameListMgmt.column.title.gameCode': 'game code',
  'game.gameListMgmt.column.title.gameType': 'game type',
  'game.gameListMgmt.column.title.currency': 'currency',
  'game.gameListMgmt.column.title.gamePcImg': 'PC image',
  'game.gameListMgmt.column.title.gameH5Img': 'H5 image',
  'game.gameListMgmt.column.title.gameAppImg': 'App image',
  'game.disable': 'are you sure switch to disalbe',
  'game.enable': 'are you sure switch to enable',
  'common.tradeId' : 'Trade ID',
  'common.enterTradeId' : 'Please Enter Trade ID',
  'activity.activityMgmt.column.title.index': 'Promotion Code',
  'activity.activityMgmt.column.name': 'Promotion name',
  'activity.activityMgmt.column.multiType': 'Promotion Category',
  'activity.activityMgmt.column.templateType': 'Promotion template',
  'activity.activityMgmt.column.lang': 'Language',
  'activity.activityMgmt.column.status': 'Promotion Status',
  'activity.activityMgmt.column.showTime': 'Promotion Effective Time',
  'activity.activityMgmt.column.enableTime': 'Promotion Effective Time',
  'activity.activityMgmt.column.sort': 'Sort',
  'activity.activityMgmt.column.action': 'Action',
  'clientInfo.displayIcon': 'Display Icon',
  'clientInfo.contactUs': 'Contact Us',
  'clientInfo.registerNoDeposit': 'Registered No Deposit',
  'clientInfo.firstDepositSubmit': 'First Deposit Submitted',
  'clientInfo.firstDepositSuccess': 'First Deposit Success',

  'sys.resetGoogleAuthPassword': 'Reset Google Verification Code',
  'sys.confirmGoogleAuthPassword': 'Confirm to reset Google Verification Code? ',
  'sys.googleAuth': 'Google Verification Code',
  'sys.googleAuth.val': 'Please enter the Google verification code',

  'game.show.type': 'Display method',
  'game.show.type.input': 'Please select the display method',

  // Website configuration translations
  'webConfig.depositTurnoverMultiplier': 'Deposit Turnover Multiplier',
  'webConfig.saveSuccess': 'Save Successful',
  'webConfig.updateSuccess': 'Update Successful',
  'webConfig.disableSuccess': 'Disable Successful',
  'webConfig.enableSuccess': 'Enable Successful',
  'webConfig.deleteSuccess': 'Delete Successful',

  // Payment withdrawal configuration translations
  'payWithdraw.autoApproval': 'Whether risk control automatically approves withdrawals',
  'payWithdraw.withdrawPassword': 'Whether withdrawal requires withdrawal password authentication',
  'payWithdraw.bankCard': 'Bank Card',
  'payWithdraw.config.title': 'Recharge and Withdrawal Configuration',
  'payWithdraw.save': 'Save',
  'payWithdraw.basicConfig': 'Basic Withdrawal Configuration',
  'payWithdraw.accountBindConfig': 'Withdrawal Account Binding Configuration',
  'payWithdraw.disabled': 'Disabled',
  'payWithdraw.enabled': 'Enabled',
  'payWithdraw.bindableAccountCount': 'Bindable Account Count',
  'payWithdraw.bindableAccountCountInvalid': 'Bindable account count must be greater than or equal to 1',
  'payWithdraw.updateSuccess': 'Update Successful',
  'payWithdraw.formValidationFailed': 'Form validation failed',
  'payWithdraw.vipRange': 'VIP Level',
  'payWithdraw.addRange': 'Add Range',
  'payWithdraw.deleteRange': 'Delete',
  'payWithdraw.vipRangeTips': 'Configure bindable account counts by VIP range (both start and end are inclusive)',
  'payWithdraw.vipRangeOverlap': 'VIP ranges cannot overlap',
  'payWithdraw.vipRangeInvalid': 'VIP range start cannot be greater than end',
  'payWithdraw.vipRangeContinuous': 'New range must start immediately after the previous range',
  'payWithdraw.vipRangeMaxReached': 'Already covered to VIP31, cannot add more ranges',

  // Withdrawal verification configuration internationalization
  'payWithdraw.withdraw_verification_mobile': 'Whether withdrawal requires mobile phone verification',
  'payWithdraw.withdraw_verification_real_name': 'Whether withdrawal requires real name verification',
  'payWithdraw.withdraw_verification_card_valid': 'Whether withdrawal requires bank card expiry date',
  'payWithdraw.withdraw_verification_email': 'Whether withdrawal requires email verification',
  'payWithdraw.withdraw_verification_withdraw_pwd': 'Whether withdrawal requires withdrawal password verification',
  'payWithdraw.withdraw_verification_login_pwd': 'Verify login password when binding withdrawal account',
  'payWithdraw.withdraw_maya_auth': 'Maya withdrawal authorization',

  // Account binding configuration internationalization
  'payWithdraw.bind_USDT': 'USDT',
  'payWithdraw.bind_SPEI': 'SPEI',
  'payWithdraw.bind_bank': 'BankCard',
  'payWithdraw.bind_cashapp': 'CashApp',
  'payWithdraw.bind_chime': 'Chime',
  'payWithdraw.bind_zelle': 'Zelle',
  'payWithdraw.bind_paypal': 'PayPal',
  'payWithdraw.bind_ach': 'ACH',
  'payWithdraw.bind_Grabpay': 'Grabpay',
  'payWithdraw.bind_Gcash': 'Gcash',
  'payWithdraw.bind_Paymaya': 'Paymaya',

  // Notice component internationalization
  'notice.soundSettings': 'Sound Settings',
  'notice.withdrawSoundPrompt': 'Withdrawal Sound Prompt',
  'notice.kycSoundPrompt': 'KYC Sound Prompt',
  'notice.close': 'Close',

  // Member Detail Modal
  'memberDetail.modal.title': 'Member Details - {memberAccount}',

  // Product Category
  'product.category.cash': 'Cash',
  'product.category.props': 'Props',
  'product.category.product': 'Physical Product',
  'product.category.unknown': 'Unknown Type',

  // ==================== Deposit/Withdraw/Promo Leaderboard ====================
  // Menu
  'menu.userRanking': 'User Ranking',
  'menu.depositLeaderboard': 'Deposit Leaderboard',
  'menu.withdrawLeaderboard': 'Withdrawal Leaderboard',
  'menu.promoLeaderboard': 'Promotion Leaderboard',

  // Leaderboard page titles
  'leaderboard.depositTitle': 'Deposit Leaderboard',
  'leaderboard.withdrawTitle': 'Withdrawal Leaderboard',
  'leaderboard.promoTitle': 'Promotion Leaderboard',

  // Table columns
  'leaderboard.rank': 'Rank',
  'leaderboard.userAccount': 'Member Account',
  'leaderboard.nickname': 'Nickname',
  'leaderboard.realName': 'Real Name',
  'leaderboard.mobile': 'Mobile',
  'leaderboard.vipLevel': 'VIP Level',
  'leaderboard.currency': 'Currency',

  // Deposit leaderboard fields
  'leaderboard.depositAmount': 'Total Deposit',
  'leaderboard.depositCount': 'Deposit Count',
  'leaderboard.avgDeposit': 'Avg. Deposit',
  'leaderboard.maxDeposit': 'Max Deposit',
  'leaderboard.lastDepositTime': 'Last Deposit Time',

  // Withdrawal leaderboard fields
  'leaderboard.withdrawAmount': 'Total Withdrawal',
  'leaderboard.withdrawCount': 'Withdrawal Count',
  'leaderboard.avgWithdraw': 'Avg. Withdrawal',
  'leaderboard.maxWithdraw': 'Max Withdrawal',
  'leaderboard.lastWithdrawTime': 'Last Withdrawal Time',

  // Promotion leaderboard fields
  'leaderboard.promoClaimCount': 'Promo Claim Count',
  'leaderboard.promoAmount': 'Promo Amount',
  'leaderboard.promoPoints': 'Promo Points',
  'leaderboard.lastPromoTime': 'Last Promo Time',
  'leaderboard.clickToSort': 'Click to sort by this field',

  // Time period
  'leaderboard.periodLabel': 'Period',
  'leaderboard.today': 'Today',
  'leaderboard.todayRealtime': 'Today Realtime',
  'leaderboard.yesterday': 'Yesterday',
  'leaderboard.lastWeek': 'Last Week',
  'leaderboard.lastMonth': 'Last Month',
  'leaderboard.hourly': 'Today Realtime',
  'leaderboard.periodDaily': 'Yesterday Leaderboard',
  'leaderboard.periodWeekly': 'Last Week Leaderboard',
  'leaderboard.periodMonthly': 'Last Month Leaderboard',
  'leaderboard.periodHourly': 'Today Realtime Leaderboard',

  // Statistics field
  'leaderboard.sortField': 'Statistics Field',
  'leaderboard.selectSortField': 'Select statistics field',

  // Placeholders
  'leaderboard.userAccountPlaceholder': 'Enter member account',
  'leaderboard.nicknamePlaceholder': 'Enter nickname',
  'leaderboard.realNamePlaceholder': 'Enter real name',
  'leaderboard.mobilePlaceholder': 'Enter mobile number',

  // ==================== Win/Loss/Bet Leaderboard ====================
  // Form fields
  'leaderboard.periodType': 'Period Type',
  'leaderboard.periodTypeRequired': 'Please select period type',
  'leaderboard.selectPeriodType': 'Select period type',
  'leaderboard.currencyRequired': 'Please select currency',
  'leaderboard.selectCurrency': 'Select currency',
  'leaderboard.enterUserAccount': 'Enter member account',
  'leaderboard.selectVipLevel': 'Select VIP level',

  // Win/Loss/Bet leaderboard fields
  'leaderboard.netProfit': 'Net Profit',
  'leaderboard.netLoss': 'Net Loss',
  'leaderboard.validBet': 'Valid Bet',
  'leaderboard.profitRate': 'Profit Rate',
  'leaderboard.lossRate': 'Loss Rate',
  'leaderboard.betCount': 'Bet Count',
  'leaderboard.lastBetTime': 'Last Bet Time',

  // Leaderboard export and hints
  'leaderboard.naturalTimeCycleHint': 'Leaderboard calculated by natural time cycle (not rolling time)',
  'leaderboard.exportSubmitSuccess': 'Export task submitted, please check "File Download" later',
  'leaderboard.exportFailed': 'Export failed, please try again later',

  // Hourly leaderboard
  'leaderboard.statsDate': 'Stats Date',
  'leaderboard.statsHour': 'Up to Hour',
  'leaderboard.selectStatsDate': 'Select stats date',
  'leaderboard.selectStatsHour': 'Select up to hour',
  'leaderboard.statsDateRequired': 'Please select stats date',
  'leaderboard.statsHourRequired': 'Please select up to hour',
  'leaderboard.hourlyHint': 'Shows cumulative ranking data from 00:00 to selected hour',
  'leaderboard.hourlyDataUpdatedAt': 'Data updated to {hour} o\'clock',

  // Game Ranking
  'gameRanking.title': 'Game Ranking',
  'gameRanking.gameName': 'Game Name',
  'gameRanking.gameNamePlaceholder': 'Enter game name',
  'gameRanking.gameId': 'Game ID',
  'gameRanking.gameIdPlaceholder': 'Enter game ID',
  'gameRanking.gameVendor': 'Game Vendor',
  'gameRanking.gameVendorPlaceholder': 'Enter game vendor',
  'gameRanking.gameShowName': 'Display Name',
  'gameRanking.rank': 'Rank',
  'gameRanking.betUserCount': 'Bet Users',
  'gameRanking.betCount': 'Bet Count',
  'gameRanking.betAmount': 'Bet Amount',
  'gameRanking.winUserCount': 'Win Count',
  'gameRanking.playerWinAmount': 'Player Win Amount',
  'gameRanking.playerLossAmount': 'Player Loss Amount',
  'gameRanking.platformNetAmount': 'Platform Net',
  'gameRanking.avgBetAmount': 'Avg Bet Amount',
  'gameRanking.avgBetCount': 'Avg Bet Count',
  'gameRanking.avgPlatformNet': 'Avg Platform Net',
  'gameRanking.dataHint': 'Data range: Today Realtime (hourly cumulative)/Yesterday/Last Monday to Sunday/Last month 1st to last day (natural time period)',
};
